/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionRead } from '../models/ActionRead';
import type { ActionWriteSerializerWithRepr } from '../models/ActionWriteSerializerWithRepr';
import type { AddToOrganisationRequest } from '../models/AddToOrganisationRequest';
import type { ApplicationFlowCount } from '../models/ApplicationFlowCount';
import type { AppPromptBulkUpdate } from '../models/AppPromptBulkUpdate';
import type { AssignVirtualNumbers } from '../models/AssignVirtualNumbers';
import type { AsyncTaskResponse } from '../models/AsyncTaskResponse';
import type { AttemptRetry } from '../models/AttemptRetry';
import type { AuditRequests } from '../models/AuditRequests';
import type { BatchAttemptRetry } from '../models/BatchAttemptRetry';
import type { BatchSettings } from '../models/BatchSettings';
import type { BlockCreate } from '../models/BlockCreate';
import type { BlockCreateSerializerWithRepr } from '../models/BlockCreateSerializerWithRepr';
import type { BlockUpdate } from '../models/BlockUpdate';
import type { BlockView } from '../models/BlockView';
import type { BulkAssignVirtualNumberRequest } from '../models/BulkAssignVirtualNumberRequest';
import type { CallCreate } from '../models/CallCreate';
import type { CallMetaDataRequest } from '../models/CallMetaDataRequest';
import type { Calls } from '../models/Calls';
import type { CallWithParametersRequest } from '../models/CallWithParametersRequest';
import type { CamapignPretrigger } from '../models/CamapignPretrigger';
import type { CampaignCreate } from '../models/CampaignCreate';
import type { CampaignHolidays } from '../models/CampaignHolidays';
import type { CampaignList } from '../models/CampaignList';
import type { CampaignSchedule } from '../models/CampaignSchedule';
import type { CampaignUpdate } from '../models/CampaignUpdate';
import type { CampaignWriteSerializerWithRepr } from '../models/CampaignWriteSerializerWithRepr';
import type { ChangeNumberRequest } from '../models/ChangeNumberRequest';
import type { ChatResponse } from '../models/ChatResponse';
import type { ClientReportCreateRequest } from '../models/ClientReportCreateRequest';
import type { ClientReportResponse } from '../models/ClientReportResponse';
import type { ClientReportUpdate } from '../models/ClientReportUpdate';
import type { CommentRead } from '../models/CommentRead';
import type { CommentWriteSerializerWithRepr } from '../models/CommentWriteSerializerWithRepr';
import type { CreateClientSecret } from '../models/CreateClientSecret';
import type { CreateSftpBucket } from '../models/CreateSftpBucket';
import type { DeployRequest } from '../models/DeployRequest';
import type { DeployResponseSerialzier } from '../models/DeployResponseSerialzier';
import type { DownloadCallRequest } from '../models/DownloadCallRequest';
import type { DownloadOrSendReportRequest } from '../models/DownloadOrSendReportRequest';
import type { DuplicateBlockPath } from '../models/DuplicateBlockPath';
import type { DuplicateFlowConfig } from '../models/DuplicateFlowConfig';
import type { DuplicateSubFlow } from '../models/DuplicateSubFlow';
import type { EnableExperiment } from '../models/EnableExperiment';
import type { EndChatRequest } from '../models/EndChatRequest';
import type { EntityRead } from '../models/EntityRead';
import type { EntityWriteSerializerWithRepr } from '../models/EntityWriteSerializerWithRepr';
import type { FetchCallRequest } from '../models/FetchCallRequest';
import type { Flow } from '../models/Flow';
import type { FlowConfigApiSpecs } from '../models/FlowConfigApiSpecs';
import type { FlowConfigCreate } from '../models/FlowConfigCreate';
import type { FlowConfigSerializerWithRepr } from '../models/FlowConfigSerializerWithRepr';
import type { FlowConfigUpdate } from '../models/FlowConfigUpdate';
import type { FlowConfigView } from '../models/FlowConfigView';
import type { FlowSerializerWithRepr } from '../models/FlowSerializerWithRepr';
import type { FlowView } from '../models/FlowView';
import type { FlowYaml } from '../models/FlowYaml';
import type { FolderFileMap } from '../models/FolderFileMap';
import type { GenerateUseCase } from '../models/GenerateUseCase';
import type { GetAssosiatedFlowCountResponse } from '../models/GetAssosiatedFlowCountResponse';
import type { GetAttributesResponse } from '../models/GetAttributesResponse';
import type { ImportFlow } from '../models/ImportFlow';
import type { InitialiseChatRequest } from '../models/InitialiseChatRequest';
import type { InteractionPaginated } from '../models/InteractionPaginated';
import type { InteractionWithMessages } from '../models/InteractionWithMessages';
import type { LeadCreate } from '../models/LeadCreate';
import type { ListCreate } from '../models/ListCreate';
import type { MarkFlowAsBeta } from '../models/MarkFlowAsBeta';
import type { NormalizedCalls } from '../models/NormalizedCalls';
import type { OnboardRequest } from '../models/OnboardRequest';
import type { OntologyLanguageRead } from '../models/OntologyLanguageRead';
import type { OntologyLanguageWriteSerializerWithRepr } from '../models/OntologyLanguageWriteSerializerWithRepr';
import type { OntologyRead } from '../models/OntologyRead';
import type { OntologyWriteSerializerWithRepr } from '../models/OntologyWriteSerializerWithRepr';
import type { OrganisationRead } from '../models/OrganisationRead';
import type { OrganisationUpdate } from '../models/OrganisationUpdate';
import type { OrganisationWriteSerializerWithRepr } from '../models/OrganisationWriteSerializerWithRepr';
import type { PaginatedActionListList } from '../models/PaginatedActionListList';
import type { PaginatedActionWriteSerializerWithReprList } from '../models/PaginatedActionWriteSerializerWithReprList';
import type { PaginatedAuditRequestsList } from '../models/PaginatedAuditRequestsList';
import type { PaginatedBlockCreateSerializerWithReprList } from '../models/PaginatedBlockCreateSerializerWithReprList';
import type { PaginatedBlockViewList } from '../models/PaginatedBlockViewList';
import type { PaginatedCampaignWriteSerializerWithReprList } from '../models/PaginatedCampaignWriteSerializerWithReprList';
import type { PaginatedClientSecretListList } from '../models/PaginatedClientSecretListList';
import type { PaginatedCommentReadList } from '../models/PaginatedCommentReadList';
import type { PaginatedCommentWriteSerializerWithReprList } from '../models/PaginatedCommentWriteSerializerWithReprList';
import type { PaginatedDuplicateResponseList } from '../models/PaginatedDuplicateResponseList';
import type { PaginatedEntityListList } from '../models/PaginatedEntityListList';
import type { PaginatedEntityWriteSerializerWithReprList } from '../models/PaginatedEntityWriteSerializerWithReprList';
import type { PaginatedFlowConfigListList } from '../models/PaginatedFlowConfigListList';
import type { PaginatedFlowConfigSerializerWithReprList } from '../models/PaginatedFlowConfigSerializerWithReprList';
import type { PaginatedFlowSerializerWithReprList } from '../models/PaginatedFlowSerializerWithReprList';
import type { PaginatedFlowViewList } from '../models/PaginatedFlowViewList';
import type { PaginatedNormalizedCallsList } from '../models/PaginatedNormalizedCallsList';
import type { PaginatedOntologyLanguageListList } from '../models/PaginatedOntologyLanguageListList';
import type { PaginatedOntologyLanguageWriteSerializerWithReprList } from '../models/PaginatedOntologyLanguageWriteSerializerWithReprList';
import type { PaginatedOntologyListList } from '../models/PaginatedOntologyListList';
import type { PaginatedOntologyWriteSerializerWithReprList } from '../models/PaginatedOntologyWriteSerializerWithReprList';
import type { PaginatedOrganisationListList } from '../models/PaginatedOrganisationListList';
import type { PaginatedOrganisationWriteSerializerWithReprList } from '../models/PaginatedOrganisationWriteSerializerWithReprList';
import type { PaginatedPathList } from '../models/PaginatedPathList';
import type { PaginatedPathSerializerWithReprList } from '../models/PaginatedPathSerializerWithReprList';
import type { PaginatedPathViewList } from '../models/PaginatedPathViewList';
import type { PaginatedPaymentConnectorsSerializersList } from '../models/PaginatedPaymentConnectorsSerializersList';
import type { PaginatedPromptContentSerializerWithReprList } from '../models/PaginatedPromptContentSerializerWithReprList';
import type { PaginatedPromptContentViewList } from '../models/PaginatedPromptContentViewList';
import type { PaginatedPromptPhrasesListList } from '../models/PaginatedPromptPhrasesListList';
import type { PaginatedPromptPhrasesWriteSerializerWithReprList } from '../models/PaginatedPromptPhrasesWriteSerializerWithReprList';
import type { PaginatedPromptSerializerWithReprList } from '../models/PaginatedPromptSerializerWithReprList';
import type { PaginatedPromptViewList } from '../models/PaginatedPromptViewList';
import type { PaginatedRequestWriteSerializerWithReprList } from '../models/PaginatedRequestWriteSerializerWithReprList';
import type { PaginatedRolesList } from '../models/PaginatedRolesList';
import type { PaginatedSmallTalkListList } from '../models/PaginatedSmallTalkListList';
import type { PaginatedSmallTalkWriteSerializerWithReprList } from '../models/PaginatedSmallTalkWriteSerializerWithReprList';
import type { PaginatedSubFlowSerializerWithReprList } from '../models/PaginatedSubFlowSerializerWithReprList';
import type { PaginatedSubFlowViewList } from '../models/PaginatedSubFlowViewList';
import type { PaginatedTCNOutboundCampaignReadList } from '../models/PaginatedTCNOutboundCampaignReadList';
import type { PaginatedTTSPersonaReadList } from '../models/PaginatedTTSPersonaReadList';
import type { PaginatedTTSPersonaWriteSerializerWithReprList } from '../models/PaginatedTTSPersonaWriteSerializerWithReprList';
import type { PaginatedUtteranceListList } from '../models/PaginatedUtteranceListList';
import type { PaginatedUtterancesContentListList } from '../models/PaginatedUtterancesContentListList';
import type { PaginatedUtterancesContentWriteSerializerWithReprList } from '../models/PaginatedUtterancesContentWriteSerializerWithReprList';
import type { PaginatedUtteranceWriteSerializerWithReprList } from '../models/PaginatedUtteranceWriteSerializerWithReprList';
import type { PatchedActionWriteSerializerWithRepr } from '../models/PatchedActionWriteSerializerWithRepr';
import type { PatchedBlockUpdate } from '../models/PatchedBlockUpdate';
import type { PatchedCallCreate } from '../models/PatchedCallCreate';
import type { PatchedCamapignPretrigger } from '../models/PatchedCamapignPretrigger';
import type { PatchedCampaignHolidays } from '../models/PatchedCampaignHolidays';
import type { PatchedCampaignSchedule } from '../models/PatchedCampaignSchedule';
import type { PatchedCampaignUpdate } from '../models/PatchedCampaignUpdate';
import type { PatchedCampaignWriteSerializerWithRepr } from '../models/PatchedCampaignWriteSerializerWithRepr';
import type { PatchedClientReportUpdate } from '../models/PatchedClientReportUpdate';
import type { PatchedCommentWriteSerializerWithRepr } from '../models/PatchedCommentWriteSerializerWithRepr';
import type { PatchedEntityWriteSerializerWithRepr } from '../models/PatchedEntityWriteSerializerWithRepr';
import type { PatchedFlowConfigUpdate } from '../models/PatchedFlowConfigUpdate';
import type { PatchedFlowSerializerWithRepr } from '../models/PatchedFlowSerializerWithRepr';
import type { PatchedLeadCreate } from '../models/PatchedLeadCreate';
import type { PatchedListCreate } from '../models/PatchedListCreate';
import type { PatchedNormalizedCalls } from '../models/PatchedNormalizedCalls';
import type { PatchedOntologyLanguageWriteSerializerWithRepr } from '../models/PatchedOntologyLanguageWriteSerializerWithRepr';
import type { PatchedOntologyWriteSerializerWithRepr } from '../models/PatchedOntologyWriteSerializerWithRepr';
import type { PatchedOrganisationUpdate } from '../models/PatchedOrganisationUpdate';
import type { PatchedPartialUpdateNumberRequest } from '../models/PatchedPartialUpdateNumberRequest';
import type { PatchedPathSerializerWithRepr } from '../models/PatchedPathSerializerWithRepr';
import type { PatchedPromptContentSerializerWithRepr } from '../models/PatchedPromptContentSerializerWithRepr';
import type { PatchedPromptPhrasesWriteSerializerWithRepr } from '../models/PatchedPromptPhrasesWriteSerializerWithRepr';
import type { PatchedPromptSerializerWithRepr } from '../models/PatchedPromptSerializerWithRepr';
import type { PatchedRequestWriteSerializerWithRepr } from '../models/PatchedRequestWriteSerializerWithRepr';
import type { PatchedRoles } from '../models/PatchedRoles';
import type { PatchedSaveSmsAgentRequest } from '../models/PatchedSaveSmsAgentRequest';
import type { PatchedSmallTalkWriteSerializerWithRepr } from '../models/PatchedSmallTalkWriteSerializerWithRepr';
import type { PatchedSubFlowSerializerWithRepr } from '../models/PatchedSubFlowSerializerWithRepr';
import type { PatchedTTSPersonaWriteSerializerWithRepr } from '../models/PatchedTTSPersonaWriteSerializerWithRepr';
import type { PatchedUtterancesContentWriteSerializerWithRepr } from '../models/PatchedUtterancesContentWriteSerializerWithRepr';
import type { PatchedUtteranceWriteSerializerWithRepr } from '../models/PatchedUtteranceWriteSerializerWithRepr';
import type { Path } from '../models/Path';
import type { PathSerializerWithRepr } from '../models/PathSerializerWithRepr';
import type { PathView } from '../models/PathView';
import type { PhaseBReportSchedulesReadResponse } from '../models/PhaseBReportSchedulesReadResponse';
import type { PhaseBReportSchedulesUpdateRequest } from '../models/PhaseBReportSchedulesUpdateRequest';
import type { PhaseBReportSchedulesWriteRequest } from '../models/PhaseBReportSchedulesWriteRequest';
import type { PhaseBReportSchedulesWriteResponse } from '../models/PhaseBReportSchedulesWriteResponse';
import type { PromptBulkUpdate } from '../models/PromptBulkUpdate';
import type { PromptContentSerializerWithRepr } from '../models/PromptContentSerializerWithRepr';
import type { PromptContentView } from '../models/PromptContentView';
import type { PromptCreateOrUpdate } from '../models/PromptCreateOrUpdate';
import type { PromptPhrasesRead } from '../models/PromptPhrasesRead';
import type { PromptPhrasesWriteSerializerWithRepr } from '../models/PromptPhrasesWriteSerializerWithRepr';
import type { PromptSerializerWithRepr } from '../models/PromptSerializerWithRepr';
import type { PromptView } from '../models/PromptView';
import type { QueueEmailMessage } from '../models/QueueEmailMessage';
import type { RequestWriteSerializerWithRepr } from '../models/RequestWriteSerializerWithRepr';
import type { RespondToChatRequest } from '../models/RespondToChatRequest';
import type { RevokeSftpAccess } from '../models/RevokeSftpAccess';
import type { Roles } from '../models/Roles';
import type { SearchPromptResponse } from '../models/SearchPromptResponse';
import type { SmallTalkRead } from '../models/SmallTalkRead';
import type { SmallTalkWriteSerializerWithRepr } from '../models/SmallTalkWriteSerializerWithRepr';
import type { SmsFlowCreateRequest } from '../models/SmsFlowCreateRequest';
import type { SmsFlowView } from '../models/SmsFlowView';
import type { SmsRetrieve } from '../models/SmsRetrieve';
import type { SubFlowSerializerWithRepr } from '../models/SubFlowSerializerWithRepr';
import type { SubFlowView } from '../models/SubFlowView';
import type { TCNOutboundCampaignRead } from '../models/TCNOutboundCampaignRead';
import type { TriggerCallRequest } from '../models/TriggerCallRequest';
import type { TTSPersonaRead } from '../models/TTSPersonaRead';
import type { TTSPersonaWrite } from '../models/TTSPersonaWrite';
import type { TTSPersonaWriteSerializerWithRepr } from '../models/TTSPersonaWriteSerializerWithRepr';
import type { UnarchiveFlowRequest } from '../models/UnarchiveFlowRequest';
import type { UtteranceRead } from '../models/UtteranceRead';
import type { UtterancesContentRead } from '../models/UtterancesContentRead';
import type { UtterancesContentWriteSerializerWithRepr } from '../models/UtterancesContentWriteSerializerWithRepr';
import type { UtteranceWriteSerializerWithRepr } from '../models/UtteranceWriteSerializerWithRepr';
import type { VirtualNumberListResponse } from '../models/VirtualNumberListResponse';
import type { VirtualNumberRequest } from '../models/VirtualNumberRequest';
import type { VirtualNumbersView } from '../models/VirtualNumbersView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrganisationsService {
    /**
     * @returns PaginatedOrganisationListList
     * @throws ApiError
     */
    public static organisationsList({
        agencyDetail,
        campaignUuid,
        clientBillingId,
        createdBy,
        dashboards,
        dataKey,
        demoConfig,
        description,
        displayName,
        enableIpWhitelisting,
        excludeFields,
        fields,
        ftpBucket,
        industrySegmentType,
        limit,
        metadata,
        name,
        offset,
        ordering,
        paymentPortalDetail,
        readDepth,
        search,
        status,
        uuid,
        whitelistedIpAddress,
    }: {
        agencyDetail?: Array<string>,
        campaignUuid?: Array<string>,
        clientBillingId?: Array<string>,
        createdBy?: Array<string>,
        dashboards?: Array<string>,
        dataKey?: Array<string>,
        demoConfig?: Array<string>,
        description?: Array<string>,
        displayName?: Array<string>,
        enableIpWhitelisting?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        ftpBucket?: Array<string>,
        industrySegmentType?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        metadata?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        paymentPortalDetail?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        uuid?: Array<string>,
        whitelistedIpAddress?: Array<string>,
    }): CancelablePromise<PaginatedOrganisationListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/',
            query: {
                'agency_detail': agencyDetail,
                'campaign_uuid': campaignUuid,
                'client_billing_id': clientBillingId,
                'created_by': createdBy,
                'dashboards': dashboards,
                'data_key': dataKey,
                'demo_config': demoConfig,
                'description': description,
                'display_name': displayName,
                'enable_ip_whitelisting': enableIpWhitelisting,
                'exclude-fields': excludeFields,
                'fields': fields,
                'ftp_bucket': ftpBucket,
                'industry_segment_type': industrySegmentType,
                'limit': limit,
                'metadata': metadata,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'payment_portal_detail': paymentPortalDetail,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'uuid': uuid,
                'whitelisted_ip_address': whitelistedIpAddress,
            },
        });
    }
    /**
     * @returns OrganisationWriteSerializerWithRepr
     * @throws ApiError
     */
    public static organisationsCreate({
        requestBody,
    }: {
        requestBody: OrganisationWriteSerializerWithRepr,
    }): CancelablePromise<OrganisationWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedOrganisationWriteSerializerWithReprList
     * @throws ApiError
     */
    public static organisationBulkUpdate({
        requestBody,
        agencyDetail,
        campaignUuid,
        clientBillingId,
        createdBy,
        dashboards,
        dataKey,
        demoConfig,
        description,
        displayName,
        enableIpWhitelisting,
        excludeFields,
        fields,
        ftpBucket,
        industrySegmentType,
        limit,
        metadata,
        name,
        offset,
        ordering,
        paymentPortalDetail,
        readDepth,
        search,
        status,
        uuid,
        whitelistedIpAddress,
    }: {
        requestBody: Array<OrganisationWriteSerializerWithRepr>,
        agencyDetail?: Array<string>,
        campaignUuid?: Array<string>,
        clientBillingId?: Array<string>,
        createdBy?: Array<string>,
        dashboards?: Array<string>,
        dataKey?: Array<string>,
        demoConfig?: Array<string>,
        description?: Array<string>,
        displayName?: Array<string>,
        enableIpWhitelisting?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        ftpBucket?: Array<string>,
        industrySegmentType?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        metadata?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        paymentPortalDetail?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        uuid?: Array<string>,
        whitelistedIpAddress?: Array<string>,
    }): CancelablePromise<PaginatedOrganisationWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/organisations/',
            query: {
                'agency_detail': agencyDetail,
                'campaign_uuid': campaignUuid,
                'client_billing_id': clientBillingId,
                'created_by': createdBy,
                'dashboards': dashboards,
                'data_key': dataKey,
                'demo_config': demoConfig,
                'description': description,
                'display_name': displayName,
                'enable_ip_whitelisting': enableIpWhitelisting,
                'exclude-fields': excludeFields,
                'fields': fields,
                'ftp_bucket': ftpBucket,
                'industry_segment_type': industrySegmentType,
                'limit': limit,
                'metadata': metadata,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'payment_portal_detail': paymentPortalDetail,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'uuid': uuid,
                'whitelisted_ip_address': whitelistedIpAddress,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedOrganisationWriteSerializerWithReprList
     * @throws ApiError
     */
    public static organisationBulkPartialUpdate({
        requestBody,
        agencyDetail,
        campaignUuid,
        clientBillingId,
        createdBy,
        dashboards,
        dataKey,
        demoConfig,
        description,
        displayName,
        enableIpWhitelisting,
        excludeFields,
        fields,
        ftpBucket,
        industrySegmentType,
        limit,
        metadata,
        name,
        offset,
        ordering,
        paymentPortalDetail,
        readDepth,
        search,
        status,
        uuid,
        whitelistedIpAddress,
    }: {
        requestBody: Array<OrganisationWriteSerializerWithRepr>,
        agencyDetail?: Array<string>,
        campaignUuid?: Array<string>,
        clientBillingId?: Array<string>,
        createdBy?: Array<string>,
        dashboards?: Array<string>,
        dataKey?: Array<string>,
        demoConfig?: Array<string>,
        description?: Array<string>,
        displayName?: Array<string>,
        enableIpWhitelisting?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        ftpBucket?: Array<string>,
        industrySegmentType?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        metadata?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        paymentPortalDetail?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        uuid?: Array<string>,
        whitelistedIpAddress?: Array<string>,
    }): CancelablePromise<PaginatedOrganisationWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/organisations/',
            query: {
                'agency_detail': agencyDetail,
                'campaign_uuid': campaignUuid,
                'client_billing_id': clientBillingId,
                'created_by': createdBy,
                'dashboards': dashboards,
                'data_key': dataKey,
                'demo_config': demoConfig,
                'description': description,
                'display_name': displayName,
                'enable_ip_whitelisting': enableIpWhitelisting,
                'exclude-fields': excludeFields,
                'fields': fields,
                'ftp_bucket': ftpBucket,
                'industry_segment_type': industrySegmentType,
                'limit': limit,
                'metadata': metadata,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'payment_portal_detail': paymentPortalDetail,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'uuid': uuid,
                'whitelisted_ip_address': whitelistedIpAddress,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static organisationsDestroy(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/organisations/',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsAccessAddToOrganisationCreate({
        organisationOrganisationUuid,
        requestBody,
    }: {
        organisationOrganisationUuid: string,
        requestBody: AddToOrganisationRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_organisation_uuid}/access/add_to_organisation/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsAccessCreateSftpCreate({
        organisationOrganisationUuid,
        requestBody,
    }: {
        organisationOrganisationUuid: string,
        requestBody: CreateSftpBucket,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_organisation_uuid}/access/create_sftp/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedClientSecretListList
     * @throws ApiError
     */
    public static organisationsAccessGetClientSecretsList({
        organisationOrganisationUuid,
        limit,
        start,
    }: {
        organisationOrganisationUuid: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        start?: number,
    }): CancelablePromise<PaginatedClientSecretListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_organisation_uuid}/access/get_client_secrets/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
            query: {
                'limit': limit,
                'start': start,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsAccessOnboardCreate({
        organisationOrganisationUuid,
        requestBody,
    }: {
        organisationOrganisationUuid: string,
        requestBody: OnboardRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_organisation_uuid}/access/onboard/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsAccessRemoveSftpAccessCreate({
        organisationOrganisationUuid,
        requestBody,
    }: {
        organisationOrganisationUuid: string,
        requestBody: RevokeSftpAccess,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_organisation_uuid}/access/remove_sftp_access/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static organisationsAccessRemoveUserDestroy({
        id,
        organisationOrganisationUuid,
        iamVersion = 'v2',
    }: {
        id: string,
        organisationOrganisationUuid: string,
        iamVersion?: 'v1' | 'v2',
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/organisations/{organisation_organisation_uuid}/access/remove_user/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
            query: {
                'iam_version': iamVersion,
                'id': id,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsAccessScopesRetrieve({
        organisationOrganisationUuid,
    }: {
        organisationOrganisationUuid: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_organisation_uuid}/access/scopes/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsAccessSftpExistRetrieve({
        organisationOrganisationUuid,
    }: {
        organisationOrganisationUuid: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_organisation_uuid}/access/sftp_exist/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsAccessUpdateClientSecretUpdate({
        organisationOrganisationUuid,
        requestBody,
    }: {
        organisationOrganisationUuid: string,
        requestBody: CreateClientSecret,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/organisations/{organisation_organisation_uuid}/access/update_client_secret/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsAccessUserPermissionsRetrieve({
        organisationOrganisationUuid,
        iamVersion = 'v2',
        userId,
    }: {
        organisationOrganisationUuid: string,
        iamVersion?: 'v1' | 'v2',
        userId?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_organisation_uuid}/access/user_permissions/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
            query: {
                'iam_version': iamVersion,
                'user_id': userId,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsAccessUsersRetrieve({
        organisationOrganisationUuid,
    }: {
        organisationOrganisationUuid: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_organisation_uuid}/access/users/',
            path: {
                'organisation_organisation_uuid': organisationOrganisationUuid,
            },
        });
    }
    /**
     * @returns OrganisationRead
     * @throws ApiError
     */
    public static organisationsRetrieve({
        organisationUuid,
        agencyDetail,
        campaignUuid,
        clientBillingId,
        createdBy,
        dashboards,
        dataKey,
        demoConfig,
        description,
        displayName,
        enableIpWhitelisting,
        excludeFields,
        fields,
        ftpBucket,
        industrySegmentType,
        metadata,
        name,
        paymentPortalDetail,
        readDepth,
        status,
        uuid,
        whitelistedIpAddress,
    }: {
        organisationUuid: string,
        agencyDetail?: Array<string>,
        campaignUuid?: Array<string>,
        clientBillingId?: Array<string>,
        createdBy?: Array<string>,
        dashboards?: Array<string>,
        dataKey?: Array<string>,
        demoConfig?: Array<string>,
        description?: Array<string>,
        displayName?: Array<string>,
        enableIpWhitelisting?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        ftpBucket?: Array<string>,
        industrySegmentType?: Array<string>,
        metadata?: Array<string>,
        name?: Array<string>,
        paymentPortalDetail?: Array<string>,
        readDepth?: number,
        status?: Array<string>,
        uuid?: Array<string>,
        whitelistedIpAddress?: Array<string>,
    }): CancelablePromise<OrganisationRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'agency_detail': agencyDetail,
                'campaign_uuid': campaignUuid,
                'client_billing_id': clientBillingId,
                'created_by': createdBy,
                'dashboards': dashboards,
                'data_key': dataKey,
                'demo_config': demoConfig,
                'description': description,
                'display_name': displayName,
                'enable_ip_whitelisting': enableIpWhitelisting,
                'exclude-fields': excludeFields,
                'fields': fields,
                'ftp_bucket': ftpBucket,
                'industry_segment_type': industrySegmentType,
                'metadata': metadata,
                'name': name,
                'payment_portal_detail': paymentPortalDetail,
                'read_depth': readDepth,
                'status': status,
                'uuid': uuid,
                'whitelisted_ip_address': whitelistedIpAddress,
            },
        });
    }
    /**
     * @returns OrganisationUpdate
     * @throws ApiError
     */
    public static organisationsUpdate({
        organisationUuid,
        requestBody,
    }: {
        organisationUuid: string,
        requestBody: OrganisationUpdate,
    }): CancelablePromise<OrganisationUpdate> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/organisations/{organisation_uuid}/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OrganisationUpdate
     * @throws ApiError
     */
    public static organisationsPartialUpdate({
        organisationUuid,
        requestBody,
    }: {
        organisationUuid: string,
        requestBody?: PatchedOrganisationUpdate,
    }): CancelablePromise<OrganisationUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/organisations/{organisation_uuid}/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static organisationsDestroy2({
        organisationUuid,
    }: {
        organisationUuid: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/organisations/{organisation_uuid}/',
            path: {
                'organisation_uuid': organisationUuid,
            },
        });
    }
    /**
     * @returns OrganisationRead
     * @throws ApiError
     */
    public static organisationsArchiveUpdate({
        organisationUuid,
    }: {
        organisationUuid: string,
    }): CancelablePromise<OrganisationRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/organisations/{organisation_uuid}/archive/',
            path: {
                'organisation_uuid': organisationUuid,
            },
        });
    }
    /**
     * @returns PaginatedAuditRequestsList
     * @throws ApiError
     */
    public static organisationsAuditLogsList({
        organisationUuid,
        eventName,
        excludeFields,
        fields,
        ip,
        ipIn,
        language,
        languageIcontains,
        limit,
        methodIn,
        offset,
        ordering,
        path,
        readDepth,
        referer,
        responseIn,
        search,
        timeDateGte,
        timeDateLte,
        timeGte,
        timeLte,
        timeTimeGte,
        timeTimeLte,
        userAgentIcontains,
        userId,
        userIdEmail,
        userIdEmailIn,
        userIdIn,
    }: {
        organisationUuid: string,
        eventName?: string,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        ip?: string,
        ipIn?: Array<any>,
        language?: string,
        languageIcontains?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        methodIn?: Array<any>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        path?: string,
        readDepth?: number,
        referer?: string,
        responseIn?: Array<any>,
        /**
         * A search term.
         */
        search?: string,
        timeDateGte?: Array<any>,
        timeDateLte?: Array<any>,
        timeGte?: string,
        timeLte?: string,
        timeTimeGte?: Array<any>,
        timeTimeLte?: Array<any>,
        userAgentIcontains?: string,
        userId?: string,
        userIdEmail?: string,
        userIdEmailIn?: Array<any>,
        userIdIn?: Array<any>,
    }): CancelablePromise<PaginatedAuditRequestsList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/audit_logs/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'event_name': eventName,
                'exclude-fields': excludeFields,
                'fields': fields,
                'ip': ip,
                'ip__in': ipIn,
                'language': language,
                'language__icontains': languageIcontains,
                'limit': limit,
                'method__in': methodIn,
                'offset': offset,
                'ordering': ordering,
                'path': path,
                'read_depth': readDepth,
                'referer': referer,
                'response__in': responseIn,
                'search': search,
                'time__date__gte': timeDateGte,
                'time__date__lte': timeDateLte,
                'time__gte': timeGte,
                'time__lte': timeLte,
                'time__time__gte': timeTimeGte,
                'time__time__lte': timeTimeLte,
                'user_agent__icontains': userAgentIcontains,
                'user_id': userId,
                'user_id__email': userIdEmail,
                'user_id__email__in': userIdEmailIn,
                'user_id__in': userIdIn,
            },
        });
    }
    /**
     * @returns RequestWriteSerializerWithRepr
     * @throws ApiError
     */
    public static organisationsAuditLogsCreate({
        organisationUuid,
        requestBody,
    }: {
        organisationUuid: string,
        requestBody?: RequestWriteSerializerWithRepr,
    }): CancelablePromise<RequestWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_uuid}/audit_logs/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedRequestWriteSerializerWithReprList
     * @throws ApiError
     */
    public static requestBulkUpdate({
        organisationUuid,
        requestBody,
        excludeFields,
        fields,
        limit,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        organisationUuid: string,
        requestBody: Array<RequestWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedRequestWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/organisations/{organisation_uuid}/audit_logs/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedRequestWriteSerializerWithReprList
     * @throws ApiError
     */
    public static requestBulkPartialUpdate({
        organisationUuid,
        requestBody,
        excludeFields,
        fields,
        limit,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        organisationUuid: string,
        requestBody: Array<RequestWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedRequestWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/organisations/{organisation_uuid}/audit_logs/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static requestBulkDestroy({
        organisationUuid,
        id,
    }: {
        organisationUuid: string,
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/organisations/{organisation_uuid}/audit_logs/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns AuditRequests
     * @throws ApiError
     */
    public static organisationsAuditLogsRetrieve({
        id,
        organisationUuid,
        excludeFields,
        fields,
        readDepth,
    }: {
        /**
         * A unique integer value identifying this request.
         */
        id: number,
        organisationUuid: string,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        readDepth?: number,
    }): CancelablePromise<AuditRequests> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/audit_logs/{id}/',
            path: {
                'id': id,
                'organisation_uuid': organisationUuid,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'read_depth': readDepth,
            },
        });
    }
    /**
     * @returns RequestWriteSerializerWithRepr
     * @throws ApiError
     */
    public static organisationsAuditLogsUpdate({
        id,
        organisationUuid,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this request.
         */
        id: number,
        organisationUuid: string,
        requestBody?: RequestWriteSerializerWithRepr,
    }): CancelablePromise<RequestWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/organisations/{organisation_uuid}/audit_logs/{id}/',
            path: {
                'id': id,
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns RequestWriteSerializerWithRepr
     * @throws ApiError
     */
    public static organisationsAuditLogsPartialUpdate({
        id,
        organisationUuid,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this request.
         */
        id: number,
        organisationUuid: string,
        requestBody?: PatchedRequestWriteSerializerWithRepr,
    }): CancelablePromise<RequestWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/organisations/{organisation_uuid}/audit_logs/{id}/',
            path: {
                'id': id,
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static organisationsAuditLogsDestroy({
        id,
        organisationUuid,
    }: {
        /**
         * A unique integer value identifying this request.
         */
        id: number,
        organisationUuid: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/organisations/{organisation_uuid}/audit_logs/{id}/',
            path: {
                'id': id,
                'organisation_uuid': organisationUuid,
            },
        });
    }
    /**
     * Get Available Reports
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsDashIntelAvailableReportsRetrieve({
        organisationUuid,
        type,
    }: {
        organisationUuid: string,
        /**
         * The type of export you want one of ['report', 'metrics']
         */
        type: 'metrics' | 'report',
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/dash_intel/available_reports/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'type': type,
            },
        });
    }
    /**
     * Download or Email Report
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsDashIntelDownloadOrEmailReportCreate({
        organisationUuid,
        requestBody,
    }: {
        organisationUuid: string,
        requestBody: DownloadOrSendReportRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_uuid}/dash_intel/download_or_email_report/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Client Summary Report
     * @returns any No response body
     * @throws ApiError
     */
    public static organisationsDashIntelSummaryReportRetrieve({
        endDate,
        organisationUuid,
        startDate,
    }: {
        endDate: string,
        organisationUuid: string,
        startDate: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/dash_intel/summary_report/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'end_date': endDate,
                'start_date': startDate,
            },
        });
    }
    /**
     * @returns PaginatedFlowViewList
     * @throws ApiError
     */
    public static organisationsFlowsList({
        organisationUuid,
        applicationType,
        betaVersion,
        campaignUuid,
        channelConfig,
        complianceType,
        createdAt,
        createdBy,
        dashboardConfig,
        debtCollectionsUsecase,
        deletedBy,
        demoConfig,
        demoLeads,
        deployedVersion,
        documentation,
        excludeFields,
        experimentEnabled,
        experimentPlatformConfig,
        experimentVersion,
        experimentVersions,
        fields,
        forDemo,
        industrySegmentType,
        isLlm,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        misReportsJson,
        name,
        offset,
        ordering,
        organisation,
        organisationName,
        organisationUuidIn,
        pdfGenerationTemplate,
        readDepth,
        search,
        status,
        subscriptionId,
        tags,
        tcnAllowedCampaignCollectorTypes,
        tcnScheduleTemplateId,
        templateFlow,
        templateType,
        thumbnail,
        type,
        useBeta,
        useCase,
        uuid,
    }: {
        organisationUuid: string,
        applicationType?: Array<string>,
        betaVersion?: Array<string>,
        campaignUuid?: Array<string>,
        channelConfig?: Array<string>,
        complianceType?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        dashboardConfig?: Array<string>,
        debtCollectionsUsecase?: Array<string>,
        deletedBy?: Array<string>,
        demoConfig?: Array<string>,
        demoLeads?: Array<string>,
        deployedVersion?: Array<string>,
        documentation?: Array<string>,
        excludeFields?: Array<string>,
        experimentEnabled?: Array<string>,
        experimentPlatformConfig?: Array<string>,
        experimentVersion?: Array<string>,
        experimentVersions?: Array<string>,
        fields?: Array<string>,
        forDemo?: Array<string>,
        industrySegmentType?: Array<string>,
        isLlm?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        misReportsJson?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        organisation?: Array<string>,
        organisationName?: Array<string>,
        organisationUuidIn?: Array<string>,
        pdfGenerationTemplate?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        subscriptionId?: Array<string>,
        tags?: Array<string>,
        tcnAllowedCampaignCollectorTypes?: Array<string>,
        tcnScheduleTemplateId?: Array<string>,
        templateFlow?: Array<string>,
        templateType?: Array<string>,
        thumbnail?: Array<string>,
        type?: Array<string>,
        useBeta?: Array<string>,
        useCase?: Array<string>,
        uuid?: Array<string>,
    }): CancelablePromise<PaginatedFlowViewList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/flows/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'application_type': applicationType,
                'beta_version': betaVersion,
                'campaign_uuid': campaignUuid,
                'channel_config': channelConfig,
                'compliance_type': complianceType,
                'created_at': createdAt,
                'created_by': createdBy,
                'dashboard_config': dashboardConfig,
                'debt_collections_usecase': debtCollectionsUsecase,
                'deleted_by': deletedBy,
                'demo_config': demoConfig,
                'demo_leads': demoLeads,
                'deployed_version': deployedVersion,
                'documentation': documentation,
                'exclude-fields': excludeFields,
                'experiment_enabled': experimentEnabled,
                'experiment_platform_config': experimentPlatformConfig,
                'experiment_version': experimentVersion,
                'experiment_versions': experimentVersions,
                'fields': fields,
                'for_demo': forDemo,
                'industry_segment_type': industrySegmentType,
                'is_llm': isLlm,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'mis_reports_json': misReportsJson,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'organisation': organisation,
                'organisation__name': organisationName,
                'organisation__uuid__in': organisationUuidIn,
                'pdf_generation_template': pdfGenerationTemplate,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'subscription_id': subscriptionId,
                'tags': tags,
                'tcn_allowed_campaign_collector_types': tcnAllowedCampaignCollectorTypes,
                'tcn_schedule_template_id': tcnScheduleTemplateId,
                'template_flow': templateFlow,
                'template_type': templateType,
                'thumbnail': thumbnail,
                'type': type,
                'use_beta': useBeta,
                'use_case': useCase,
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns FlowSerializerWithRepr
     * @throws ApiError
     */
    public static organisationsFlowsCreate({
        organisationUuid,
        requestBody,
    }: {
        organisationUuid: string,
        requestBody: FlowSerializerWithRepr,
    }): CancelablePromise<FlowSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_uuid}/flows/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedFlowSerializerWithReprList
     * @throws ApiError
     */
    public static flowBulkUpdate2({
        organisationUuid,
        requestBody,
        applicationType,
        betaVersion,
        campaignUuid,
        channelConfig,
        complianceType,
        createdAt,
        createdBy,
        dashboardConfig,
        debtCollectionsUsecase,
        deletedBy,
        demoConfig,
        demoLeads,
        deployedVersion,
        documentation,
        excludeFields,
        experimentEnabled,
        experimentPlatformConfig,
        experimentVersion,
        experimentVersions,
        fields,
        forDemo,
        industrySegmentType,
        isLlm,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        misReportsJson,
        name,
        offset,
        ordering,
        organisation,
        organisationName,
        organisationUuidIn,
        pdfGenerationTemplate,
        readDepth,
        search,
        status,
        subscriptionId,
        tags,
        tcnAllowedCampaignCollectorTypes,
        tcnScheduleTemplateId,
        templateFlow,
        templateType,
        thumbnail,
        type,
        useBeta,
        useCase,
        uuid,
    }: {
        organisationUuid: string,
        requestBody: Array<FlowSerializerWithRepr>,
        applicationType?: Array<string>,
        betaVersion?: Array<string>,
        campaignUuid?: Array<string>,
        channelConfig?: Array<string>,
        complianceType?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        dashboardConfig?: Array<string>,
        debtCollectionsUsecase?: Array<string>,
        deletedBy?: Array<string>,
        demoConfig?: Array<string>,
        demoLeads?: Array<string>,
        deployedVersion?: Array<string>,
        documentation?: Array<string>,
        excludeFields?: Array<string>,
        experimentEnabled?: Array<string>,
        experimentPlatformConfig?: Array<string>,
        experimentVersion?: Array<string>,
        experimentVersions?: Array<string>,
        fields?: Array<string>,
        forDemo?: Array<string>,
        industrySegmentType?: Array<string>,
        isLlm?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        misReportsJson?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        organisation?: Array<string>,
        organisationName?: Array<string>,
        organisationUuidIn?: Array<string>,
        pdfGenerationTemplate?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        subscriptionId?: Array<string>,
        tags?: Array<string>,
        tcnAllowedCampaignCollectorTypes?: Array<string>,
        tcnScheduleTemplateId?: Array<string>,
        templateFlow?: Array<string>,
        templateType?: Array<string>,
        thumbnail?: Array<string>,
        type?: Array<string>,
        useBeta?: Array<string>,
        useCase?: Array<string>,
        uuid?: Array<string>,
    }): CancelablePromise<PaginatedFlowSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/organisations/{organisation_uuid}/flows/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'application_type': applicationType,
                'beta_version': betaVersion,
                'campaign_uuid': campaignUuid,
                'channel_config': channelConfig,
                'compliance_type': complianceType,
                'created_at': createdAt,
                'created_by': createdBy,
                'dashboard_config': dashboardConfig,
                'debt_collections_usecase': debtCollectionsUsecase,
                'deleted_by': deletedBy,
                'demo_config': demoConfig,
                'demo_leads': demoLeads,
                'deployed_version': deployedVersion,
                'documentation': documentation,
                'exclude-fields': excludeFields,
                'experiment_enabled': experimentEnabled,
                'experiment_platform_config': experimentPlatformConfig,
                'experiment_version': experimentVersion,
                'experiment_versions': experimentVersions,
                'fields': fields,
                'for_demo': forDemo,
                'industry_segment_type': industrySegmentType,
                'is_llm': isLlm,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'mis_reports_json': misReportsJson,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'organisation': organisation,
                'organisation__name': organisationName,
                'organisation__uuid__in': organisationUuidIn,
                'pdf_generation_template': pdfGenerationTemplate,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'subscription_id': subscriptionId,
                'tags': tags,
                'tcn_allowed_campaign_collector_types': tcnAllowedCampaignCollectorTypes,
                'tcn_schedule_template_id': tcnScheduleTemplateId,
                'template_flow': templateFlow,
                'template_type': templateType,
                'thumbnail': thumbnail,
                'type': type,
                'use_beta': useBeta,
                'use_case': useCase,
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedFlowSerializerWithReprList
     * @throws ApiError
     */
    public static flowBulkPartialUpdate2({
        organisationUuid,
        requestBody,
        applicationType,
        betaVersion,
        campaignUuid,
        channelConfig,
        complianceType,
        createdAt,
        createdBy,
        dashboardConfig,
        debtCollectionsUsecase,
        deletedBy,
        demoConfig,
        demoLeads,
        deployedVersion,
        documentation,
        excludeFields,
        experimentEnabled,
        experimentPlatformConfig,
        experimentVersion,
        experimentVersions,
        fields,
        forDemo,
        industrySegmentType,
        isLlm,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        misReportsJson,
        name,
        offset,
        ordering,
        organisation,
        organisationName,
        organisationUuidIn,
        pdfGenerationTemplate,
        readDepth,
        search,
        status,
        subscriptionId,
        tags,
        tcnAllowedCampaignCollectorTypes,
        tcnScheduleTemplateId,
        templateFlow,
        templateType,
        thumbnail,
        type,
        useBeta,
        useCase,
        uuid,
    }: {
        organisationUuid: string,
        requestBody: Array<FlowSerializerWithRepr>,
        applicationType?: Array<string>,
        betaVersion?: Array<string>,
        campaignUuid?: Array<string>,
        channelConfig?: Array<string>,
        complianceType?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        dashboardConfig?: Array<string>,
        debtCollectionsUsecase?: Array<string>,
        deletedBy?: Array<string>,
        demoConfig?: Array<string>,
        demoLeads?: Array<string>,
        deployedVersion?: Array<string>,
        documentation?: Array<string>,
        excludeFields?: Array<string>,
        experimentEnabled?: Array<string>,
        experimentPlatformConfig?: Array<string>,
        experimentVersion?: Array<string>,
        experimentVersions?: Array<string>,
        fields?: Array<string>,
        forDemo?: Array<string>,
        industrySegmentType?: Array<string>,
        isLlm?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        misReportsJson?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        organisation?: Array<string>,
        organisationName?: Array<string>,
        organisationUuidIn?: Array<string>,
        pdfGenerationTemplate?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        subscriptionId?: Array<string>,
        tags?: Array<string>,
        tcnAllowedCampaignCollectorTypes?: Array<string>,
        tcnScheduleTemplateId?: Array<string>,
        templateFlow?: Array<string>,
        templateType?: Array<string>,
        thumbnail?: Array<string>,
        type?: Array<string>,
        useBeta?: Array<string>,
        useCase?: Array<string>,
        uuid?: Array<string>,
    }): CancelablePromise<PaginatedFlowSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/organisations/{organisation_uuid}/flows/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'application_type': applicationType,
                'beta_version': betaVersion,
                'campaign_uuid': campaignUuid,
                'channel_config': channelConfig,
                'compliance_type': complianceType,
                'created_at': createdAt,
                'created_by': createdBy,
                'dashboard_config': dashboardConfig,
                'debt_collections_usecase': debtCollectionsUsecase,
                'deleted_by': deletedBy,
                'demo_config': demoConfig,
                'demo_leads': demoLeads,
                'deployed_version': deployedVersion,
                'documentation': documentation,
                'exclude-fields': excludeFields,
                'experiment_enabled': experimentEnabled,
                'experiment_platform_config': experimentPlatformConfig,
                'experiment_version': experimentVersion,
                'experiment_versions': experimentVersions,
                'fields': fields,
                'for_demo': forDemo,
                'industry_segment_type': industrySegmentType,
                'is_llm': isLlm,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'mis_reports_json': misReportsJson,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'organisation': organisation,
                'organisation__name': organisationName,
                'organisation__uuid__in': organisationUuidIn,
                'pdf_generation_template': pdfGenerationTemplate,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'subscription_id': subscriptionId,
                'tags': tags,
                'tcn_allowed_campaign_collector_types': tcnAllowedCampaignCollectorTypes,
                'tcn_schedule_template_id': tcnScheduleTemplateId,
                'template_flow': templateFlow,
                'template_type': templateType,
                'thumbnail': thumbnail,
                'type': type,
                'use_beta': useBeta,
                'use_case': useCase,
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static flowBulkDestroy2({
        organisationUuid,
        id,
    }: {
        organisationUuid: string,
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/organisations/{organisation_uuid}/flows/',
            path: {
                'organisation_uuid': organisationUuid,
            },
            query: {
                'id': id,
            },
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns PaginatedNormalizedCallsList
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsList({
        flowUuid,
        organisationUuid,
        limit,
        offset,
        ordering,
        search,
    }: {
        flowUuid: string,
        organisationUuid: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedNormalizedCallsList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/',
            path: {
                'flow_uuid': flowUuid,
                'organisation_uuid': organisationUuid,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'search': search,
            },
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns NormalizedCalls
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsCreate({
        flowUuid,
        organisationUuid,
        requestBody,
    }: {
        flowUuid: string,
        organisationUuid: string,
        requestBody: NormalizedCalls,
    }): CancelablePromise<NormalizedCalls> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/',
            path: {
                'flow_uuid': flowUuid,
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns NormalizedCalls
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsRetrieve({
        flowUuid,
        id,
        organisationUuid,
    }: {
        flowUuid: string,
        /**
         * A unique integer value identifying this normalized calls.
         */
        id: number,
        organisationUuid: string,
    }): CancelablePromise<NormalizedCalls> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/{id}/',
            path: {
                'flow_uuid': flowUuid,
                'id': id,
                'organisation_uuid': organisationUuid,
            },
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns NormalizedCalls
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsUpdate({
        flowUuid,
        id,
        organisationUuid,
        requestBody,
    }: {
        flowUuid: string,
        /**
         * A unique integer value identifying this normalized calls.
         */
        id: number,
        organisationUuid: string,
        requestBody: NormalizedCalls,
    }): CancelablePromise<NormalizedCalls> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/{id}/',
            path: {
                'flow_uuid': flowUuid,
                'id': id,
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns NormalizedCalls
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsPartialUpdate({
        flowUuid,
        id,
        organisationUuid,
        requestBody,
    }: {
        flowUuid: string,
        /**
         * A unique integer value identifying this normalized calls.
         */
        id: number,
        organisationUuid: string,
        requestBody?: PatchedNormalizedCalls,
    }): CancelablePromise<NormalizedCalls> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/{id}/',
            path: {
                'flow_uuid': flowUuid,
                'id': id,
                'organisation_uuid': organisationUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns void
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsDestroy({
        flowUuid,
        id,
        organisationUuid,
    }: {
        flowUuid: string,
        /**
         * A unique integer value identifying this normalized calls.
         */
        id: number,
        organisationUuid: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/{id}/',
            path: {
                'flow_uuid': flowUuid,
                'id': id,
                'organisation_uuid': organisationUuid,
            },
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns Calls
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsCallDetailsRetrieve({
        callUuid,
        flowUuid,
        organisationUuid,
        ssmlRedact = false,
    }: {
        callUuid: string,
        flowUuid: string,
        organisationUuid: string,
        ssmlRedact?: boolean,
    }): CancelablePromise<Calls> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/call_details/',
            path: {
                'flow_uuid': flowUuid,
                'organisation_uuid': organisationUuid,
            },
            query: {
                'call_uuid': callUuid,
                'ssml_redact': ssmlRedact,
            },
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns NormalizedCalls
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsCallMetadataRetrieve({
        callUuid,
        flowUuid,
        organisationUuid,
    }: {
        callUuid: string,
        flowUuid: string,
        organisationUuid: string,
    }): CancelablePromise<NormalizedCalls> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/call_metadata/',
            path: {
                'flow_uuid': flowUuid,
                'organisation_uuid': organisationUuid,
            },
            query: {
                'call_uuid': callUuid,
            },
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns NormalizedCalls
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsDownloadCallsCreate({
        flowUuid,
        organisationUuid,
        callCreatedAtGte,
        callCreatedAtLte,
        callDriver,
        callDurationGte,
        callDurationLte,
        callTypeIn,
        callUuid,
        callerNumber,
        category,
        customSearchKey,
        customSearchValue,
        downloadType,
        flowVersion,
        languageCode,
        languageCodeIn,
        searchFields,
        stateIn,
        statusIn,
        requestBody,
    }: {
        flowUuid: string,
        organisationUuid: string,
        callCreatedAtGte?: string,
        callCreatedAtLte?: string,
        callDriver?: string,
        callDurationGte?: string,
        callDurationLte?: string,
        callTypeIn?: Array<string>,
        callUuid?: string,
        callerNumber?: string,
        category?: string,
        customSearchKey?: string,
        customSearchValue?: string,
        downloadType?: 'audio' | 'csv',
        flowVersion?: string,
        languageCode?: string,
        languageCodeIn?: Array<string>,
        searchFields?: Array<string>,
        stateIn?: Array<string>,
        statusIn?: Array<string>,
        requestBody?: DownloadCallRequest,
    }): CancelablePromise<NormalizedCalls> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/download_calls/',
            path: {
                'flow_uuid': flowUuid,
                'organisation_uuid': organisationUuid,
            },
            query: {
                'call_created_at__gte': callCreatedAtGte,
                'call_created_at__lte': callCreatedAtLte,
                'call_driver': callDriver,
                'call_duration__gte': callDurationGte,
                'call_duration__lte': callDurationLte,
                'call_type__in': callTypeIn,
                'call_uuid': callUuid,
                'caller_number': callerNumber,
                'category': category,
                'custom_search_key': customSearchKey,
                'custom_search_value': customSearchValue,
                'download_type': downloadType,
                'flow_version': flowVersion,
                'language_code': languageCode,
                'language_code__in': languageCodeIn,
                'search_fields': searchFields,
                'state__in': stateIn,
                'status__in': statusIn,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns NormalizedCalls
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsEditCallMetadataCreate({
        callUuid,
        flowUuid,
        organisationUuid,
        requestBody,
    }: {
        callUuid: string,
        flowUuid: string,
        organisationUuid: string,
        requestBody: CallMetaDataRequest,
    }): CancelablePromise<NormalizedCalls> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/edit_call_metadata/',
            path: {
                'flow_uuid': flowUuid,
                'organisation_uuid': organisationUuid,
            },
            query: {
                'call_uuid': callUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Endpoint to list all calls for a given Flow
     * @returns PaginatedNormalizedCallsList
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsFetchCallsList({
        category,
        flowUuid,
        organisationUuid,
        callCreatedAtGte,
        callCreatedAtLte,
        callDriver,
        callDurationGte,
        callDurationLte,
        callTypeIn,
        callUuid,
        callerNumber,
        customSearchKey,
        customSearchValue,
        flowVersion,
        languageCode,
        languageCodeIn,
        limit,
        offset,
        ordering,
        search,
        searchFields,
        stateIn,
        statusIn,
    }: {
        category: string,
        flowUuid: string,
        organisationUuid: string,
        callCreatedAtGte?: string,
        callCreatedAtLte?: string,
        callDriver?: string,
        callDurationGte?: string,
        callDurationLte?: string,
        callTypeIn?: Array<string>,
        callUuid?: string,
        callerNumber?: string,
        customSearchKey?: string,
        customSearchValue?: string,
        flowVersion?: string,
        languageCode?: string,
        languageCodeIn?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * A search term.
         */
        search?: string,
        searchFields?: Array<string>,
        stateIn?: Array<string>,
        statusIn?: Array<string>,
    }): CancelablePromise<PaginatedNormalizedCallsList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/fetch_calls/',
            path: {
                'flow_uuid': flowUuid,
                'organisation_uuid': organisationUuid,
            },
            query: {
                'call_created_at__gte': callCreatedAtGte,
                'call_created_at__lte': callCreatedAtLte,
                'call_driver': callDriver,
                'call_duration__gte': callDurationGte,
                'call_duration__lte': callDurationLte,
                'call_type__in': callTypeIn,
                'call_uuid': callUuid,
                'caller_number': callerNumber,
                'category': category,
                'custom_search_key': customSearchKey,
                'custom_search_value': customSearchValue,
                'flow_version': flowVersion,
                'language_code': languageCode,
                'language_code__in': languageCodeIn,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'search': search,
                'search_fields': searchFields,
                'state__in': stateIn,
                'status__in': statusIn,
            },
        });
    }
    /**
     * Viewset to handle CRUD actions on Normalized Calls.
     * @returns NormalizedCalls
     * @throws ApiError
     */
    public static organisationsFlowsAnalyticsSessionFlowRetrieve({
        flowUuid,
        organisationUuid,
        callCreatedAtGte,
        callCreatedAtLte,
        callDriver,
        callUuid,
        callerNumber,
        clientUuid,
        flowVersion,
        languageCode,
        readDepth,
    }: {
        flowUuid: string,
        organisationUuid: string,
        callCreatedAtGte?: Array<string>,
        callCreatedAtLte?: Array<string>,
        callDriver?: Array<string>,
        callUuid?: Array<string>,
        callerNumber?: Array<string>,
        clientUuid?: Array<string>,
        flowVersion?: Array<string>,
        languageCode?: Array<string>,
        readDepth?: number,
    }): CancelablePromise<NormalizedCalls> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/analytics/session_flow/',
            path: {
                'flow_uuid': flowUuid,
                'organisation_uuid': organisationUuid,
            },
            query: {
                'call_created_at__gte': callCreatedAtGte,
                'call_created_at__lte': callCreatedAtLte,
                'call_driver': callDriver,
                'call_uuid': callUuid,
                'caller_number': callerNumber,
                'client_uuid': clientUuid,
                'flow_version': flowVersion,
                'language_code': languageCode,
                'read_depth': readDepth,
            },
        });
    }
    /**
     * 1. View to approve/cancel an attempt; sets cancel message in case of cancel
     * 2. Updates last_modified_by for logs (whoever is last_modified either approved/cancelled)
     * - Sets approved for an attempt = True
     * - request:
     * * attempt_uuid in request_params
     * * {
         * "exclusion_file":"<file path>",
         * "approve":"approve/cancel",
         * }
         * - response:
         * responses = { 200: TCNOutboundCampaignReadSerializer() }
         * @returns TCNOutboundCampaignRead
         * @throws ApiError
         */
        public static organisationsFlowsAppOutboundCampaignApproveCancelAttemptCreate({
            flowUuid,
            id,
            organisationUuid,
            formData,
        }: {
            flowUuid: string,
            id: string,
            organisationUuid: string,
            formData?: {
                /**
                 * Exclusion Sheet (.csv)
                 */
                exclusion_file?: Blob;
                approve?: string;
            },
        }): CancelablePromise<TCNOutboundCampaignRead> {
            return __request(OpenAPI, {
                method: 'POST',
                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/app_outbound_campaign/{id}/approve_cancel_attempt/',
                path: {
                    'flow_uuid': flowUuid,
                    'id': id,
                    'organisation_uuid': organisationUuid,
                },
                formData: formData,
                mediaType: 'multipart/form-data',
            });
        }
        /**
         * @returns any
         * @throws ApiError
         */
        public static organisationsFlowsAppOutboundCampaignDownloadFileRetrieve({
            fileType,
            flowUuid,
            id,
            organisationUuid,
        }: {
            /**
             * File type to download
             */
            fileType: 'contacts_file' | 'excluded_file' | 'exclusion_file' | 'filtered_file',
            flowUuid: string,
            id: string,
            organisationUuid: string,
        }): CancelablePromise<Record<string, any>> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/app_outbound_campaign/{id}/download_file/',
                path: {
                    'flow_uuid': flowUuid,
                    'id': id,
                    'organisation_uuid': organisationUuid,
                },
                query: {
                    'file_type': fileType,
                },
            });
        }
        /**
         * View which returns logs for batch
         * @returns any
         * @throws ApiError
         */
        public static organisationsFlowsAppOutboundCampaignGetBatchLogRetrieve({
            flowUuid,
            id,
            organisationUuid,
        }: {
            flowUuid: string,
            id: string,
            organisationUuid: string,
        }): CancelablePromise<Record<string, any>> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/app_outbound_campaign/{id}/get_batch_log/',
                path: {
                    'flow_uuid': flowUuid,
                    'id': id,
                    'organisation_uuid': organisationUuid,
                },
            });
        }
        /**
         * Function to schedule a campaign in Batch Table and creates attempts in Campaign Table
         * - request:
         * {
             * "name":"<campaign name>",
             * "attempts":[
                 * {
                     * "scheduled_datetime":"2022-10-24 09:00 +0530",
                     * "is_retry": false
                     * },
                     * {
                         * "scheduled_datetime":"2022-10-24 09:00 +0530",
                         * "is_retry": true
                         * },
                         * ],
                         * "contacts_file":"<file name>"
                         * }
                         * - response in case of error:
                         * Response({
                             * "error_message": "Error exists in input",
                             * "errors": errors list
                             * }, status=status.HTTP_400_BAD_REQUEST/status.HTTP_500_INTERNAL_SERVER_ERROR)
                             * - no error:
                             * response = {
                                 * "batch_id": <None/int>
                                 * }
                                 *
                                 *
                                 * - Returns "error_message" key in case of error
                                 * @returns any
                                 * @throws ApiError
                                 */
                                public static organisationsFlowsAppOutboundCampaignCreateCampaignCreate({
                                    flowUuid,
                                    organisationUuid,
                                    formData,
                                }: {
                                    flowUuid: string,
                                    organisationUuid: string,
                                    formData?: {
                                        /**
                                         * Upload Contacts Sheet (.csv)
                                         */
                                        contacts_file?: Blob;
                                        attempts?: string;
                                        schedule_template_id?: string;
                                        name?: string;
                                        collector_type?: string;
                                    },
                                }): CancelablePromise<Record<string, any>> {
                                    return __request(OpenAPI, {
                                        method: 'POST',
                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/app_outbound_campaign/create_campaign/',
                                        path: {
                                            'flow_uuid': flowUuid,
                                            'organisation_uuid': organisationUuid,
                                        },
                                        formData: formData,
                                        mediaType: 'multipart/form-data',
                                    });
                                }
                                /**
                                 * @returns any No response body
                                 * @throws ApiError
                                 */
                                public static organisationsFlowsAppOutboundCampaignCreateEmailCampaignCreate({
                                    flowUuid,
                                    organisationUuid,
                                    formData,
                                }: {
                                    flowUuid: string,
                                    organisationUuid: string,
                                    formData?: {
                                        /**
                                         * Exclusion Sheet (.csv)
                                         */
                                        contacts_file?: Blob;
                                        campaign_settings?: {
                                            subject_line?: string;
                                            from_name?: string;
                                            from_email?: string;
                                            template_id?: string;
                                        };
                                    },
                                }): CancelablePromise<any> {
                                    return __request(OpenAPI, {
                                        method: 'POST',
                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/app_outbound_campaign/create_email_campaign/',
                                        path: {
                                            'flow_uuid': flowUuid,
                                            'organisation_uuid': organisationUuid,
                                        },
                                        formData: formData,
                                        mediaType: 'multipart/form-data',
                                    });
                                }
                                /**
                                 * Get campaign settings
                                 * @returns BatchSettings
                                 * @throws ApiError
                                 */
                                public static organisationsFlowsAppOutboundCampaignGetBatchAttemptSettingsRetrieve({
                                    flowUuid,
                                    organisationUuid,
                                }: {
                                    flowUuid: string,
                                    organisationUuid: string,
                                }): CancelablePromise<BatchSettings> {
                                    return __request(OpenAPI, {
                                        method: 'GET',
                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/app_outbound_campaign/get_batch_attempt_settings/',
                                        path: {
                                            'flow_uuid': flowUuid,
                                            'organisation_uuid': organisationUuid,
                                        },
                                    });
                                }
                                /**
                                 * Function to list all the campaigns
                                 * - Request:
                                 * {}
                                 * - Response:
                                 * Response(200,
                                 * {
                                     * [
                                         * {
                                             * <campaign_1>
                                             * },
                                             * {
                                                 * <campaign_2>
                                                 * },
                                                 *
                                                 * ]
                                                 * })
                                                 * @returns CampaignList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsAppOutboundCampaignListCampaignsList({
                                                    flowUuid,
                                                    organisationUuid,
                                                    batchStatus,
                                                    batchesPerPage,
                                                    page,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    /**
                                                     * Status of Batch
                                                     */
                                                    batchStatus?: string,
                                                    /**
                                                     * Number of batches per page
                                                     */
                                                    batchesPerPage?: number,
                                                    /**
                                                     * Page number
                                                     */
                                                    page?: number,
                                                }): CancelablePromise<Array<CampaignList>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/app_outbound_campaign/list_campaigns/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'batch_status': batchStatus,
                                                            'batches_per_page': batchesPerPage,
                                                            'page': page,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * This view expects a POST request with a payload containing an "attempts" list, where each
                                                 * item in the list represents an attempt with a scheduled date and time. The view performs
                                                 * validations on each attempt, using campaign settings such as the campaign timezone, maximum number
                                                 * of days, list of holidays, and maximum attempts per day. If any errors are encountered,
                                                 * the view returns a response with a "status" of` "invalid" and a list of errors. Otherwise,
                                                 * the view returns a response with a "status" of "valid".
                                                 * @returns any
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsAppOutboundCampaignValidateCampaignInputsCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    formData,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    formData?: {
                                                        scope?: 'all' | 'attempts' | 'name' | 'contacts_file';
                                                        name?: string;
                                                        /**
                                                         * Upload Contacts Sheet (.csv)
                                                         */
                                                        contacts_file?: Blob;
                                                        attempts?: string;
                                                    },
                                                }): CancelablePromise<Record<string, any>> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/app_outbound_campaign/validate_campaign_inputs/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        formData: formData,
                                                        mediaType: 'multipart/form-data',
                                                    });
                                                }
                                                /**
                                                 * @returns CampaignCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsList({
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<Array<CampaignCreate>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: CampaignCreate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns CallCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsCallsList({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                    ordering,
                                                    status,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    ordering?: string,
                                                    status?: string,
                                                }): CancelablePromise<Array<CallCreate>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/calls/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'ordering': ordering,
                                                            'status': status,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CallCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsCallsRetrieve({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<CallCreate> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/calls/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsCallsPartialUpdate({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedCallCreate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/calls/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsCallsDestroy({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/calls/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CampaignHolidays
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsHolidaysList({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<Array<CampaignHolidays>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/holidays/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsHolidaysCreate({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody?: CampaignHolidays,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/holidays/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsHolidaysPartialUpdate({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedCampaignHolidays,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/holidays/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsHolidaysDestroy({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/holidays/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns LeadCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsLeadsList({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                    ordering,
                                                    status,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    ordering?: string,
                                                    status?: string,
                                                }): CancelablePromise<Array<LeadCreate>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/leads/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'ordering': ordering,
                                                            'status': status,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns LeadCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsLeadsRetrieve({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<LeadCreate> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/leads/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsLeadsPartialUpdate({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedLeadCreate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/leads/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsLeadsDestroy({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/leads/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns ListCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsListsList({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                    campaign,
                                                    ordering,
                                                    status,
                                                    statusIn,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    campaign?: Array<string>,
                                                    ordering?: string,
                                                    status?: string,
                                                    statusIn?: Array<string>,
                                                }): CancelablePromise<Array<ListCreate>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/lists/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'campaign': campaign,
                                                            'ordering': ordering,
                                                            'status': status,
                                                            'status__in': statusIn,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsListsCreate({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: ListCreate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/lists/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns ListCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsListsRetrieve({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<ListCreate> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/lists/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsListsUpdate({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody: ListCreate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/lists/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsListsPartialUpdate({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedListCreate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/lists/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsListsDestroy({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/lists/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CamapignPretrigger
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsPretriggerList({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<Array<CamapignPretrigger>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/pretrigger/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsPretriggerCreate({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: CampaignCreate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/pretrigger/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsPretriggerPartialUpdate({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedCamapignPretrigger,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/pretrigger/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsPretriggerDestroy({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/pretrigger/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CampaignSchedule
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsSchedulesList({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<Array<CampaignSchedule>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/schedules/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsSchedulesCreate({
                                                    campaignPk,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: CampaignSchedule,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/schedules/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsSchedulesPartialUpdate({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedCampaignSchedule,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/schedules/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsSchedulesDestroy({
                                                    campaignPk,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    campaignPk: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{campaign_pk}/schedules/{id}/',
                                                        path: {
                                                            'campaign_pk': campaignPk,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CampaignCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsRetrieve({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<CampaignCreate> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody?: CampaignUpdate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsPartialUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedCampaignUpdate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsDestroy({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsGenerateSampleSheetRetrieve({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{id}/generate_sample_sheet/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsPauseUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{id}/pause/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsPurgeUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{id}/purge/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsResumeUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{id}/resume/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCampaignsValidateColumnMappingRetrieve({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/campaigns/{id}/validate_column_mapping/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCommentReadList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCommentsList({
                                                    flowUuid,
                                                    organisationUuid,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    limit,
                                                    objectId,
                                                    offset,
                                                    ordering,
                                                    parent,
                                                    readDepth,
                                                    search,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    objectId?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<PaginatedCommentReadList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/comments/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'limit': limit,
                                                            'object_id': objectId,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CommentWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCommentsCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: CommentWriteSerializerWithRepr,
                                                }): CancelablePromise<CommentWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/comments/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCommentWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static commentBulkUpdate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    limit,
                                                    objectId,
                                                    offset,
                                                    ordering,
                                                    parent,
                                                    readDepth,
                                                    search,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<CommentWriteSerializerWithRepr>,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    objectId?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<PaginatedCommentWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/comments/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'limit': limit,
                                                            'object_id': objectId,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCommentWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static commentBulkPartialUpdate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    limit,
                                                    objectId,
                                                    offset,
                                                    ordering,
                                                    parent,
                                                    readDepth,
                                                    search,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<CommentWriteSerializerWithRepr>,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    objectId?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<PaginatedCommentWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/comments/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'limit': limit,
                                                            'object_id': objectId,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static commentBulkDestroy({
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/comments/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CommentRead
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCommentsRetrieve({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    objectId,
                                                    parent,
                                                    readDepth,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this comment.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    objectId?: Array<string>,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<CommentRead> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/comments/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'object_id': objectId,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CommentWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCommentsUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this comment.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody: CommentWriteSerializerWithRepr,
                                                }): CancelablePromise<CommentWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/comments/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns CommentWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCommentsPartialUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this comment.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedCommentWriteSerializerWithRepr,
                                                }): CancelablePromise<CommentWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/comments/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsCommentsDestroy({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this comment.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/comments/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * Enable the experiment version for the application.
                                                 * This view will create a new version of the application with the experiment version and
                                                 * copy the prompts and parameters from the default version to the experimental version.
                                                 * @returns Flow
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsFlowExperimentEnableExperimentCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: EnableExperiment,
                                                }): CancelablePromise<Flow> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/flow-experiment/enable_experiment/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * Remove the experiment version for the application.
                                                 * Disabling the experiment won't delete the experiment version of the application flows
                                                 * instead, it will remove the required values from the database.
                                                 * @returns Flow
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsFlowExperimentRemoveExperimentCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<Flow> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/flow-experiment/remove_experiment/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * Remove the experiment version of the template flow.
                                                 * Experiment Config can only be removed if that experiment version is not being used by any other flow.
                                                 * @returns any
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsFlowExperimentRemoveExperimentVersionCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody?: Record<string, any>,
                                                }): CancelablePromise<Record<string, any>> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/flow-experiment/remove_experiment_version/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * Returns paginated normalized calls
                                                 * based on the mis_reports_json
                                                 * @returns PaginatedNormalizedCallsList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsMisReportsList({
                                                    flowUuid,
                                                    organisationUuid,
                                                    callType,
                                                    endDate,
                                                    language,
                                                    limit = 10,
                                                    offset,
                                                    ordering,
                                                    search,
                                                    startDate,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    callType?: string,
                                                    endDate?: string,
                                                    language?: string,
                                                    limit?: number,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    startDate?: string,
                                                }): CancelablePromise<PaginatedNormalizedCallsList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/mis-reports/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'call_type': callType,
                                                            'end_date': endDate,
                                                            'language': language,
                                                            'limit': limit,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'search': search,
                                                            'start_date': startDate,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * Returns mis_reports_json for a particular flow
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsMisReportsJsonRetrieve({
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/mis-reports-json/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * Viewset to handle CRUD actions on MIS Reports.
                                                 * @returns NormalizedCalls
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsMisReportsRetrieve({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this normalized calls.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<NormalizedCalls> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/mis-reports/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * Returns a csv file containing normalized_calls
                                                 * based on the mis_reports_json
                                                 * @returns NormalizedCalls
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsMisReportsAllReportsRetrieve({
                                                    flowUuid,
                                                    organisationUuid,
                                                    callType,
                                                    endDate,
                                                    language,
                                                    startDate,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    callType?: string,
                                                    endDate?: string,
                                                    language?: string,
                                                    startDate?: string,
                                                }): CancelablePromise<NormalizedCalls> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/mis-reports/all_reports/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'call_type': callType,
                                                            'end_date': endDate,
                                                            'language': language,
                                                            'start_date': startDate,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * Returns all the columns of the normalized_calls table
                                                 * and metadata fields as a list
                                                 * @returns NormalizedCalls
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsMisReportsFetchColumnsRetrieve({
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<NormalizedCalls> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/mis-reports/fetch_columns/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedOntologyListList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesList({
                                                    flowUuid,
                                                    organisationUuid,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    flowConfigIsnull,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    flowConfigIsnull?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                }): CancelablePromise<PaginatedOntologyListList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'flow_config__isnull': flowConfigIsnull,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns OntologyWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: OntologyWriteSerializerWithRepr,
                                                }): CancelablePromise<OntologyWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedOntologyWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static ontologyBulkUpdate2({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    flowConfigIsnull,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<OntologyWriteSerializerWithRepr>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    flowConfigIsnull?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                }): CancelablePromise<PaginatedOntologyWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'flow_config__isnull': flowConfigIsnull,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedOntologyWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static ontologyBulkPartialUpdate2({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    flowConfigIsnull,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<OntologyWriteSerializerWithRepr>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    flowConfigIsnull?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                }): CancelablePromise<PaginatedOntologyWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'flow_config__isnull': flowConfigIsnull,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static ontologyBulkDestroy2({
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedOntologyLanguageListList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesLanguagesList({
                                                    flowUuid,
                                                    ontologyPk,
                                                    organisationUuid,
                                                    excludeFields,
                                                    fields,
                                                    language,
                                                    limit,
                                                    offset,
                                                    ontology,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                    utterance,
                                                }: {
                                                    flowUuid: string,
                                                    ontologyPk: number,
                                                    organisationUuid: string,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    language?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    ontology?: Array<string>,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    utterance?: Array<string>,
                                                }): CancelablePromise<PaginatedOntologyLanguageListList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{ontology_pk}/languages/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'ontology_pk': ontologyPk,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'language': language,
                                                            'limit': limit,
                                                            'offset': offset,
                                                            'ontology': ontology,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'utterance': utterance,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns OntologyLanguageWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesLanguagesCreate({
                                                    flowUuid,
                                                    ontologyPk,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    ontologyPk: number,
                                                    organisationUuid: string,
                                                    requestBody: OntologyLanguageWriteSerializerWithRepr,
                                                }): CancelablePromise<OntologyLanguageWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{ontology_pk}/languages/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'ontology_pk': ontologyPk,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedOntologyLanguageWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static ontologyLanguageBulkUpdate2({
                                                    flowUuid,
                                                    ontologyPk,
                                                    organisationUuid,
                                                    requestBody,
                                                    excludeFields,
                                                    fields,
                                                    language,
                                                    limit,
                                                    offset,
                                                    ontology,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                    utterance,
                                                }: {
                                                    flowUuid: string,
                                                    ontologyPk: number,
                                                    organisationUuid: string,
                                                    requestBody: Array<OntologyLanguageWriteSerializerWithRepr>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    language?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    ontology?: Array<string>,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    utterance?: Array<string>,
                                                }): CancelablePromise<PaginatedOntologyLanguageWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{ontology_pk}/languages/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'ontology_pk': ontologyPk,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'language': language,
                                                            'limit': limit,
                                                            'offset': offset,
                                                            'ontology': ontology,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'utterance': utterance,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedOntologyLanguageWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static ontologyLanguageBulkPartialUpdate2({
                                                    flowUuid,
                                                    ontologyPk,
                                                    organisationUuid,
                                                    requestBody,
                                                    excludeFields,
                                                    fields,
                                                    language,
                                                    limit,
                                                    offset,
                                                    ontology,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                    utterance,
                                                }: {
                                                    flowUuid: string,
                                                    ontologyPk: number,
                                                    organisationUuid: string,
                                                    requestBody: Array<OntologyLanguageWriteSerializerWithRepr>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    language?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    ontology?: Array<string>,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    utterance?: Array<string>,
                                                }): CancelablePromise<PaginatedOntologyLanguageWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{ontology_pk}/languages/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'ontology_pk': ontologyPk,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'language': language,
                                                            'limit': limit,
                                                            'offset': offset,
                                                            'ontology': ontology,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'utterance': utterance,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static ontologyLanguageBulkDestroy2({
                                                    flowUuid,
                                                    ontologyPk,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowUuid: string,
                                                    ontologyPk: number,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{ontology_pk}/languages/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'ontology_pk': ontologyPk,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns OntologyLanguageRead
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesLanguagesRetrieve({
                                                    flowUuid,
                                                    id,
                                                    ontologyPk,
                                                    organisationUuid,
                                                    excludeFields,
                                                    fields,
                                                    language,
                                                    ontology,
                                                    readDepth,
                                                    utterance,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this ontology language.
                                                     */
                                                    id: number,
                                                    ontologyPk: number,
                                                    organisationUuid: string,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    language?: Array<string>,
                                                    ontology?: Array<string>,
                                                    readDepth?: number,
                                                    utterance?: Array<string>,
                                                }): CancelablePromise<OntologyLanguageRead> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{ontology_pk}/languages/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'ontology_pk': ontologyPk,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'language': language,
                                                            'ontology': ontology,
                                                            'read_depth': readDepth,
                                                            'utterance': utterance,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns OntologyLanguageWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesLanguagesUpdate({
                                                    flowUuid,
                                                    id,
                                                    ontologyPk,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this ontology language.
                                                     */
                                                    id: number,
                                                    ontologyPk: number,
                                                    organisationUuid: string,
                                                    requestBody: OntologyLanguageWriteSerializerWithRepr,
                                                }): CancelablePromise<OntologyLanguageWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{ontology_pk}/languages/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'ontology_pk': ontologyPk,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns OntologyLanguageWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesLanguagesPartialUpdate({
                                                    flowUuid,
                                                    id,
                                                    ontologyPk,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this ontology language.
                                                     */
                                                    id: number,
                                                    ontologyPk: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedOntologyLanguageWriteSerializerWithRepr,
                                                }): CancelablePromise<OntologyLanguageWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{ontology_pk}/languages/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'ontology_pk': ontologyPk,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesLanguagesDestroy({
                                                    flowUuid,
                                                    id,
                                                    ontologyPk,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this ontology language.
                                                     */
                                                    id: number,
                                                    ontologyPk: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{ontology_pk}/languages/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'ontology_pk': ontologyPk,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns OntologyRead
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesRetrieve({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    name,
                                                    readDepth,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this ontology.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    name?: Array<string>,
                                                    readDepth?: number,
                                                }): CancelablePromise<OntologyRead> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'name': name,
                                                            'read_depth': readDepth,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns OntologyWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this ontology.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody: OntologyWriteSerializerWithRepr,
                                                }): CancelablePromise<OntologyWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns OntologyWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesPartialUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this ontology.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedOntologyWriteSerializerWithRepr,
                                                }): CancelablePromise<OntologyWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsOntologiesDestroy({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this ontology.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/ontologies/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns ClientReportResponse
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsReportsCustomReportsList({
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<Array<ClientReportResponse>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/reports/custom-reports/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns ClientReportResponse
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsReportsCustomReportsCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: ClientReportCreateRequest,
                                                }): CancelablePromise<ClientReportResponse> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/reports/custom-reports/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns ClientReportCreateRequest
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsReportsCustomReportsRetrieve({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this client report.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<ClientReportCreateRequest> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/reports/custom-reports/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns ClientReportResponse
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsReportsCustomReportsUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this client report.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody: ClientReportUpdate,
                                                }): CancelablePromise<ClientReportResponse> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/reports/custom-reports/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns ClientReportUpdate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsReportsCustomReportsPartialUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this client report.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedClientReportUpdate,
                                                }): CancelablePromise<ClientReportUpdate> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/reports/custom-reports/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsReportsCustomReportsDestroy({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this client report.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/reports/custom-reports/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * Filters Beat Periodic Tasks by name(unique)=f"phaseb-report-{flow_uuid}" and task = "hardcoded-value"
                                                 * @returns PhaseBReportSchedulesReadResponse
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsScheduleList({
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<Array<PhaseBReportSchedulesReadResponse>> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/schedule/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * Creates Beat Periodic Task by name(unique)=f"phaseb-report-{flow_uuid}" and task = "hardcoded-value"
                                                 * @returns PhaseBReportSchedulesWriteResponse
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsScheduleCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: PhaseBReportSchedulesWriteRequest,
                                                }): CancelablePromise<PhaseBReportSchedulesWriteResponse> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/schedule/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * Filters Beat Periodic Tasks by name(unique)=f"phaseb-report-{flow_uuid}" and task = "hardcoded-value" and updates them using input data
                                                 * @returns PhaseBReportSchedulesWriteResponse
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsScheduleUpdate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: PhaseBReportSchedulesUpdateRequest,
                                                }): CancelablePromise<PhaseBReportSchedulesWriteResponse> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/schedule/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * Filters Beat Periodic Tasks by name(unique)=f"phaseb-report-{flow_uuid}" and task = "hardcoded-value" and deletes them
                                                 * @returns any
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsScheduleDestroy({
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<Record<string, any>> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/schedule/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedTCNOutboundCampaignReadList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsTcnCampaignsList({
                                                    flowUuid,
                                                    organisationUuid,
                                                    approved,
                                                    awsSwfId,
                                                    billedMinutes,
                                                    campaignReferenceId,
                                                    cancellationCode,
                                                    cancellationMessage,
                                                    collectorType,
                                                    completedRecords,
                                                    connectivity,
                                                    cost,
                                                    createdAt,
                                                    createdBy,
                                                    exceptionMessage,
                                                    excludeFields,
                                                    exclusionFile,
                                                    fields,
                                                    file,
                                                    filteredSheet,
                                                    groupName,
                                                    isRetry,
                                                    lastModifiedAt,
                                                    lastModifiedBy,
                                                    limit,
                                                    offset,
                                                    ordering,
                                                    outboundLines,
                                                    readDepth,
                                                    scheduleTemplateId,
                                                    scheduledDatetime,
                                                    search,
                                                    status,
                                                    totalRecords,
                                                    uuid,
                                                    workflowStatus,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    approved?: Array<string>,
                                                    awsSwfId?: Array<string>,
                                                    billedMinutes?: Array<string>,
                                                    campaignReferenceId?: Array<string>,
                                                    cancellationCode?: Array<string>,
                                                    cancellationMessage?: Array<string>,
                                                    collectorType?: Array<string>,
                                                    completedRecords?: Array<string>,
                                                    connectivity?: Array<string>,
                                                    cost?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    exceptionMessage?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    exclusionFile?: Array<string>,
                                                    fields?: Array<string>,
                                                    file?: Array<string>,
                                                    filteredSheet?: Array<string>,
                                                    groupName?: Array<string>,
                                                    isRetry?: Array<string>,
                                                    lastModifiedAt?: Array<string>,
                                                    lastModifiedBy?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    outboundLines?: Array<string>,
                                                    readDepth?: number,
                                                    scheduleTemplateId?: Array<string>,
                                                    scheduledDatetime?: Array<string>,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    status?: Array<string>,
                                                    totalRecords?: Array<string>,
                                                    uuid?: Array<string>,
                                                    workflowStatus?: Array<string>,
                                                }): CancelablePromise<PaginatedTCNOutboundCampaignReadList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_campaigns/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'approved': approved,
                                                            'aws_swf_id': awsSwfId,
                                                            'billed_minutes': billedMinutes,
                                                            'campaign_reference_id': campaignReferenceId,
                                                            'cancellation_code': cancellationCode,
                                                            'cancellation_message': cancellationMessage,
                                                            'collector_type': collectorType,
                                                            'completed_records': completedRecords,
                                                            'connectivity': connectivity,
                                                            'cost': cost,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exception_message': exceptionMessage,
                                                            'exclude-fields': excludeFields,
                                                            'exclusion_file': exclusionFile,
                                                            'fields': fields,
                                                            'file': file,
                                                            'filtered_sheet': filteredSheet,
                                                            'group_name': groupName,
                                                            'is_retry': isRetry,
                                                            'last_modified_at': lastModifiedAt,
                                                            'last_modified_by': lastModifiedBy,
                                                            'limit': limit,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'outbound_lines': outboundLines,
                                                            'read_depth': readDepth,
                                                            'schedule_template_id': scheduleTemplateId,
                                                            'scheduled_datetime': scheduledDatetime,
                                                            'search': search,
                                                            'status': status,
                                                            'total_records': totalRecords,
                                                            'uuid': uuid,
                                                            'workflow_status': workflowStatus,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CampaignWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsTcnCampaignsCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: CampaignWriteSerializerWithRepr,
                                                }): CancelablePromise<CampaignWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_campaigns/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCampaignWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static campaignBulkUpdate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    approved,
                                                    awsSwfId,
                                                    billedMinutes,
                                                    campaignReferenceId,
                                                    cancellationCode,
                                                    cancellationMessage,
                                                    collectorType,
                                                    completedRecords,
                                                    connectivity,
                                                    cost,
                                                    createdAt,
                                                    createdBy,
                                                    exceptionMessage,
                                                    excludeFields,
                                                    exclusionFile,
                                                    fields,
                                                    file,
                                                    filteredSheet,
                                                    groupName,
                                                    isRetry,
                                                    lastModifiedAt,
                                                    lastModifiedBy,
                                                    limit,
                                                    offset,
                                                    ordering,
                                                    outboundLines,
                                                    readDepth,
                                                    scheduleTemplateId,
                                                    scheduledDatetime,
                                                    search,
                                                    status,
                                                    totalRecords,
                                                    uuid,
                                                    workflowStatus,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<CampaignWriteSerializerWithRepr>,
                                                    approved?: Array<string>,
                                                    awsSwfId?: Array<string>,
                                                    billedMinutes?: Array<string>,
                                                    campaignReferenceId?: Array<string>,
                                                    cancellationCode?: Array<string>,
                                                    cancellationMessage?: Array<string>,
                                                    collectorType?: Array<string>,
                                                    completedRecords?: Array<string>,
                                                    connectivity?: Array<string>,
                                                    cost?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    exceptionMessage?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    exclusionFile?: Array<string>,
                                                    fields?: Array<string>,
                                                    file?: Array<string>,
                                                    filteredSheet?: Array<string>,
                                                    groupName?: Array<string>,
                                                    isRetry?: Array<string>,
                                                    lastModifiedAt?: Array<string>,
                                                    lastModifiedBy?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    outboundLines?: Array<string>,
                                                    readDepth?: number,
                                                    scheduleTemplateId?: Array<string>,
                                                    scheduledDatetime?: Array<string>,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    status?: Array<string>,
                                                    totalRecords?: Array<string>,
                                                    uuid?: Array<string>,
                                                    workflowStatus?: Array<string>,
                                                }): CancelablePromise<PaginatedCampaignWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_campaigns/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'approved': approved,
                                                            'aws_swf_id': awsSwfId,
                                                            'billed_minutes': billedMinutes,
                                                            'campaign_reference_id': campaignReferenceId,
                                                            'cancellation_code': cancellationCode,
                                                            'cancellation_message': cancellationMessage,
                                                            'collector_type': collectorType,
                                                            'completed_records': completedRecords,
                                                            'connectivity': connectivity,
                                                            'cost': cost,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exception_message': exceptionMessage,
                                                            'exclude-fields': excludeFields,
                                                            'exclusion_file': exclusionFile,
                                                            'fields': fields,
                                                            'file': file,
                                                            'filtered_sheet': filteredSheet,
                                                            'group_name': groupName,
                                                            'is_retry': isRetry,
                                                            'last_modified_at': lastModifiedAt,
                                                            'last_modified_by': lastModifiedBy,
                                                            'limit': limit,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'outbound_lines': outboundLines,
                                                            'read_depth': readDepth,
                                                            'schedule_template_id': scheduleTemplateId,
                                                            'scheduled_datetime': scheduledDatetime,
                                                            'search': search,
                                                            'status': status,
                                                            'total_records': totalRecords,
                                                            'uuid': uuid,
                                                            'workflow_status': workflowStatus,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCampaignWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static campaignBulkPartialUpdate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    approved,
                                                    awsSwfId,
                                                    billedMinutes,
                                                    campaignReferenceId,
                                                    cancellationCode,
                                                    cancellationMessage,
                                                    collectorType,
                                                    completedRecords,
                                                    connectivity,
                                                    cost,
                                                    createdAt,
                                                    createdBy,
                                                    exceptionMessage,
                                                    excludeFields,
                                                    exclusionFile,
                                                    fields,
                                                    file,
                                                    filteredSheet,
                                                    groupName,
                                                    isRetry,
                                                    lastModifiedAt,
                                                    lastModifiedBy,
                                                    limit,
                                                    offset,
                                                    ordering,
                                                    outboundLines,
                                                    readDepth,
                                                    scheduleTemplateId,
                                                    scheduledDatetime,
                                                    search,
                                                    status,
                                                    totalRecords,
                                                    uuid,
                                                    workflowStatus,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<CampaignWriteSerializerWithRepr>,
                                                    approved?: Array<string>,
                                                    awsSwfId?: Array<string>,
                                                    billedMinutes?: Array<string>,
                                                    campaignReferenceId?: Array<string>,
                                                    cancellationCode?: Array<string>,
                                                    cancellationMessage?: Array<string>,
                                                    collectorType?: Array<string>,
                                                    completedRecords?: Array<string>,
                                                    connectivity?: Array<string>,
                                                    cost?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    exceptionMessage?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    exclusionFile?: Array<string>,
                                                    fields?: Array<string>,
                                                    file?: Array<string>,
                                                    filteredSheet?: Array<string>,
                                                    groupName?: Array<string>,
                                                    isRetry?: Array<string>,
                                                    lastModifiedAt?: Array<string>,
                                                    lastModifiedBy?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    outboundLines?: Array<string>,
                                                    readDepth?: number,
                                                    scheduleTemplateId?: Array<string>,
                                                    scheduledDatetime?: Array<string>,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    status?: Array<string>,
                                                    totalRecords?: Array<string>,
                                                    uuid?: Array<string>,
                                                    workflowStatus?: Array<string>,
                                                }): CancelablePromise<PaginatedCampaignWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_campaigns/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'approved': approved,
                                                            'aws_swf_id': awsSwfId,
                                                            'billed_minutes': billedMinutes,
                                                            'campaign_reference_id': campaignReferenceId,
                                                            'cancellation_code': cancellationCode,
                                                            'cancellation_message': cancellationMessage,
                                                            'collector_type': collectorType,
                                                            'completed_records': completedRecords,
                                                            'connectivity': connectivity,
                                                            'cost': cost,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exception_message': exceptionMessage,
                                                            'exclude-fields': excludeFields,
                                                            'exclusion_file': exclusionFile,
                                                            'fields': fields,
                                                            'file': file,
                                                            'filtered_sheet': filteredSheet,
                                                            'group_name': groupName,
                                                            'is_retry': isRetry,
                                                            'last_modified_at': lastModifiedAt,
                                                            'last_modified_by': lastModifiedBy,
                                                            'limit': limit,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'outbound_lines': outboundLines,
                                                            'read_depth': readDepth,
                                                            'schedule_template_id': scheduleTemplateId,
                                                            'scheduled_datetime': scheduledDatetime,
                                                            'search': search,
                                                            'status': status,
                                                            'total_records': totalRecords,
                                                            'uuid': uuid,
                                                            'workflow_status': workflowStatus,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static campaignBulkDestroy({
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_campaigns/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns TCNOutboundCampaignRead
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsTcnCampaignsRetrieve({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    approved,
                                                    awsSwfId,
                                                    billedMinutes,
                                                    campaignReferenceId,
                                                    cancellationCode,
                                                    cancellationMessage,
                                                    collectorType,
                                                    completedRecords,
                                                    connectivity,
                                                    cost,
                                                    createdAt,
                                                    createdBy,
                                                    exceptionMessage,
                                                    excludeFields,
                                                    exclusionFile,
                                                    fields,
                                                    file,
                                                    filteredSheet,
                                                    groupName,
                                                    isRetry,
                                                    lastModifiedAt,
                                                    lastModifiedBy,
                                                    outboundLines,
                                                    readDepth,
                                                    scheduleTemplateId,
                                                    scheduledDatetime,
                                                    status,
                                                    totalRecords,
                                                    uuid,
                                                    workflowStatus,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this campaign.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    approved?: Array<string>,
                                                    awsSwfId?: Array<string>,
                                                    billedMinutes?: Array<string>,
                                                    campaignReferenceId?: Array<string>,
                                                    cancellationCode?: Array<string>,
                                                    cancellationMessage?: Array<string>,
                                                    collectorType?: Array<string>,
                                                    completedRecords?: Array<string>,
                                                    connectivity?: Array<string>,
                                                    cost?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    exceptionMessage?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    exclusionFile?: Array<string>,
                                                    fields?: Array<string>,
                                                    file?: Array<string>,
                                                    filteredSheet?: Array<string>,
                                                    groupName?: Array<string>,
                                                    isRetry?: Array<string>,
                                                    lastModifiedAt?: Array<string>,
                                                    lastModifiedBy?: Array<string>,
                                                    outboundLines?: Array<string>,
                                                    readDepth?: number,
                                                    scheduleTemplateId?: Array<string>,
                                                    scheduledDatetime?: Array<string>,
                                                    status?: Array<string>,
                                                    totalRecords?: Array<string>,
                                                    uuid?: Array<string>,
                                                    workflowStatus?: Array<string>,
                                                }): CancelablePromise<TCNOutboundCampaignRead> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_campaigns/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'approved': approved,
                                                            'aws_swf_id': awsSwfId,
                                                            'billed_minutes': billedMinutes,
                                                            'campaign_reference_id': campaignReferenceId,
                                                            'cancellation_code': cancellationCode,
                                                            'cancellation_message': cancellationMessage,
                                                            'collector_type': collectorType,
                                                            'completed_records': completedRecords,
                                                            'connectivity': connectivity,
                                                            'cost': cost,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exception_message': exceptionMessage,
                                                            'exclude-fields': excludeFields,
                                                            'exclusion_file': exclusionFile,
                                                            'fields': fields,
                                                            'file': file,
                                                            'filtered_sheet': filteredSheet,
                                                            'group_name': groupName,
                                                            'is_retry': isRetry,
                                                            'last_modified_at': lastModifiedAt,
                                                            'last_modified_by': lastModifiedBy,
                                                            'outbound_lines': outboundLines,
                                                            'read_depth': readDepth,
                                                            'schedule_template_id': scheduleTemplateId,
                                                            'scheduled_datetime': scheduledDatetime,
                                                            'status': status,
                                                            'total_records': totalRecords,
                                                            'uuid': uuid,
                                                            'workflow_status': workflowStatus,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CampaignWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsTcnCampaignsUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this campaign.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody: CampaignWriteSerializerWithRepr,
                                                }): CancelablePromise<CampaignWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_campaigns/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns CampaignWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsTcnCampaignsPartialUpdate({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this campaign.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedCampaignWriteSerializerWithRepr,
                                                }): CancelablePromise<CampaignWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_campaigns/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsTcnCampaignsDestroy({
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this campaign.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_campaigns/{id}/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * - Returns filtered csv S3 bucket URL as per compliance rules
                                                 * - Uploads the above csv to TCN
                                                 * - Uploads both uploaded and filtered csv to
                                                 * - S3 bucket for Indian Cluster = '**product-compliance-filter-india**'
                                                 * - S3 bucket for US Cluster = '**product-compliance-filter-us**'
                                                 * - S3 path = '**{client_name}/{date-of-upload}**'
                                                 * - **Uploads blank csv to S3 if the same sheet is uploaded again within 1 day**
                                                 * @returns AttemptRetry
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsTcnUploadsCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: AttemptRetry,
                                                }): CancelablePromise<AttemptRetry> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_uploads/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * - Returns filtered csv S3 bucket URL as per compliance rules
                                                 * - Uploads the above csv to TCN
                                                 * - Uploads both uploaded and filtered csv to
                                                 * - S3 bucket for Indian Cluster = '**product-compliance-filter-india**'
                                                 * - S3 bucket for US Cluster = '**product-compliance-filter-us**'
                                                 * - S3 path = '**{client_name}/{date-of-upload}**'
                                                 * - **Uploads blank csv to S3 if the same sheet is uploaded again within 1 day**
                                                 * @returns BatchAttemptRetry
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsTcnUploadsRunComplianceAndTriggerTcnCampaignCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: BatchAttemptRetry,
                                                }): CancelablePromise<BatchAttemptRetry> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/tcn_uploads/run_compliance_and_trigger_tcn_campaign/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedFlowConfigListList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsList({
                                                    flowUuid,
                                                    organisationUuid,
                                                    abTests,
                                                    accountAttributes,
                                                    allowCallback,
                                                    allowInteractionPostTransfer,
                                                    asrExecutionType,
                                                    asrList,
                                                    asrModel,
                                                    asrProvider,
                                                    audioFormat,
                                                    audioOverlayUrl,
                                                    baseUrl,
                                                    biBehaviour,
                                                    biEnable,
                                                    botResponseType,
                                                    businessConfig,
                                                    cachableKeys,
                                                    conditionalAsrs,
                                                    conditionalLanguages,
                                                    conditionalSluModels,
                                                    config,
                                                    createdAt,
                                                    createdBy,
                                                    defaultConditionalLanguage,
                                                    defaultIntent,
                                                    deletedBy,
                                                    enableKeyCaching,
                                                    enableVca,
                                                    encryptBotResponse,
                                                    encryptTranscript,
                                                    events,
                                                    eventsCompleted,
                                                    eventsPostCall,
                                                    excludeFields,
                                                    experimentConfig,
                                                    experimentTtsAgents,
                                                    fields,
                                                    flow,
                                                    isAsrService,
                                                    isDebugMode,
                                                    language,
                                                    languages,
                                                    lastModifiedAt,
                                                    lastModifiedBy,
                                                    ldConditionalEnable,
                                                    ldConsecutiveTurns,
                                                    ldEnable,
                                                    ldLanguages,
                                                    ldLimit,
                                                    ldShadow,
                                                    ldSlidsModel,
                                                    ldStates,
                                                    ldThresholdHighLowerLimit,
                                                    ldThresholdHighUpperLimit,
                                                    ldThresholdLowLowerLimit,
                                                    ldThresholdLowUpperLimit,
                                                    ldThresholdMediumLowerLimit,
                                                    ldThresholdMediumUpperLimit,
                                                    limit,
                                                    logRequest,
                                                    maskEnable,
                                                    maskType,
                                                    maskWith,
                                                    maxRetryAttempts,
                                                    maxTransitLimit,
                                                    metadataKeyHistory,
                                                    metadataKeys,
                                                    ndEnable,
                                                    ndThreshold,
                                                    offset,
                                                    ordering,
                                                    outputFormat,
                                                    primaryScopeName,
                                                    readDepth,
                                                    search,
                                                    sluModel,
                                                    stateMaxRetryAttempts,
                                                    suEnable,
                                                    suLanguage,
                                                    suShadowModeEnable,
                                                    suThreshold,
                                                    templateConfig,
                                                    templateVersion,
                                                    ttsAgents,
                                                    ttsSsmlTags,
                                                    ttsStorageType,
                                                    vcaHost,
                                                    version,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    abTests?: Array<string>,
                                                    accountAttributes?: Array<string>,
                                                    allowCallback?: Array<string>,
                                                    allowInteractionPostTransfer?: Array<string>,
                                                    asrExecutionType?: Array<string>,
                                                    asrList?: Array<string>,
                                                    asrModel?: Array<string>,
                                                    asrProvider?: Array<string>,
                                                    audioFormat?: Array<string>,
                                                    audioOverlayUrl?: Array<string>,
                                                    baseUrl?: Array<string>,
                                                    biBehaviour?: Array<string>,
                                                    biEnable?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    businessConfig?: Array<string>,
                                                    cachableKeys?: Array<string>,
                                                    conditionalAsrs?: Array<string>,
                                                    conditionalLanguages?: Array<string>,
                                                    conditionalSluModels?: Array<string>,
                                                    config?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    defaultConditionalLanguage?: Array<string>,
                                                    defaultIntent?: Array<string>,
                                                    deletedBy?: Array<string>,
                                                    enableKeyCaching?: Array<string>,
                                                    enableVca?: Array<string>,
                                                    encryptBotResponse?: Array<string>,
                                                    encryptTranscript?: Array<string>,
                                                    events?: Array<string>,
                                                    eventsCompleted?: Array<string>,
                                                    eventsPostCall?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    experimentConfig?: Array<string>,
                                                    experimentTtsAgents?: Array<string>,
                                                    fields?: Array<string>,
                                                    flow?: Array<string>,
                                                    isAsrService?: Array<string>,
                                                    isDebugMode?: Array<string>,
                                                    language?: Array<string>,
                                                    languages?: Array<string>,
                                                    lastModifiedAt?: Array<string>,
                                                    lastModifiedBy?: Array<string>,
                                                    ldConditionalEnable?: Array<string>,
                                                    ldConsecutiveTurns?: Array<string>,
                                                    ldEnable?: Array<string>,
                                                    ldLanguages?: Array<string>,
                                                    ldLimit?: Array<string>,
                                                    ldShadow?: Array<string>,
                                                    ldSlidsModel?: Array<string>,
                                                    ldStates?: Array<string>,
                                                    ldThresholdHighLowerLimit?: Array<string>,
                                                    ldThresholdHighUpperLimit?: Array<string>,
                                                    ldThresholdLowLowerLimit?: Array<string>,
                                                    ldThresholdLowUpperLimit?: Array<string>,
                                                    ldThresholdMediumLowerLimit?: Array<string>,
                                                    ldThresholdMediumUpperLimit?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    logRequest?: Array<string>,
                                                    maskEnable?: Array<string>,
                                                    maskType?: Array<string>,
                                                    maskWith?: Array<string>,
                                                    maxRetryAttempts?: Array<string>,
                                                    maxTransitLimit?: Array<string>,
                                                    metadataKeyHistory?: Array<string>,
                                                    metadataKeys?: Array<string>,
                                                    ndEnable?: Array<string>,
                                                    ndThreshold?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    outputFormat?: Array<string>,
                                                    primaryScopeName?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    sluModel?: Array<string>,
                                                    stateMaxRetryAttempts?: Array<string>,
                                                    suEnable?: Array<string>,
                                                    suLanguage?: Array<string>,
                                                    suShadowModeEnable?: Array<string>,
                                                    suThreshold?: Array<string>,
                                                    templateConfig?: Array<string>,
                                                    templateVersion?: Array<string>,
                                                    ttsAgents?: Array<string>,
                                                    ttsSsmlTags?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    vcaHost?: Array<string>,
                                                    version?: Array<string>,
                                                }): CancelablePromise<PaginatedFlowConfigListList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'ab_tests': abTests,
                                                            'account_attributes': accountAttributes,
                                                            'allow_callback': allowCallback,
                                                            'allow_interaction_post_transfer': allowInteractionPostTransfer,
                                                            'asr_execution_type': asrExecutionType,
                                                            'asr_list': asrList,
                                                            'asr_model': asrModel,
                                                            'asr_provider': asrProvider,
                                                            'audio_format': audioFormat,
                                                            'audio_overlay_url': audioOverlayUrl,
                                                            'base_url': baseUrl,
                                                            'bi_behaviour': biBehaviour,
                                                            'bi_enable': biEnable,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'business_config': businessConfig,
                                                            'cachable_keys': cachableKeys,
                                                            'conditional_asrs': conditionalAsrs,
                                                            'conditional_languages': conditionalLanguages,
                                                            'conditional_slu_models': conditionalSluModels,
                                                            'config': config,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'default_conditional_language': defaultConditionalLanguage,
                                                            'default_intent': defaultIntent,
                                                            'deleted_by': deletedBy,
                                                            'enable_key_caching': enableKeyCaching,
                                                            'enable_vca': enableVca,
                                                            'encrypt_bot_response': encryptBotResponse,
                                                            'encrypt_transcript': encryptTranscript,
                                                            'events': events,
                                                            'events_completed': eventsCompleted,
                                                            'events_post_call': eventsPostCall,
                                                            'exclude-fields': excludeFields,
                                                            'experiment_config': experimentConfig,
                                                            'experiment_tts_agents': experimentTtsAgents,
                                                            'fields': fields,
                                                            'flow': flow,
                                                            'is_asr_service': isAsrService,
                                                            'is_debug_mode': isDebugMode,
                                                            'language': language,
                                                            'languages': languages,
                                                            'last_modified_at': lastModifiedAt,
                                                            'last_modified_by': lastModifiedBy,
                                                            'ld_conditional_enable': ldConditionalEnable,
                                                            'ld_consecutive_turns': ldConsecutiveTurns,
                                                            'ld_enable': ldEnable,
                                                            'ld_languages': ldLanguages,
                                                            'ld_limit': ldLimit,
                                                            'ld_shadow': ldShadow,
                                                            'ld_slids_model': ldSlidsModel,
                                                            'ld_states': ldStates,
                                                            'ld_threshold_high_lower_limit': ldThresholdHighLowerLimit,
                                                            'ld_threshold_high_upper_limit': ldThresholdHighUpperLimit,
                                                            'ld_threshold_low_lower_limit': ldThresholdLowLowerLimit,
                                                            'ld_threshold_low_upper_limit': ldThresholdLowUpperLimit,
                                                            'ld_threshold_medium_lower_limit': ldThresholdMediumLowerLimit,
                                                            'ld_threshold_medium_upper_limit': ldThresholdMediumUpperLimit,
                                                            'limit': limit,
                                                            'log_request': logRequest,
                                                            'mask_enable': maskEnable,
                                                            'mask_type': maskType,
                                                            'mask_with': maskWith,
                                                            'max_retry_attempts': maxRetryAttempts,
                                                            'max_transit_limit': maxTransitLimit,
                                                            'metadata_key_history': metadataKeyHistory,
                                                            'metadata_keys': metadataKeys,
                                                            'nd_enable': ndEnable,
                                                            'nd_threshold': ndThreshold,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'output_format': outputFormat,
                                                            'primary_scope_name': primaryScopeName,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'slu_model': sluModel,
                                                            'state_max_retry_attempts': stateMaxRetryAttempts,
                                                            'su_enable': suEnable,
                                                            'su_language': suLanguage,
                                                            'su_shadow_mode_enable': suShadowModeEnable,
                                                            'su_threshold': suThreshold,
                                                            'template_config': templateConfig,
                                                            'template_version': templateVersion,
                                                            'tts_agents': ttsAgents,
                                                            'tts_ssml_tags': ttsSsmlTags,
                                                            'vca_host': vcaHost,
                                                            'version': version,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns FlowConfigCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsCreate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: FlowConfigCreate,
                                                }): CancelablePromise<FlowConfigCreate> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedFlowConfigSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static flowConfigBulkUpdate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    abTests,
                                                    accountAttributes,
                                                    allowCallback,
                                                    allowInteractionPostTransfer,
                                                    asrExecutionType,
                                                    asrList,
                                                    asrModel,
                                                    asrProvider,
                                                    audioFormat,
                                                    audioOverlayUrl,
                                                    baseUrl,
                                                    biBehaviour,
                                                    biEnable,
                                                    botResponseType,
                                                    businessConfig,
                                                    cachableKeys,
                                                    conditionalAsrs,
                                                    conditionalLanguages,
                                                    conditionalSluModels,
                                                    config,
                                                    createdAt,
                                                    createdBy,
                                                    defaultConditionalLanguage,
                                                    defaultIntent,
                                                    deletedBy,
                                                    enableKeyCaching,
                                                    enableVca,
                                                    encryptBotResponse,
                                                    encryptTranscript,
                                                    events,
                                                    eventsCompleted,
                                                    eventsPostCall,
                                                    excludeFields,
                                                    experimentConfig,
                                                    experimentTtsAgents,
                                                    fields,
                                                    flow,
                                                    isAsrService,
                                                    isDebugMode,
                                                    language,
                                                    languages,
                                                    lastModifiedAt,
                                                    lastModifiedBy,
                                                    ldConditionalEnable,
                                                    ldConsecutiveTurns,
                                                    ldEnable,
                                                    ldLanguages,
                                                    ldLimit,
                                                    ldShadow,
                                                    ldSlidsModel,
                                                    ldStates,
                                                    ldThresholdHighLowerLimit,
                                                    ldThresholdHighUpperLimit,
                                                    ldThresholdLowLowerLimit,
                                                    ldThresholdLowUpperLimit,
                                                    ldThresholdMediumLowerLimit,
                                                    ldThresholdMediumUpperLimit,
                                                    limit,
                                                    logRequest,
                                                    maskEnable,
                                                    maskType,
                                                    maskWith,
                                                    maxRetryAttempts,
                                                    maxTransitLimit,
                                                    metadataKeyHistory,
                                                    metadataKeys,
                                                    ndEnable,
                                                    ndThreshold,
                                                    offset,
                                                    ordering,
                                                    outputFormat,
                                                    primaryScopeName,
                                                    readDepth,
                                                    search,
                                                    sluModel,
                                                    stateMaxRetryAttempts,
                                                    suEnable,
                                                    suLanguage,
                                                    suShadowModeEnable,
                                                    suThreshold,
                                                    templateConfig,
                                                    templateVersion,
                                                    ttsAgents,
                                                    ttsSsmlTags,
                                                    ttsStorageType,
                                                    vcaHost,
                                                    version,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<FlowConfigSerializerWithRepr>,
                                                    abTests?: Array<string>,
                                                    accountAttributes?: Array<string>,
                                                    allowCallback?: Array<string>,
                                                    allowInteractionPostTransfer?: Array<string>,
                                                    asrExecutionType?: Array<string>,
                                                    asrList?: Array<string>,
                                                    asrModel?: Array<string>,
                                                    asrProvider?: Array<string>,
                                                    audioFormat?: Array<string>,
                                                    audioOverlayUrl?: Array<string>,
                                                    baseUrl?: Array<string>,
                                                    biBehaviour?: Array<string>,
                                                    biEnable?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    businessConfig?: Array<string>,
                                                    cachableKeys?: Array<string>,
                                                    conditionalAsrs?: Array<string>,
                                                    conditionalLanguages?: Array<string>,
                                                    conditionalSluModels?: Array<string>,
                                                    config?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    defaultConditionalLanguage?: Array<string>,
                                                    defaultIntent?: Array<string>,
                                                    deletedBy?: Array<string>,
                                                    enableKeyCaching?: Array<string>,
                                                    enableVca?: Array<string>,
                                                    encryptBotResponse?: Array<string>,
                                                    encryptTranscript?: Array<string>,
                                                    events?: Array<string>,
                                                    eventsCompleted?: Array<string>,
                                                    eventsPostCall?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    experimentConfig?: Array<string>,
                                                    experimentTtsAgents?: Array<string>,
                                                    fields?: Array<string>,
                                                    flow?: Array<string>,
                                                    isAsrService?: Array<string>,
                                                    isDebugMode?: Array<string>,
                                                    language?: Array<string>,
                                                    languages?: Array<string>,
                                                    lastModifiedAt?: Array<string>,
                                                    lastModifiedBy?: Array<string>,
                                                    ldConditionalEnable?: Array<string>,
                                                    ldConsecutiveTurns?: Array<string>,
                                                    ldEnable?: Array<string>,
                                                    ldLanguages?: Array<string>,
                                                    ldLimit?: Array<string>,
                                                    ldShadow?: Array<string>,
                                                    ldSlidsModel?: Array<string>,
                                                    ldStates?: Array<string>,
                                                    ldThresholdHighLowerLimit?: Array<string>,
                                                    ldThresholdHighUpperLimit?: Array<string>,
                                                    ldThresholdLowLowerLimit?: Array<string>,
                                                    ldThresholdLowUpperLimit?: Array<string>,
                                                    ldThresholdMediumLowerLimit?: Array<string>,
                                                    ldThresholdMediumUpperLimit?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    logRequest?: Array<string>,
                                                    maskEnable?: Array<string>,
                                                    maskType?: Array<string>,
                                                    maskWith?: Array<string>,
                                                    maxRetryAttempts?: Array<string>,
                                                    maxTransitLimit?: Array<string>,
                                                    metadataKeyHistory?: Array<string>,
                                                    metadataKeys?: Array<string>,
                                                    ndEnable?: Array<string>,
                                                    ndThreshold?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    outputFormat?: Array<string>,
                                                    primaryScopeName?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    sluModel?: Array<string>,
                                                    stateMaxRetryAttempts?: Array<string>,
                                                    suEnable?: Array<string>,
                                                    suLanguage?: Array<string>,
                                                    suShadowModeEnable?: Array<string>,
                                                    suThreshold?: Array<string>,
                                                    templateConfig?: Array<string>,
                                                    templateVersion?: Array<string>,
                                                    ttsAgents?: Array<string>,
                                                    ttsSsmlTags?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    vcaHost?: Array<string>,
                                                    version?: Array<string>,
                                                }): CancelablePromise<PaginatedFlowConfigSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'ab_tests': abTests,
                                                            'account_attributes': accountAttributes,
                                                            'allow_callback': allowCallback,
                                                            'allow_interaction_post_transfer': allowInteractionPostTransfer,
                                                            'asr_execution_type': asrExecutionType,
                                                            'asr_list': asrList,
                                                            'asr_model': asrModel,
                                                            'asr_provider': asrProvider,
                                                            'audio_format': audioFormat,
                                                            'audio_overlay_url': audioOverlayUrl,
                                                            'base_url': baseUrl,
                                                            'bi_behaviour': biBehaviour,
                                                            'bi_enable': biEnable,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'business_config': businessConfig,
                                                            'cachable_keys': cachableKeys,
                                                            'conditional_asrs': conditionalAsrs,
                                                            'conditional_languages': conditionalLanguages,
                                                            'conditional_slu_models': conditionalSluModels,
                                                            'config': config,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'default_conditional_language': defaultConditionalLanguage,
                                                            'default_intent': defaultIntent,
                                                            'deleted_by': deletedBy,
                                                            'enable_key_caching': enableKeyCaching,
                                                            'enable_vca': enableVca,
                                                            'encrypt_bot_response': encryptBotResponse,
                                                            'encrypt_transcript': encryptTranscript,
                                                            'events': events,
                                                            'events_completed': eventsCompleted,
                                                            'events_post_call': eventsPostCall,
                                                            'exclude-fields': excludeFields,
                                                            'experiment_config': experimentConfig,
                                                            'experiment_tts_agents': experimentTtsAgents,
                                                            'fields': fields,
                                                            'flow': flow,
                                                            'is_asr_service': isAsrService,
                                                            'is_debug_mode': isDebugMode,
                                                            'language': language,
                                                            'languages': languages,
                                                            'last_modified_at': lastModifiedAt,
                                                            'last_modified_by': lastModifiedBy,
                                                            'ld_conditional_enable': ldConditionalEnable,
                                                            'ld_consecutive_turns': ldConsecutiveTurns,
                                                            'ld_enable': ldEnable,
                                                            'ld_languages': ldLanguages,
                                                            'ld_limit': ldLimit,
                                                            'ld_shadow': ldShadow,
                                                            'ld_slids_model': ldSlidsModel,
                                                            'ld_states': ldStates,
                                                            'ld_threshold_high_lower_limit': ldThresholdHighLowerLimit,
                                                            'ld_threshold_high_upper_limit': ldThresholdHighUpperLimit,
                                                            'ld_threshold_low_lower_limit': ldThresholdLowLowerLimit,
                                                            'ld_threshold_low_upper_limit': ldThresholdLowUpperLimit,
                                                            'ld_threshold_medium_lower_limit': ldThresholdMediumLowerLimit,
                                                            'ld_threshold_medium_upper_limit': ldThresholdMediumUpperLimit,
                                                            'limit': limit,
                                                            'log_request': logRequest,
                                                            'mask_enable': maskEnable,
                                                            'mask_type': maskType,
                                                            'mask_with': maskWith,
                                                            'max_retry_attempts': maxRetryAttempts,
                                                            'max_transit_limit': maxTransitLimit,
                                                            'metadata_key_history': metadataKeyHistory,
                                                            'metadata_keys': metadataKeys,
                                                            'nd_enable': ndEnable,
                                                            'nd_threshold': ndThreshold,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'output_format': outputFormat,
                                                            'primary_scope_name': primaryScopeName,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'slu_model': sluModel,
                                                            'state_max_retry_attempts': stateMaxRetryAttempts,
                                                            'su_enable': suEnable,
                                                            'su_language': suLanguage,
                                                            'su_shadow_mode_enable': suShadowModeEnable,
                                                            'su_threshold': suThreshold,
                                                            'template_config': templateConfig,
                                                            'template_version': templateVersion,
                                                            'tts_agents': ttsAgents,
                                                            'tts_ssml_tags': ttsSsmlTags,
                                                            'vca_host': vcaHost,
                                                            'version': version,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedFlowConfigSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static flowConfigBulkPartialUpdate({
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    abTests,
                                                    accountAttributes,
                                                    allowCallback,
                                                    allowInteractionPostTransfer,
                                                    asrExecutionType,
                                                    asrList,
                                                    asrModel,
                                                    asrProvider,
                                                    audioFormat,
                                                    audioOverlayUrl,
                                                    baseUrl,
                                                    biBehaviour,
                                                    biEnable,
                                                    botResponseType,
                                                    businessConfig,
                                                    cachableKeys,
                                                    conditionalAsrs,
                                                    conditionalLanguages,
                                                    conditionalSluModels,
                                                    config,
                                                    createdAt,
                                                    createdBy,
                                                    defaultConditionalLanguage,
                                                    defaultIntent,
                                                    deletedBy,
                                                    enableKeyCaching,
                                                    enableVca,
                                                    encryptBotResponse,
                                                    encryptTranscript,
                                                    events,
                                                    eventsCompleted,
                                                    eventsPostCall,
                                                    excludeFields,
                                                    experimentConfig,
                                                    experimentTtsAgents,
                                                    fields,
                                                    flow,
                                                    isAsrService,
                                                    isDebugMode,
                                                    language,
                                                    languages,
                                                    lastModifiedAt,
                                                    lastModifiedBy,
                                                    ldConditionalEnable,
                                                    ldConsecutiveTurns,
                                                    ldEnable,
                                                    ldLanguages,
                                                    ldLimit,
                                                    ldShadow,
                                                    ldSlidsModel,
                                                    ldStates,
                                                    ldThresholdHighLowerLimit,
                                                    ldThresholdHighUpperLimit,
                                                    ldThresholdLowLowerLimit,
                                                    ldThresholdLowUpperLimit,
                                                    ldThresholdMediumLowerLimit,
                                                    ldThresholdMediumUpperLimit,
                                                    limit,
                                                    logRequest,
                                                    maskEnable,
                                                    maskType,
                                                    maskWith,
                                                    maxRetryAttempts,
                                                    maxTransitLimit,
                                                    metadataKeyHistory,
                                                    metadataKeys,
                                                    ndEnable,
                                                    ndThreshold,
                                                    offset,
                                                    ordering,
                                                    outputFormat,
                                                    primaryScopeName,
                                                    readDepth,
                                                    search,
                                                    sluModel,
                                                    stateMaxRetryAttempts,
                                                    suEnable,
                                                    suLanguage,
                                                    suShadowModeEnable,
                                                    suThreshold,
                                                    templateConfig,
                                                    templateVersion,
                                                    ttsAgents,
                                                    ttsSsmlTags,
                                                    ttsStorageType,
                                                    vcaHost,
                                                    version,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<FlowConfigSerializerWithRepr>,
                                                    abTests?: Array<string>,
                                                    accountAttributes?: Array<string>,
                                                    allowCallback?: Array<string>,
                                                    allowInteractionPostTransfer?: Array<string>,
                                                    asrExecutionType?: Array<string>,
                                                    asrList?: Array<string>,
                                                    asrModel?: Array<string>,
                                                    asrProvider?: Array<string>,
                                                    audioFormat?: Array<string>,
                                                    audioOverlayUrl?: Array<string>,
                                                    baseUrl?: Array<string>,
                                                    biBehaviour?: Array<string>,
                                                    biEnable?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    businessConfig?: Array<string>,
                                                    cachableKeys?: Array<string>,
                                                    conditionalAsrs?: Array<string>,
                                                    conditionalLanguages?: Array<string>,
                                                    conditionalSluModels?: Array<string>,
                                                    config?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    defaultConditionalLanguage?: Array<string>,
                                                    defaultIntent?: Array<string>,
                                                    deletedBy?: Array<string>,
                                                    enableKeyCaching?: Array<string>,
                                                    enableVca?: Array<string>,
                                                    encryptBotResponse?: Array<string>,
                                                    encryptTranscript?: Array<string>,
                                                    events?: Array<string>,
                                                    eventsCompleted?: Array<string>,
                                                    eventsPostCall?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    experimentConfig?: Array<string>,
                                                    experimentTtsAgents?: Array<string>,
                                                    fields?: Array<string>,
                                                    flow?: Array<string>,
                                                    isAsrService?: Array<string>,
                                                    isDebugMode?: Array<string>,
                                                    language?: Array<string>,
                                                    languages?: Array<string>,
                                                    lastModifiedAt?: Array<string>,
                                                    lastModifiedBy?: Array<string>,
                                                    ldConditionalEnable?: Array<string>,
                                                    ldConsecutiveTurns?: Array<string>,
                                                    ldEnable?: Array<string>,
                                                    ldLanguages?: Array<string>,
                                                    ldLimit?: Array<string>,
                                                    ldShadow?: Array<string>,
                                                    ldSlidsModel?: Array<string>,
                                                    ldStates?: Array<string>,
                                                    ldThresholdHighLowerLimit?: Array<string>,
                                                    ldThresholdHighUpperLimit?: Array<string>,
                                                    ldThresholdLowLowerLimit?: Array<string>,
                                                    ldThresholdLowUpperLimit?: Array<string>,
                                                    ldThresholdMediumLowerLimit?: Array<string>,
                                                    ldThresholdMediumUpperLimit?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    logRequest?: Array<string>,
                                                    maskEnable?: Array<string>,
                                                    maskType?: Array<string>,
                                                    maskWith?: Array<string>,
                                                    maxRetryAttempts?: Array<string>,
                                                    maxTransitLimit?: Array<string>,
                                                    metadataKeyHistory?: Array<string>,
                                                    metadataKeys?: Array<string>,
                                                    ndEnable?: Array<string>,
                                                    ndThreshold?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    outputFormat?: Array<string>,
                                                    primaryScopeName?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    sluModel?: Array<string>,
                                                    stateMaxRetryAttempts?: Array<string>,
                                                    suEnable?: Array<string>,
                                                    suLanguage?: Array<string>,
                                                    suShadowModeEnable?: Array<string>,
                                                    suThreshold?: Array<string>,
                                                    templateConfig?: Array<string>,
                                                    templateVersion?: Array<string>,
                                                    ttsAgents?: Array<string>,
                                                    ttsSsmlTags?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    vcaHost?: Array<string>,
                                                    version?: Array<string>,
                                                }): CancelablePromise<PaginatedFlowConfigSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'ab_tests': abTests,
                                                            'account_attributes': accountAttributes,
                                                            'allow_callback': allowCallback,
                                                            'allow_interaction_post_transfer': allowInteractionPostTransfer,
                                                            'asr_execution_type': asrExecutionType,
                                                            'asr_list': asrList,
                                                            'asr_model': asrModel,
                                                            'asr_provider': asrProvider,
                                                            'audio_format': audioFormat,
                                                            'audio_overlay_url': audioOverlayUrl,
                                                            'base_url': baseUrl,
                                                            'bi_behaviour': biBehaviour,
                                                            'bi_enable': biEnable,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'business_config': businessConfig,
                                                            'cachable_keys': cachableKeys,
                                                            'conditional_asrs': conditionalAsrs,
                                                            'conditional_languages': conditionalLanguages,
                                                            'conditional_slu_models': conditionalSluModels,
                                                            'config': config,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'default_conditional_language': defaultConditionalLanguage,
                                                            'default_intent': defaultIntent,
                                                            'deleted_by': deletedBy,
                                                            'enable_key_caching': enableKeyCaching,
                                                            'enable_vca': enableVca,
                                                            'encrypt_bot_response': encryptBotResponse,
                                                            'encrypt_transcript': encryptTranscript,
                                                            'events': events,
                                                            'events_completed': eventsCompleted,
                                                            'events_post_call': eventsPostCall,
                                                            'exclude-fields': excludeFields,
                                                            'experiment_config': experimentConfig,
                                                            'experiment_tts_agents': experimentTtsAgents,
                                                            'fields': fields,
                                                            'flow': flow,
                                                            'is_asr_service': isAsrService,
                                                            'is_debug_mode': isDebugMode,
                                                            'language': language,
                                                            'languages': languages,
                                                            'last_modified_at': lastModifiedAt,
                                                            'last_modified_by': lastModifiedBy,
                                                            'ld_conditional_enable': ldConditionalEnable,
                                                            'ld_consecutive_turns': ldConsecutiveTurns,
                                                            'ld_enable': ldEnable,
                                                            'ld_languages': ldLanguages,
                                                            'ld_limit': ldLimit,
                                                            'ld_shadow': ldShadow,
                                                            'ld_slids_model': ldSlidsModel,
                                                            'ld_states': ldStates,
                                                            'ld_threshold_high_lower_limit': ldThresholdHighLowerLimit,
                                                            'ld_threshold_high_upper_limit': ldThresholdHighUpperLimit,
                                                            'ld_threshold_low_lower_limit': ldThresholdLowLowerLimit,
                                                            'ld_threshold_low_upper_limit': ldThresholdLowUpperLimit,
                                                            'ld_threshold_medium_lower_limit': ldThresholdMediumLowerLimit,
                                                            'ld_threshold_medium_upper_limit': ldThresholdMediumUpperLimit,
                                                            'limit': limit,
                                                            'log_request': logRequest,
                                                            'mask_enable': maskEnable,
                                                            'mask_type': maskType,
                                                            'mask_with': maskWith,
                                                            'max_retry_attempts': maxRetryAttempts,
                                                            'max_transit_limit': maxTransitLimit,
                                                            'metadata_key_history': metadataKeyHistory,
                                                            'metadata_keys': metadataKeys,
                                                            'nd_enable': ndEnable,
                                                            'nd_threshold': ndThreshold,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'output_format': outputFormat,
                                                            'primary_scope_name': primaryScopeName,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'slu_model': sluModel,
                                                            'state_max_retry_attempts': stateMaxRetryAttempts,
                                                            'su_enable': suEnable,
                                                            'su_language': suLanguage,
                                                            'su_shadow_mode_enable': suShadowModeEnable,
                                                            'su_threshold': suThreshold,
                                                            'template_config': templateConfig,
                                                            'template_version': templateVersion,
                                                            'tts_agents': ttsAgents,
                                                            'tts_ssml_tags': ttsSsmlTags,
                                                            'vca_host': vcaHost,
                                                            'version': version,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static flowConfigBulkDestroy({
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/',
                                                        path: {
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * List actions
                                                 * @returns PaginatedActionListList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsActionsList({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    additionalRequestParameters,
                                                    content,
                                                    description,
                                                    endpoint,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    internalActionName,
                                                    isSensitive,
                                                    limit,
                                                    logRequest,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                    source,
                                                    type,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    additionalRequestParameters?: Array<string>,
                                                    content?: Array<string>,
                                                    description?: Array<string>,
                                                    endpoint?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    internalActionName?: Array<string>,
                                                    isSensitive?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    logRequest?: Array<string>,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    source?: Array<string>,
                                                    type?: Array<string>,
                                                }): CancelablePromise<PaginatedActionListList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/actions/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'additional_request_parameters': additionalRequestParameters,
                                                            'content': content,
                                                            'description': description,
                                                            'endpoint': endpoint,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'internal_action_name': internalActionName,
                                                            'is_sensitive': isSensitive,
                                                            'limit': limit,
                                                            'log_request': logRequest,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'source': source,
                                                            'type': type,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns ActionWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsActionsCreate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: ActionWriteSerializerWithRepr,
                                                }): CancelablePromise<ActionWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/actions/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedActionWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static actionBulkUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    additionalRequestParameters,
                                                    content,
                                                    description,
                                                    endpoint,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    internalActionName,
                                                    isSensitive,
                                                    limit,
                                                    logRequest,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                    source,
                                                    type,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<ActionWriteSerializerWithRepr>,
                                                    additionalRequestParameters?: Array<string>,
                                                    content?: Array<string>,
                                                    description?: Array<string>,
                                                    endpoint?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    internalActionName?: Array<string>,
                                                    isSensitive?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    logRequest?: Array<string>,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    source?: Array<string>,
                                                    type?: Array<string>,
                                                }): CancelablePromise<PaginatedActionWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/actions/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'additional_request_parameters': additionalRequestParameters,
                                                            'content': content,
                                                            'description': description,
                                                            'endpoint': endpoint,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'internal_action_name': internalActionName,
                                                            'is_sensitive': isSensitive,
                                                            'limit': limit,
                                                            'log_request': logRequest,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'source': source,
                                                            'type': type,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedActionWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static actionBulkPartialUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    additionalRequestParameters,
                                                    content,
                                                    description,
                                                    endpoint,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    internalActionName,
                                                    isSensitive,
                                                    limit,
                                                    logRequest,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                    source,
                                                    type,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<ActionWriteSerializerWithRepr>,
                                                    additionalRequestParameters?: Array<string>,
                                                    content?: Array<string>,
                                                    description?: Array<string>,
                                                    endpoint?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    internalActionName?: Array<string>,
                                                    isSensitive?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    logRequest?: Array<string>,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    source?: Array<string>,
                                                    type?: Array<string>,
                                                }): CancelablePromise<PaginatedActionWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/actions/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'additional_request_parameters': additionalRequestParameters,
                                                            'content': content,
                                                            'description': description,
                                                            'endpoint': endpoint,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'internal_action_name': internalActionName,
                                                            'is_sensitive': isSensitive,
                                                            'limit': limit,
                                                            'log_request': logRequest,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'source': source,
                                                            'type': type,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static actionBulkDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/actions/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns ActionRead
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsActionsRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    additionalRequestParameters,
                                                    content,
                                                    description,
                                                    endpoint,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    internalActionName,
                                                    isSensitive,
                                                    logRequest,
                                                    name,
                                                    readDepth,
                                                    source,
                                                    type,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this action.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    additionalRequestParameters?: Array<string>,
                                                    content?: Array<string>,
                                                    description?: Array<string>,
                                                    endpoint?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    internalActionName?: Array<string>,
                                                    isSensitive?: Array<string>,
                                                    logRequest?: Array<string>,
                                                    name?: Array<string>,
                                                    readDepth?: number,
                                                    source?: Array<string>,
                                                    type?: Array<string>,
                                                }): CancelablePromise<ActionRead> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/actions/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'additional_request_parameters': additionalRequestParameters,
                                                            'content': content,
                                                            'description': description,
                                                            'endpoint': endpoint,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'internal_action_name': internalActionName,
                                                            'is_sensitive': isSensitive,
                                                            'log_request': logRequest,
                                                            'name': name,
                                                            'read_depth': readDepth,
                                                            'source': source,
                                                            'type': type,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns ActionWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsActionsUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this action.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody: ActionWriteSerializerWithRepr,
                                                }): CancelablePromise<ActionWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/actions/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns ActionWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsActionsPartialUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this action.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedActionWriteSerializerWithRepr,
                                                }): CancelablePromise<ActionWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/actions/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsActionsDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this action.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/actions/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsAppPromptsRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/app_prompts/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsAppPromptsFilterAndSearchRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    block,
                                                    search,
                                                    subflow,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    block?: Array<number>,
                                                    search?: string,
                                                    subflow?: Array<number>,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/app_prompts/filter_and_search/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'block': block,
                                                            'search': search,
                                                            'subflow': subflow,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsAppPromptsResetAllPromptsDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/app_prompts/reset_all_prompts/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns any No response body
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsAppPromptsSaveUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody?: AppPromptBulkUpdate,
                                                }): CancelablePromise<any> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/app_prompts/save/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedBlockViewList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksList({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    appendLanguageToNlsmlKey,
                                                    asrEnabled,
                                                    asrExecutionType,
                                                    asrLang,
                                                    asrModel,
                                                    asrProvider,
                                                    biBehaviour,
                                                    biEnable,
                                                    biasForEntities,
                                                    biasForIntents,
                                                    botResponseType,
                                                    conditionalAsrModel,
                                                    conditionalAsrProvider,
                                                    conditionalContext,
                                                    conditionalPrompts,
                                                    conditionalSetIntent,
                                                    context,
                                                    description,
                                                    disableBeep,
                                                    dtmfMaxWaitTime,
                                                    enableAsync,
                                                    encryptBotResponse,
                                                    encryptTranscript,
                                                    endState,
                                                    entities,
                                                    entityMatchingMetadata,
                                                    entrypointBlock,
                                                    entrypointSubflow,
                                                    excludeFields,
                                                    excludeName,
                                                    excludeType,
                                                    fields,
                                                    fillSlotWebhook,
                                                    flowConfig,
                                                    ignoreAsCurrent,
                                                    infoWebhook,
                                                    intent,
                                                    isActionBased,
                                                    isDebugMode,
                                                    limit,
                                                    maxDigits,
                                                    maxInterDigitWaitTime,
                                                    firstDigitWaitTime,
                                                    maxRecordTime,
                                                    maxRetries,
                                                    metadataKeys,
                                                    minRecordTime,
                                                    name,
                                                    nlsmlKey,
                                                    offset,
                                                    ordering,
                                                    patience,
                                                    paymentCurrency,
                                                    paymentProvider,
                                                    paymentTimeout,
                                                    prompts,
                                                    readDepth,
                                                    regexPattern,
                                                    renderInfo,
                                                    saveInputToMetadataKey,
                                                    search,
                                                    setIntent,
                                                    setLanguage,
                                                    setMetadata,
                                                    setMetadataJson,
                                                    setTags,
                                                    silenceThreshold,
                                                    sluModel,
                                                    suEnable,
                                                    suLanguage,
                                                    suShadowModeEnable,
                                                    suThreshold,
                                                    subflow,
                                                    transferIpAddress,
                                                    transferMetadata,
                                                    transferPhoneNumber,
                                                    trigger,
                                                    ttsStorageType,
                                                    type,
                                                    validationWebhook,
                                                    visitLimit,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    appendLanguageToNlsmlKey?: Array<string>,
                                                    asrEnabled?: Array<string>,
                                                    asrExecutionType?: Array<string>,
                                                    asrLang?: Array<string>,
                                                    asrModel?: Array<string>,
                                                    asrProvider?: Array<string>,
                                                    biBehaviour?: Array<string>,
                                                    biEnable?: Array<string>,
                                                    biasForEntities?: Array<string>,
                                                    biasForIntents?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    conditionalAsrModel?: Array<string>,
                                                    conditionalAsrProvider?: Array<string>,
                                                    conditionalContext?: Array<string>,
                                                    conditionalPrompts?: Array<string>,
                                                    conditionalSetIntent?: Array<string>,
                                                    context?: Array<string>,
                                                    description?: Array<string>,
                                                    disableBeep?: Array<string>,
                                                    dtmfMaxWaitTime?: Array<string>,
                                                    enableAsync?: Array<string>,
                                                    encryptBotResponse?: Array<string>,
                                                    encryptTranscript?: Array<string>,
                                                    endState?: Array<string>,
                                                    entities?: Array<string>,
                                                    entityMatchingMetadata?: Array<string>,
                                                    entrypointBlock?: Array<string>,
                                                    entrypointSubflow?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    excludeName?: Array<string>,
                                                    excludeType?: Array<string>,
                                                    fields?: Array<string>,
                                                    fillSlotWebhook?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    ignoreAsCurrent?: Array<string>,
                                                    infoWebhook?: Array<string>,
                                                    intent?: Array<string>,
                                                    isActionBased?: Array<string>,
                                                    isDebugMode?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    maxDigits?: Array<string>,
                                                    maxInterDigitWaitTime?: Array<string>,
                                                    firstDigitWaitTime?: Array<string>,
                                                    maxRecordTime?: Array<string>,
                                                    maxRetries?: Array<string>,
                                                    metadataKeys?: Array<string>,
                                                    minRecordTime?: Array<string>,
                                                    name?: Array<string>,
                                                    nlsmlKey?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    patience?: Array<string>,
                                                    paymentCurrency?: Array<string>,
                                                    paymentProvider?: Array<string>,
                                                    paymentTimeout?: Array<string>,
                                                    prompts?: Array<string>,
                                                    readDepth?: number,
                                                    regexPattern?: Array<string>,
                                                    renderInfo?: Array<string>,
                                                    saveInputToMetadataKey?: Array<string>,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    setIntent?: Array<string>,
                                                    setLanguage?: Array<string>,
                                                    setMetadata?: Array<string>,
                                                    setMetadataJson?: Array<string>,
                                                    setTags?: Array<string>,
                                                    silenceThreshold?: Array<string>,
                                                    sluModel?: Array<string>,
                                                    suEnable?: Array<string>,
                                                    suLanguage?: Array<string>,
                                                    suShadowModeEnable?: Array<string>,
                                                    suThreshold?: Array<string>,
                                                    subflow?: Array<string>,
                                                    transferIpAddress?: Array<string>,
                                                    transferMetadata?: Array<string>,
                                                    transferPhoneNumber?: Array<string>,
                                                    trigger?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    type?: Array<string>,
                                                    validationWebhook?: Array<string>,
                                                    visitLimit?: Array<string>,
                                                }): CancelablePromise<PaginatedBlockViewList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'append_language_to_nlsml_key': appendLanguageToNlsmlKey,
                                                            'asr_enabled': asrEnabled,
                                                            'asr_execution_type': asrExecutionType,
                                                            'asr_lang': asrLang,
                                                            'asr_model': asrModel,
                                                            'asr_provider': asrProvider,
                                                            'bi_behaviour': biBehaviour,
                                                            'bi_enable': biEnable,
                                                            'bias_for_entities': biasForEntities,
                                                            'bias_for_intents': biasForIntents,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'conditional_asr_model': conditionalAsrModel,
                                                            'conditional_asr_provider': conditionalAsrProvider,
                                                            'conditional_context': conditionalContext,
                                                            'conditional_prompts': conditionalPrompts,
                                                            'conditional_set_intent': conditionalSetIntent,
                                                            'context': context,
                                                            'description': description,
                                                            'disable_beep': disableBeep,
                                                            'dtmf_max_wait_time': dtmfMaxWaitTime,
                                                            'enable_async': enableAsync,
                                                            'encrypt_bot_response': encryptBotResponse,
                                                            'encrypt_transcript': encryptTranscript,
                                                            'end_state': endState,
                                                            'entities': entities,
                                                            'entity_matching_metadata': entityMatchingMetadata,
                                                            'entrypoint_block': entrypointBlock,
                                                            'entrypoint_subflow': entrypointSubflow,
                                                            'exclude-fields': excludeFields,
                                                            'exclude__name': excludeName,
                                                            'exclude__type': excludeType,
                                                            'fields': fields,
                                                            'fill_slot_webhook': fillSlotWebhook,
                                                            'flow_config': flowConfig,
                                                            'ignore_as_current': ignoreAsCurrent,
                                                            'info_webhook': infoWebhook,
                                                            'intent': intent,
                                                            'is_action_based': isActionBased,
                                                            'is_debug_mode': isDebugMode,
                                                            'limit': limit,
                                                            'max_digits': maxDigits,
                                                            'max_inter_digit_wait_time': maxInterDigitWaitTime,
                                                            'first_digit_time': firstDigitWaitTime,
                                                            'max_record_time': maxRecordTime,
                                                            'max_retries': maxRetries,
                                                            'metadata_keys': metadataKeys,
                                                            'min_record_time': minRecordTime,
                                                            'name': name,
                                                            'nlsml_key': nlsmlKey,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'patience': patience,
                                                            'payment_currency': paymentCurrency,
                                                            'payment_provider': paymentProvider,
                                                            'payment_timeout': paymentTimeout,
                                                            'prompts': prompts,
                                                            'read_depth': readDepth,
                                                            'regex_pattern': regexPattern,
                                                            'render_info': renderInfo,
                                                            'save_input_to_metadata_key': saveInputToMetadataKey,
                                                            'search': search,
                                                            'set_intent': setIntent,
                                                            'set_language': setLanguage,
                                                            'set_metadata': setMetadata,
                                                            'set_metadata_json': setMetadataJson,
                                                            'set_tags': setTags,
                                                            'silence_threshold': silenceThreshold,
                                                            'slu_model': sluModel,
                                                            'su_enable': suEnable,
                                                            'su_language': suLanguage,
                                                            'su_shadow_mode_enable': suShadowModeEnable,
                                                            'su_threshold': suThreshold,
                                                            'subflow': subflow,
                                                            'transfer_ip_address': transferIpAddress,
                                                            'transfer_metadata': transferMetadata,
                                                            'transfer_phone_number': transferPhoneNumber,
                                                            'trigger': trigger,
                                                            'type': type,
                                                            'validation_webhook': validationWebhook,
                                                            'visit_limit': visitLimit,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns BlockCreate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksCreate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: BlockCreate,
                                                }): CancelablePromise<BlockCreate> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedBlockCreateSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static blockBulkUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    appendLanguageToNlsmlKey,
                                                    asrEnabled,
                                                    asrExecutionType,
                                                    asrLang,
                                                    asrModel,
                                                    asrProvider,
                                                    biBehaviour,
                                                    biEnable,
                                                    biasForEntities,
                                                    biasForIntents,
                                                    botResponseType,
                                                    conditionalAsrModel,
                                                    conditionalAsrProvider,
                                                    conditionalContext,
                                                    conditionalPrompts,
                                                    conditionalSetIntent,
                                                    context,
                                                    description,
                                                    disableBeep,
                                                    dtmfMaxWaitTime,
                                                    enableAsync,
                                                    encryptBotResponse,
                                                    encryptTranscript,
                                                    endState,
                                                    entities,
                                                    entityMatchingMetadata,
                                                    entrypointBlock,
                                                    entrypointSubflow,
                                                    excludeFields,
                                                    excludeName,
                                                    excludeType,
                                                    fields,
                                                    fillSlotWebhook,
                                                    flowConfig,
                                                    ignoreAsCurrent,
                                                    infoWebhook,
                                                    intent,
                                                    isActionBased,
                                                    isDebugMode,
                                                    limit,
                                                    maxDigits,
                                                    maxInterDigitWaitTime,
                                                    firstDigitWaitTime,
                                                    maxRecordTime,
                                                    maxRetries,
                                                    metadataKeys,
                                                    minRecordTime,
                                                    name,
                                                    nlsmlKey,
                                                    offset,
                                                    ordering,
                                                    patience,
                                                    paymentCurrency,
                                                    paymentProvider,
                                                    paymentTimeout,
                                                    prompts,
                                                    readDepth,
                                                    regexPattern,
                                                    renderInfo,
                                                    saveInputToMetadataKey,
                                                    search,
                                                    setIntent,
                                                    setLanguage,
                                                    setMetadata,
                                                    setMetadataJson,
                                                    setTags,
                                                    silenceThreshold,
                                                    sluModel,
                                                    suEnable,
                                                    suLanguage,
                                                    suShadowModeEnable,
                                                    suThreshold,
                                                    subflow,
                                                    transferIpAddress,
                                                    transferMetadata,
                                                    transferPhoneNumber,
                                                    trigger,
                                                    ttsStorageType,
                                                    type,
                                                    validationWebhook,
                                                    visitLimit,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<BlockCreateSerializerWithRepr>,
                                                    appendLanguageToNlsmlKey?: Array<string>,
                                                    asrEnabled?: Array<string>,
                                                    asrExecutionType?: Array<string>,
                                                    asrLang?: Array<string>,
                                                    asrModel?: Array<string>,
                                                    asrProvider?: Array<string>,
                                                    biBehaviour?: Array<string>,
                                                    biEnable?: Array<string>,
                                                    biasForEntities?: Array<string>,
                                                    biasForIntents?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    conditionalAsrModel?: Array<string>,
                                                    conditionalAsrProvider?: Array<string>,
                                                    conditionalContext?: Array<string>,
                                                    conditionalPrompts?: Array<string>,
                                                    conditionalSetIntent?: Array<string>,
                                                    context?: Array<string>,
                                                    description?: Array<string>,
                                                    disableBeep?: Array<string>,
                                                    dtmfMaxWaitTime?: Array<string>,
                                                    enableAsync?: Array<string>,
                                                    encryptBotResponse?: Array<string>,
                                                    encryptTranscript?: Array<string>,
                                                    endState?: Array<string>,
                                                    entities?: Array<string>,
                                                    entityMatchingMetadata?: Array<string>,
                                                    entrypointBlock?: Array<string>,
                                                    entrypointSubflow?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    excludeName?: Array<string>,
                                                    excludeType?: Array<string>,
                                                    fields?: Array<string>,
                                                    fillSlotWebhook?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    ignoreAsCurrent?: Array<string>,
                                                    infoWebhook?: Array<string>,
                                                    intent?: Array<string>,
                                                    isActionBased?: Array<string>,
                                                    isDebugMode?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    maxDigits?: Array<string>,
                                                    maxInterDigitWaitTime?: Array<string>,
                                                    firstDigitWaitTime?: Array<string>,
                                                    maxRecordTime?: Array<string>,
                                                    maxRetries?: Array<string>,
                                                    metadataKeys?: Array<string>,
                                                    minRecordTime?: Array<string>,
                                                    name?: Array<string>,
                                                    nlsmlKey?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    patience?: Array<string>,
                                                    paymentCurrency?: Array<string>,
                                                    paymentProvider?: Array<string>,
                                                    paymentTimeout?: Array<string>,
                                                    prompts?: Array<string>,
                                                    readDepth?: number,
                                                    regexPattern?: Array<string>,
                                                    renderInfo?: Array<string>,
                                                    saveInputToMetadataKey?: Array<string>,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    setIntent?: Array<string>,
                                                    setLanguage?: Array<string>,
                                                    setMetadata?: Array<string>,
                                                    setMetadataJson?: Array<string>,
                                                    setTags?: Array<string>,
                                                    silenceThreshold?: Array<string>,
                                                    sluModel?: Array<string>,
                                                    suEnable?: Array<string>,
                                                    suLanguage?: Array<string>,
                                                    suShadowModeEnable?: Array<string>,
                                                    suThreshold?: Array<string>,
                                                    subflow?: Array<string>,
                                                    transferIpAddress?: Array<string>,
                                                    transferMetadata?: Array<string>,
                                                    transferPhoneNumber?: Array<string>,
                                                    trigger?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    type?: Array<string>,
                                                    validationWebhook?: Array<string>,
                                                    visitLimit?: Array<string>,
                                                }): CancelablePromise<PaginatedBlockCreateSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'append_language_to_nlsml_key': appendLanguageToNlsmlKey,
                                                            'asr_enabled': asrEnabled,
                                                            'asr_execution_type': asrExecutionType,
                                                            'asr_lang': asrLang,
                                                            'asr_model': asrModel,
                                                            'asr_provider': asrProvider,
                                                            'bi_behaviour': biBehaviour,
                                                            'bi_enable': biEnable,
                                                            'bias_for_entities': biasForEntities,
                                                            'bias_for_intents': biasForIntents,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'conditional_asr_model': conditionalAsrModel,
                                                            'conditional_asr_provider': conditionalAsrProvider,
                                                            'conditional_context': conditionalContext,
                                                            'conditional_prompts': conditionalPrompts,
                                                            'conditional_set_intent': conditionalSetIntent,
                                                            'context': context,
                                                            'description': description,
                                                            'disable_beep': disableBeep,
                                                            'dtmf_max_wait_time': dtmfMaxWaitTime,
                                                            'enable_async': enableAsync,
                                                            'encrypt_bot_response': encryptBotResponse,
                                                            'encrypt_transcript': encryptTranscript,
                                                            'end_state': endState,
                                                            'entities': entities,
                                                            'entity_matching_metadata': entityMatchingMetadata,
                                                            'entrypoint_block': entrypointBlock,
                                                            'entrypoint_subflow': entrypointSubflow,
                                                            'exclude-fields': excludeFields,
                                                            'exclude__name': excludeName,
                                                            'exclude__type': excludeType,
                                                            'fields': fields,
                                                            'fill_slot_webhook': fillSlotWebhook,
                                                            'flow_config': flowConfig,
                                                            'ignore_as_current': ignoreAsCurrent,
                                                            'info_webhook': infoWebhook,
                                                            'intent': intent,
                                                            'is_action_based': isActionBased,
                                                            'is_debug_mode': isDebugMode,
                                                            'limit': limit,
                                                            'max_digits': maxDigits,
                                                            'max_inter_digit_wait_time': maxInterDigitWaitTime,
                                                            'first_digit_wait_time': firstDigitWaitTime,
                                                            'max_record_time': maxRecordTime,
                                                            'max_retries': maxRetries,
                                                            'metadata_keys': metadataKeys,
                                                            'min_record_time': minRecordTime,
                                                            'name': name,
                                                            'nlsml_key': nlsmlKey,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'patience': patience,
                                                            'payment_currency': paymentCurrency,
                                                            'payment_provider': paymentProvider,
                                                            'payment_timeout': paymentTimeout,
                                                            'prompts': prompts,
                                                            'read_depth': readDepth,
                                                            'regex_pattern': regexPattern,
                                                            'render_info': renderInfo,
                                                            'save_input_to_metadata_key': saveInputToMetadataKey,
                                                            'search': search,
                                                            'set_intent': setIntent,
                                                            'set_language': setLanguage,
                                                            'set_metadata': setMetadata,
                                                            'set_metadata_json': setMetadataJson,
                                                            'set_tags': setTags,
                                                            'silence_threshold': silenceThreshold,
                                                            'slu_model': sluModel,
                                                            'su_enable': suEnable,
                                                            'su_language': suLanguage,
                                                            'su_shadow_mode_enable': suShadowModeEnable,
                                                            'su_threshold': suThreshold,
                                                            'subflow': subflow,
                                                            'transfer_ip_address': transferIpAddress,
                                                            'transfer_metadata': transferMetadata,
                                                            'transfer_phone_number': transferPhoneNumber,
                                                            'trigger': trigger,
                                                            'type': type,
                                                            'validation_webhook': validationWebhook,
                                                            'visit_limit': visitLimit,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedBlockCreateSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static blockBulkPartialUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    appendLanguageToNlsmlKey,
                                                    asrEnabled,
                                                    asrExecutionType,
                                                    asrLang,
                                                    asrModel,
                                                    asrProvider,
                                                    biBehaviour,
                                                    biEnable,
                                                    biasForEntities,
                                                    biasForIntents,
                                                    botResponseType,
                                                    conditionalAsrModel,
                                                    conditionalAsrProvider,
                                                    conditionalContext,
                                                    conditionalPrompts,
                                                    conditionalSetIntent,
                                                    context,
                                                    description,
                                                    disableBeep,
                                                    dtmfMaxWaitTime,
                                                    enableAsync,
                                                    encryptBotResponse,
                                                    encryptTranscript,
                                                    endState,
                                                    entities,
                                                    entityMatchingMetadata,
                                                    entrypointBlock,
                                                    entrypointSubflow,
                                                    excludeFields,
                                                    excludeName,
                                                    excludeType,
                                                    fields,
                                                    fillSlotWebhook,
                                                    flowConfig,
                                                    ignoreAsCurrent,
                                                    infoWebhook,
                                                    intent,
                                                    isActionBased,
                                                    isDebugMode,
                                                    limit,
                                                    maxDigits,
                                                    maxInterDigitWaitTime,
                                                    firstDigitWaitTime,
                                                    maxRecordTime,
                                                    maxRetries,
                                                    metadataKeys,
                                                    minRecordTime,
                                                    name,
                                                    nlsmlKey,
                                                    offset,
                                                    ordering,
                                                    patience,
                                                    paymentCurrency,
                                                    paymentProvider,
                                                    paymentTimeout,
                                                    prompts,
                                                    readDepth,
                                                    regexPattern,
                                                    renderInfo,
                                                    saveInputToMetadataKey,
                                                    search,
                                                    setIntent,
                                                    setLanguage,
                                                    setMetadata,
                                                    setMetadataJson,
                                                    setTags,
                                                    silenceThreshold,
                                                    sluModel,
                                                    suEnable,
                                                    suLanguage,
                                                    suShadowModeEnable,
                                                    suThreshold,
                                                    subflow,
                                                    transferIpAddress,
                                                    transferMetadata,
                                                    transferPhoneNumber,
                                                    trigger,
                                                    ttsStorageType,
                                                    type,
                                                    validationWebhook,
                                                    visitLimit,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<BlockCreateSerializerWithRepr>,
                                                    appendLanguageToNlsmlKey?: Array<string>,
                                                    asrEnabled?: Array<string>,
                                                    asrExecutionType?: Array<string>,
                                                    asrLang?: Array<string>,
                                                    asrModel?: Array<string>,
                                                    asrProvider?: Array<string>,
                                                    biBehaviour?: Array<string>,
                                                    biEnable?: Array<string>,
                                                    biasForEntities?: Array<string>,
                                                    biasForIntents?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    conditionalAsrModel?: Array<string>,
                                                    conditionalAsrProvider?: Array<string>,
                                                    conditionalContext?: Array<string>,
                                                    conditionalPrompts?: Array<string>,
                                                    conditionalSetIntent?: Array<string>,
                                                    context?: Array<string>,
                                                    description?: Array<string>,
                                                    disableBeep?: Array<string>,
                                                    dtmfMaxWaitTime?: Array<string>,
                                                    enableAsync?: Array<string>,
                                                    encryptBotResponse?: Array<string>,
                                                    encryptTranscript?: Array<string>,
                                                    endState?: Array<string>,
                                                    entities?: Array<string>,
                                                    entityMatchingMetadata?: Array<string>,
                                                    entrypointBlock?: Array<string>,
                                                    entrypointSubflow?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    excludeName?: Array<string>,
                                                    excludeType?: Array<string>,
                                                    fields?: Array<string>,
                                                    fillSlotWebhook?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    ignoreAsCurrent?: Array<string>,
                                                    infoWebhook?: Array<string>,
                                                    intent?: Array<string>,
                                                    isActionBased?: Array<string>,
                                                    isDebugMode?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    maxDigits?: Array<string>,
                                                    maxInterDigitWaitTime?: Array<string>
                                                    firstDigitWaitTime?: Array<string>
                                                    maxRecordTime?: Array<string>,
                                                    maxRetries?: Array<string>,
                                                    metadataKeys?: Array<string>,
                                                    minRecordTime?: Array<string>,
                                                    name?: Array<string>,
                                                    nlsmlKey?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    patience?: Array<string>,
                                                    paymentCurrency?: Array<string>,
                                                    paymentProvider?: Array<string>,
                                                    paymentTimeout?: Array<string>,
                                                    prompts?: Array<string>,
                                                    readDepth?: number,
                                                    regexPattern?: Array<string>,
                                                    renderInfo?: Array<string>,
                                                    saveInputToMetadataKey?: Array<string>,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    setIntent?: Array<string>,
                                                    setLanguage?: Array<string>,
                                                    setMetadata?: Array<string>,
                                                    setMetadataJson?: Array<string>,
                                                    setTags?: Array<string>,
                                                    silenceThreshold?: Array<string>,
                                                    sluModel?: Array<string>,
                                                    suEnable?: Array<string>,
                                                    suLanguage?: Array<string>,
                                                    suShadowModeEnable?: Array<string>,
                                                    suThreshold?: Array<string>,
                                                    subflow?: Array<string>,
                                                    transferIpAddress?: Array<string>,
                                                    transferMetadata?: Array<string>,
                                                    transferPhoneNumber?: Array<string>,
                                                    trigger?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    type?: Array<string>,
                                                    validationWebhook?: Array<string>,
                                                    visitLimit?: Array<string>,
                                                }): CancelablePromise<PaginatedBlockCreateSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'append_language_to_nlsml_key': appendLanguageToNlsmlKey,
                                                            'asr_enabled': asrEnabled,
                                                            'asr_execution_type': asrExecutionType,
                                                            'asr_lang': asrLang,
                                                            'asr_model': asrModel,
                                                            'asr_provider': asrProvider,
                                                            'bi_behaviour': biBehaviour,
                                                            'bi_enable': biEnable,
                                                            'bias_for_entities': biasForEntities,
                                                            'bias_for_intents': biasForIntents,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'conditional_asr_model': conditionalAsrModel,
                                                            'conditional_asr_provider': conditionalAsrProvider,
                                                            'conditional_context': conditionalContext,
                                                            'conditional_prompts': conditionalPrompts,
                                                            'conditional_set_intent': conditionalSetIntent,
                                                            'context': context,
                                                            'description': description,
                                                            'disable_beep': disableBeep,
                                                            'dtmf_': dtmfMaxWaitTime,
                                                            'enable_async': enableAsync,
                                                            'encrypt_bot_response': encryptBotResponse,
                                                            'encrypt_transcript': encryptTranscript,
                                                            'end_state': endState,
                                                            'entities': entities,
                                                            'entity_matching_metadata': entityMatchingMetadata,
                                                            'entrypoint_block': entrypointBlock,
                                                            'entrypoint_subflow': entrypointSubflow,
                                                            'exclude-fields': excludeFields,
                                                            'exclude__name': excludeName,
                                                            'exclude__type': excludeType,
                                                            'fields': fields,
                                                            'fill_slot_webhook': fillSlotWebhook,
                                                            'flow_config': flowConfig,
                                                            'ignore_as_current': ignoreAsCurrent,
                                                            'info_webhook': infoWebhook,
                                                            'intent': intent,
                                                            'is_action_based': isActionBased,
                                                            'is_debug_mode': isDebugMode,
                                                            'limit': limit,
                                                            'max_digits': maxDigits,
                                                            'max_inter_digit_wait_time': maxInterDigitWaitTime,
                                                            'first_digit_wait_time': firstDigitWaitTime,
                                                            'max_record_time': maxRecordTime,
                                                            'max_retries': maxRetries,
                                                            'metadata_keys': metadataKeys,
                                                            'min_record_time': minRecordTime,
                                                            'name': name,
                                                            'nlsml_key': nlsmlKey,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'patience': patience,
                                                            'payment_currency': paymentCurrency,
                                                            'payment_provider': paymentProvider,
                                                            'payment_timeout': paymentTimeout,
                                                            'prompts': prompts,
                                                            'read_depth': readDepth,
                                                            'regex_pattern': regexPattern,
                                                            'render_info': renderInfo,
                                                            'save_input_to_metadata_key': saveInputToMetadataKey,
                                                            'search': search,
                                                            'set_intent': setIntent,
                                                            'set_language': setLanguage,
                                                            'set_metadata': setMetadata,
                                                            'set_metadata_json': setMetadataJson,
                                                            'set_tags': setTags,
                                                            'silence_threshold': silenceThreshold,
                                                            'slu_model': sluModel,
                                                            'su_enable': suEnable,
                                                            'su_language': suLanguage,
                                                            'su_shadow_mode_enable': suShadowModeEnable,
                                                            'su_threshold': suThreshold,
                                                            'subflow': subflow,
                                                            'transfer_ip_address': transferIpAddress,
                                                            'transfer_metadata': transferMetadata,
                                                            'transfer_phone_number': transferPhoneNumber,
                                                            'trigger': trigger,
                                                            'type': type,
                                                            'validation_webhook': validationWebhook,
                                                            'visit_limit': visitLimit,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static blockBulkDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCommentReadList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksCommentsList({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    limit,
                                                    objectId,
                                                    offset,
                                                    ordering,
                                                    parent,
                                                    readDepth,
                                                    search,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    objectId?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<PaginatedCommentReadList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/comments/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'limit': limit,
                                                            'object_id': objectId,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CommentWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksCommentsCreate({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: CommentWriteSerializerWithRepr,
                                                }): CancelablePromise<CommentWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/comments/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCommentWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static commentBulkUpdate2({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    limit,
                                                    objectId,
                                                    offset,
                                                    ordering,
                                                    parent,
                                                    readDepth,
                                                    search,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<CommentWriteSerializerWithRepr>,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    objectId?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<PaginatedCommentWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/comments/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'limit': limit,
                                                            'object_id': objectId,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCommentWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static commentBulkPartialUpdate2({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    limit,
                                                    objectId,
                                                    offset,
                                                    ordering,
                                                    parent,
                                                    readDepth,
                                                    search,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<CommentWriteSerializerWithRepr>,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    objectId?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<PaginatedCommentWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/comments/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'limit': limit,
                                                            'object_id': objectId,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static commentBulkDestroy2({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/comments/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CommentRead
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksCommentsRetrieve({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    objectId,
                                                    parent,
                                                    readDepth,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    objectId?: Array<string>,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<CommentRead> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/comments/{id}/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'object_id': objectId,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CommentWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksCommentsUpdate({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody: CommentWriteSerializerWithRepr,
                                                }): CancelablePromise<CommentWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/comments/{id}/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns CommentWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksCommentsPartialUpdate({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedCommentWriteSerializerWithRepr,
                                                }): CancelablePromise<CommentWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/comments/{id}/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksCommentsDestroy({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/comments/{id}/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedEntityListList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksEntitiesList({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    excludeFields,
                                                    fields,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                    types,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    types?: Array<string>,
                                                }): CancelablePromise<PaginatedEntityListList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/entities/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'types': types,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns EntityWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksEntitiesCreate({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: EntityWriteSerializerWithRepr,
                                                }): CancelablePromise<EntityWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/entities/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedEntityWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static entityBulkUpdate2({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    excludeFields,
                                                    fields,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                    types,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<EntityWriteSerializerWithRepr>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    types?: Array<string>,
                                                }): CancelablePromise<PaginatedEntityWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/entities/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'types': types,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedEntityWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static entityBulkPartialUpdate2({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    excludeFields,
                                                    fields,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                    types,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<EntityWriteSerializerWithRepr>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    types?: Array<string>,
                                                }): CancelablePromise<PaginatedEntityWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/entities/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'types': types,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static entityBulkDestroy2({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/entities/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns EntityRead
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksEntitiesRetrieve({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    excludeFields,
                                                    fields,
                                                    name,
                                                    readDepth,
                                                    types,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this entity.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    name?: Array<string>,
                                                    readDepth?: number,
                                                    types?: Array<string>,
                                                }): CancelablePromise<EntityRead> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/entities/{id}/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'name': name,
                                                            'read_depth': readDepth,
                                                            'types': types,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns EntityWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksEntitiesUpdate({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this entity.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody: EntityWriteSerializerWithRepr,
                                                }): CancelablePromise<EntityWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/entities/{id}/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns EntityWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksEntitiesPartialUpdate({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this entity.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedEntityWriteSerializerWithRepr,
                                                }): CancelablePromise<EntityWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/entities/{id}/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksEntitiesDestroy({
                                                    blockPk,
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    blockPk: string,
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this entity.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{block_pk}/entities/{id}/',
                                                        path: {
                                                            'block_pk': blockPk,
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns BlockView
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    appendLanguageToNlsmlKey,
                                                    asrEnabled,
                                                    asrExecutionType,
                                                    asrLang,
                                                    asrModel,
                                                    asrProvider,
                                                    biBehaviour,
                                                    biEnable,
                                                    biasForEntities,
                                                    biasForIntents,
                                                    botResponseType,
                                                    conditionalAsrModel,
                                                    conditionalAsrProvider,
                                                    conditionalContext,
                                                    conditionalPrompts,
                                                    conditionalSetIntent,
                                                    context,
                                                    description,
                                                    disableBeep,
                                                    dtmfMaxWaitTime,
                                                    enableAsync,
                                                    encryptBotResponse,
                                                    encryptTranscript,
                                                    endState,
                                                    entities,
                                                    entityMatchingMetadata,
                                                    entrypointBlock,
                                                    entrypointSubflow,
                                                    excludeFields,
                                                    fields,
                                                    fillSlotWebhook,
                                                    flowConfig,
                                                    ignoreAsCurrent,
                                                    infoWebhook,
                                                    intent,
                                                    isActionBased,
                                                    isDebugMode,
                                                    maxDigits,
                                                    maxInterDigitWaitTime,
                                                    firstDigitWaitTime,
                                                    maxRecordTime,
                                                    maxRetries,
                                                    metadataKeys,
                                                    minRecordTime,
                                                    name,
                                                    nlsmlKey,
                                                    patience,
                                                    paymentCurrency,
                                                    paymentProvider,
                                                    paymentTimeout,
                                                    prompts,
                                                    readDepth,
                                                    regexPattern,
                                                    renderInfo,
                                                    saveInputToMetadataKey,
                                                    setIntent,
                                                    setLanguage,
                                                    setMetadata,
                                                    setMetadataJson,
                                                    setTags,
                                                    silenceThreshold,
                                                    sluModel,
                                                    suEnable,
                                                    suLanguage,
                                                    suShadowModeEnable,
                                                    suThreshold,
                                                    subflow,
                                                    transferIpAddress,
                                                    transferMetadata,
                                                    transferPhoneNumber,
                                                    trigger,
                                                    ttsStorageType,
                                                    type,
                                                    validationWebhook,
                                                    visitLimit,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this block.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    appendLanguageToNlsmlKey?: Array<string>,
                                                    asrEnabled?: Array<string>,
                                                    asrExecutionType?: Array<string>,
                                                    asrLang?: Array<string>,
                                                    asrModel?: Array<string>,
                                                    asrProvider?: Array<string>,
                                                    biBehaviour?: Array<string>,
                                                    biEnable?: Array<string>,
                                                    biasForEntities?: Array<string>,
                                                    biasForIntents?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    conditionalAsrModel?: Array<string>,
                                                    conditionalAsrProvider?: Array<string>,
                                                    conditionalContext?: Array<string>,
                                                    conditionalPrompts?: Array<string>,
                                                    conditionalSetIntent?: Array<string>,
                                                    context?: Array<string>,
                                                    description?: Array<string>,
                                                    disableBeep?: Array<string>,
                                                    dtmfMaxWaitTime?: Array<string>,
                                                    enableAsync?: Array<string>,
                                                    encryptBotResponse?: Array<string>,
                                                    encryptTranscript?: Array<string>,
                                                    endState?: Array<string>,
                                                    entities?: Array<string>,
                                                    entityMatchingMetadata?: Array<string>,
                                                    entrypointBlock?: Array<string>,
                                                    entrypointSubflow?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    fillSlotWebhook?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    ignoreAsCurrent?: Array<string>,
                                                    infoWebhook?: Array<string>,
                                                    intent?: Array<string>,
                                                    isActionBased?: Array<string>,
                                                    isDebugMode?: Array<string>,
                                                    maxDigits?: Array<string>,
                                                    maxInterDigitWaitTime?: Array<string>,
                                                    firstDigitWaitTime?: Array<string>,
                                                    maxRecordTime?: Array<string>,
                                                    maxRetries?: Array<string>,
                                                    metadataKeys?: Array<string>,
                                                    minRecordTime?: Array<string>,
                                                    name?: Array<string>,
                                                    nlsmlKey?: Array<string>,
                                                    patience?: Array<string>,
                                                    paymentCurrency?: Array<string>,
                                                    paymentProvider?: Array<string>,
                                                    paymentTimeout?: Array<string>,
                                                    prompts?: Array<string>,
                                                    readDepth?: number,
                                                    regexPattern?: Array<string>,
                                                    renderInfo?: Array<string>,
                                                    saveInputToMetadataKey?: Array<string>,
                                                    setIntent?: Array<string>,
                                                    setLanguage?: Array<string>,
                                                    setMetadata?: Array<string>,
                                                    setMetadataJson?: Array<string>,
                                                    setTags?: Array<string>,
                                                    silenceThreshold?: Array<string>,
                                                    sluModel?: Array<string>,
                                                    suEnable?: Array<string>,
                                                    suLanguage?: Array<string>,
                                                    suShadowModeEnable?: Array<string>,
                                                    suThreshold?: Array<string>,
                                                    subflow?: Array<string>,
                                                    transferIpAddress?: Array<string>,
                                                    transferMetadata?: Array<string>,
                                                    transferPhoneNumber?: Array<string>,
                                                    trigger?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    type?: Array<string>,
                                                    validationWebhook?: Array<string>,
                                                    visitLimit?: Array<string>,
                                                }): CancelablePromise<BlockView> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'append_language_to_nlsml_key': appendLanguageToNlsmlKey,
                                                            'asr_enabled': asrEnabled,
                                                            'asr_execution_type': asrExecutionType,
                                                            'asr_lang': asrLang,
                                                            'asr_model': asrModel,
                                                            'asr_provider': asrProvider,
                                                            'bi_behaviour': biBehaviour,
                                                            'bi_enable': biEnable,
                                                            'bias_for_entities': biasForEntities,
                                                            'bias_for_intents': biasForIntents,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'conditional_asr_model': conditionalAsrModel,
                                                            'conditional_asr_provider': conditionalAsrProvider,
                                                            'conditional_context': conditionalContext,
                                                            'conditional_prompts': conditionalPrompts,
                                                            'conditional_set_intent': conditionalSetIntent,
                                                            'context': context,
                                                            'description': description,
                                                            'disable_beep': disableBeep,
                                                            'dtmf_max_wait_time': dtmfMaxWaitTime,
                                                            'enable_async': enableAsync,
                                                            'encrypt_bot_response': encryptBotResponse,
                                                            'encrypt_transcript': encryptTranscript,
                                                            'end_state': endState,
                                                            'entities': entities,
                                                            'entity_matching_metadata': entityMatchingMetadata,
                                                            'entrypoint_block': entrypointBlock,
                                                            'entrypoint_subflow': entrypointSubflow,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'fill_slot_webhook': fillSlotWebhook,
                                                            'flow_config': flowConfig,
                                                            'ignore_as_current': ignoreAsCurrent,
                                                            'info_webhook': infoWebhook,
                                                            'intent': intent,
                                                            'is_action_based': isActionBased,
                                                            'is_debug_mode': isDebugMode,
                                                            'max_digits': maxDigits,
                                                            'max_inter_digit_wait_time': maxInterDigitWaitTime,
                                                            'first_digit_wait_time': firstDigitWaitTime,
                                                            'max_record_time': maxRecordTime,
                                                            'max_retries': maxRetries,
                                                            'metadata_keys': metadataKeys,
                                                            'min_record_time': minRecordTime,
                                                            'name': name,
                                                            'nlsml_key': nlsmlKey,
                                                            'patience': patience,
                                                            'payment_currency': paymentCurrency,
                                                            'payment_provider': paymentProvider,
                                                            'payment_timeout': paymentTimeout,
                                                            'prompts': prompts,
                                                            'read_depth': readDepth,
                                                            'regex_pattern': regexPattern,
                                                            'render_info': renderInfo,
                                                            'save_input_to_metadata_key': saveInputToMetadataKey,
                                                            'set_intent': setIntent,
                                                            'set_language': setLanguage,
                                                            'set_metadata': setMetadata,
                                                            'set_metadata_json': setMetadataJson,
                                                            'set_tags': setTags,
                                                            'silence_threshold': silenceThreshold,
                                                            'slu_model': sluModel,
                                                            'su_enable': suEnable,
                                                            'su_language': suLanguage,
                                                            'su_shadow_mode_enable': suShadowModeEnable,
                                                            'su_threshold': suThreshold,
                                                            'subflow': subflow,
                                                            'transfer_ip_address': transferIpAddress,
                                                            'transfer_metadata': transferMetadata,
                                                            'transfer_phone_number': transferPhoneNumber,
                                                            'trigger': trigger,
                                                            'type': type,
                                                            'validation_webhook': validationWebhook,
                                                            'visit_limit': visitLimit,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns BlockUpdate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this block.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody: BlockUpdate,
                                                }): CancelablePromise<BlockUpdate> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns BlockUpdate
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksPartialUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this block.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedBlockUpdate,
                                                }): CancelablePromise<BlockUpdate> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this block.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns BlockView
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksUndeleteRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this block.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<BlockView> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/{id}/undelete/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns BlockView
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsBlocksBulkUndeleteRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<BlockView> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/blocks/bulk_undelete/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedPathViewList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsList({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    additionalPrompts,
                                                    botResponseType,
                                                    breachFallbackBlock,
                                                    completelyFill,
                                                    conditionalPrompts,
                                                    conditionalSetIntent,
                                                    defaultPath,
                                                    destinationBlock,
                                                    destinationBlockNull,
                                                    displayInGlobalList,
                                                    excludeFields,
                                                    fields,
                                                    fillEntity,
                                                    fillFromMetadata,
                                                    flowConfig,
                                                    hide,
                                                    ignoreAsCurrentIntent,
                                                    intent,
                                                    limit,
                                                    mimicIntent,
                                                    mimicTrigger,
                                                    name,
                                                    offset,
                                                    order,
                                                    ordering,
                                                    override,
                                                    partiallyFilled,
                                                    readDepth,
                                                    renderInfo,
                                                    retries,
                                                    search,
                                                    setIntent,
                                                    setLanguage,
                                                    setMetadata,
                                                    setMetadataJson,
                                                    sourceBlock,
                                                    sourceBlockSubflow,
                                                    transitionType,
                                                    trigger,
                                                    ttsStorageType,
                                                    userInputExample,
                                                    validate,
                                                    visitLimit,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    additionalPrompts?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    breachFallbackBlock?: Array<string>,
                                                    completelyFill?: Array<string>,
                                                    conditionalPrompts?: Array<string>,
                                                    conditionalSetIntent?: Array<string>,
                                                    defaultPath?: Array<string>,
                                                    destinationBlock?: Array<string>,
                                                    destinationBlockNull?: Array<string>,
                                                    displayInGlobalList?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    fillEntity?: Array<string>,
                                                    fillFromMetadata?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    hide?: Array<string>,
                                                    ignoreAsCurrentIntent?: Array<string>,
                                                    intent?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    mimicIntent?: Array<string>,
                                                    mimicTrigger?: Array<string>,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    order?: Array<string>,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    override?: Array<string>,
                                                    partiallyFilled?: Array<string>,
                                                    readDepth?: number,
                                                    renderInfo?: Array<string>,
                                                    retries?: Array<string>,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    setIntent?: Array<string>,
                                                    setLanguage?: Array<string>,
                                                    setMetadata?: Array<string>,
                                                    setMetadataJson?: Array<string>,
                                                    sourceBlock?: Array<string>,
                                                    sourceBlockSubflow?: Array<string>,
                                                    transitionType?: Array<string>,
                                                    trigger?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    userInputExample?: Array<string>,
                                                    validate?: Array<string>,
                                                    visitLimit?: Array<string>,
                                                }): CancelablePromise<PaginatedPathViewList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'additional_prompts': additionalPrompts,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'breach_fallback_block': breachFallbackBlock,
                                                            'completely_fill': completelyFill,
                                                            'conditional_prompts': conditionalPrompts,
                                                            'conditional_set_intent': conditionalSetIntent,
                                                            'default_path': defaultPath,
                                                            'destination_block': destinationBlock,
                                                            'destination_block__null': destinationBlockNull,
                                                            'display_in_global_list': displayInGlobalList,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'fill_entity': fillEntity,
                                                            'fill_from_metadata': fillFromMetadata,
                                                            'flow_config': flowConfig,
                                                            'hide': hide,
                                                            'ignore_as_current_intent': ignoreAsCurrentIntent,
                                                            'intent': intent,
                                                            'limit': limit,
                                                            'mimic_intent': mimicIntent,
                                                            'mimic_trigger': mimicTrigger,
                                                            'name': name,
                                                            'offset': offset,
                                                            'order': order,
                                                            'ordering': ordering,
                                                            'override': override,
                                                            'partially_filled': partiallyFilled,
                                                            'read_depth': readDepth,
                                                            'render_info': renderInfo,
                                                            'retries': retries,
                                                            'search': search,
                                                            'set_intent': setIntent,
                                                            'set_language': setLanguage,
                                                            'set_metadata': setMetadata,
                                                            'set_metadata_json': setMetadataJson,
                                                            'source_block': sourceBlock,
                                                            'source_block__subflow': sourceBlockSubflow,
                                                            'transition_type': transitionType,
                                                            'trigger': trigger,
                                                            'user_input_example': userInputExample,
                                                            'validate': validate,
                                                            'visit_limit': visitLimit,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PathSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsCreate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: PathSerializerWithRepr,
                                                }): CancelablePromise<PathSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedPathList
                                                 * @throws ApiError
                                                 */
                                                public static pathBulkUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    additionalPrompts,
                                                    botResponseType,
                                                    breachFallbackBlock,
                                                    completelyFill,
                                                    conditionalPrompts,
                                                    conditionalSetIntent,
                                                    defaultPath,
                                                    destinationBlock,
                                                    destinationBlockNull,
                                                    displayInGlobalList,
                                                    excludeFields,
                                                    fields,
                                                    fillEntity,
                                                    fillFromMetadata,
                                                    flowConfig,
                                                    hide,
                                                    ignoreAsCurrentIntent,
                                                    intent,
                                                    limit,
                                                    mimicIntent,
                                                    mimicTrigger,
                                                    name,
                                                    offset,
                                                    order,
                                                    ordering,
                                                    override,
                                                    partiallyFilled,
                                                    readDepth,
                                                    renderInfo,
                                                    retries,
                                                    search,
                                                    setIntent,
                                                    setLanguage,
                                                    setMetadata,
                                                    setMetadataJson,
                                                    sourceBlock,
                                                    sourceBlockSubflow,
                                                    transitionType,
                                                    trigger,
                                                    ttsStorageType,
                                                    userInputExample,
                                                    validate,
                                                    visitLimit,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<Path>,
                                                    additionalPrompts?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    breachFallbackBlock?: Array<string>,
                                                    completelyFill?: Array<string>,
                                                    conditionalPrompts?: Array<string>,
                                                    conditionalSetIntent?: Array<string>,
                                                    defaultPath?: Array<string>,
                                                    destinationBlock?: Array<string>,
                                                    destinationBlockNull?: Array<string>,
                                                    displayInGlobalList?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    fillEntity?: Array<string>,
                                                    fillFromMetadata?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    hide?: Array<string>,
                                                    ignoreAsCurrentIntent?: Array<string>,
                                                    intent?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    mimicIntent?: Array<string>,
                                                    mimicTrigger?: Array<string>,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    order?: Array<string>,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    override?: Array<string>,
                                                    partiallyFilled?: Array<string>,
                                                    readDepth?: number,
                                                    renderInfo?: Array<string>,
                                                    retries?: Array<string>,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    setIntent?: Array<string>,
                                                    setLanguage?: Array<string>,
                                                    setMetadata?: Array<string>,
                                                    setMetadataJson?: Array<string>,
                                                    sourceBlock?: Array<string>,
                                                    sourceBlockSubflow?: Array<string>,
                                                    transitionType?: Array<string>,
                                                    trigger?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    userInputExample?: Array<string>,
                                                    validate?: Array<string>,
                                                    visitLimit?: Array<string>,
                                                }): CancelablePromise<PaginatedPathList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'additional_prompts': additionalPrompts,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'breach_fallback_block': breachFallbackBlock,
                                                            'completely_fill': completelyFill,
                                                            'conditional_prompts': conditionalPrompts,
                                                            'conditional_set_intent': conditionalSetIntent,
                                                            'default_path': defaultPath,
                                                            'destination_block': destinationBlock,
                                                            'destination_block__null': destinationBlockNull,
                                                            'display_in_global_list': displayInGlobalList,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'fill_entity': fillEntity,
                                                            'fill_from_metadata': fillFromMetadata,
                                                            'flow_config': flowConfig,
                                                            'hide': hide,
                                                            'ignore_as_current_intent': ignoreAsCurrentIntent,
                                                            'intent': intent,
                                                            'limit': limit,
                                                            'mimic_intent': mimicIntent,
                                                            'mimic_trigger': mimicTrigger,
                                                            'name': name,
                                                            'offset': offset,
                                                            'order': order,
                                                            'ordering': ordering,
                                                            'override': override,
                                                            'partially_filled': partiallyFilled,
                                                            'read_depth': readDepth,
                                                            'render_info': renderInfo,
                                                            'retries': retries,
                                                            'search': search,
                                                            'set_intent': setIntent,
                                                            'set_language': setLanguage,
                                                            'set_metadata': setMetadata,
                                                            'set_metadata_json': setMetadataJson,
                                                            'source_block': sourceBlock,
                                                            'source_block__subflow': sourceBlockSubflow,
                                                            'transition_type': transitionType,
                                                            'trigger': trigger,
                                                            'user_input_example': userInputExample,
                                                            'validate': validate,
                                                            'visit_limit': visitLimit,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedPathSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static pathBulkPartialUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    additionalPrompts,
                                                    botResponseType,
                                                    breachFallbackBlock,
                                                    completelyFill,
                                                    conditionalPrompts,
                                                    conditionalSetIntent,
                                                    defaultPath,
                                                    destinationBlock,
                                                    destinationBlockNull,
                                                    displayInGlobalList,
                                                    excludeFields,
                                                    fields,
                                                    fillEntity,
                                                    fillFromMetadata,
                                                    flowConfig,
                                                    hide,
                                                    ignoreAsCurrentIntent,
                                                    intent,
                                                    limit,
                                                    mimicIntent,
                                                    mimicTrigger,
                                                    name,
                                                    offset,
                                                    order,
                                                    ordering,
                                                    override,
                                                    partiallyFilled,
                                                    readDepth,
                                                    renderInfo,
                                                    retries,
                                                    search,
                                                    setIntent,
                                                    setLanguage,
                                                    setMetadata,
                                                    setMetadataJson,
                                                    sourceBlock,
                                                    sourceBlockSubflow,
                                                    transitionType,
                                                    trigger,
                                                    ttsStorageType,
                                                    userInputExample,
                                                    validate,
                                                    visitLimit,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<PathSerializerWithRepr>,
                                                    additionalPrompts?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    breachFallbackBlock?: Array<string>,
                                                    completelyFill?: Array<string>,
                                                    conditionalPrompts?: Array<string>,
                                                    conditionalSetIntent?: Array<string>,
                                                    defaultPath?: Array<string>,
                                                    destinationBlock?: Array<string>,
                                                    destinationBlockNull?: Array<string>,
                                                    displayInGlobalList?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    fillEntity?: Array<string>,
                                                    fillFromMetadata?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    hide?: Array<string>,
                                                    ignoreAsCurrentIntent?: Array<string>,
                                                    intent?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    mimicIntent?: Array<string>,
                                                    mimicTrigger?: Array<string>,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    order?: Array<string>,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    override?: Array<string>,
                                                    partiallyFilled?: Array<string>,
                                                    readDepth?: number,
                                                    renderInfo?: Array<string>,
                                                    retries?: Array<string>,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    setIntent?: Array<string>,
                                                    setLanguage?: Array<string>,
                                                    setMetadata?: Array<string>,
                                                    setMetadataJson?: Array<string>,
                                                    sourceBlock?: Array<string>,
                                                    sourceBlockSubflow?: Array<string>,
                                                    transitionType?: Array<string>,
                                                    trigger?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    userInputExample?: Array<string>,
                                                    validate?: Array<string>,
                                                    visitLimit?: Array<string>,
                                                }): CancelablePromise<PaginatedPathSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'additional_prompts': additionalPrompts,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'breach_fallback_block': breachFallbackBlock,
                                                            'completely_fill': completelyFill,
                                                            'conditional_prompts': conditionalPrompts,
                                                            'conditional_set_intent': conditionalSetIntent,
                                                            'default_path': defaultPath,
                                                            'destination_block': destinationBlock,
                                                            'destination_block__null': destinationBlockNull,
                                                            'display_in_global_list': displayInGlobalList,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'fill_entity': fillEntity,
                                                            'fill_from_metadata': fillFromMetadata,
                                                            'flow_config': flowConfig,
                                                            'hide': hide,
                                                            'ignore_as_current_intent': ignoreAsCurrentIntent,
                                                            'intent': intent,
                                                            'limit': limit,
                                                            'mimic_intent': mimicIntent,
                                                            'mimic_trigger': mimicTrigger,
                                                            'name': name,
                                                            'offset': offset,
                                                            'order': order,
                                                            'ordering': ordering,
                                                            'override': override,
                                                            'partially_filled': partiallyFilled,
                                                            'read_depth': readDepth,
                                                            'render_info': renderInfo,
                                                            'retries': retries,
                                                            'search': search,
                                                            'set_intent': setIntent,
                                                            'set_language': setLanguage,
                                                            'set_metadata': setMetadata,
                                                            'set_metadata_json': setMetadataJson,
                                                            'source_block': sourceBlock,
                                                            'source_block__subflow': sourceBlockSubflow,
                                                            'transition_type': transitionType,
                                                            'trigger': trigger,
                                                            'user_input_example': userInputExample,
                                                            'validate': validate,
                                                            'visit_limit': visitLimit,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static pathBulkDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCommentReadList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsCommentsList({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    pathPk,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    limit,
                                                    objectId,
                                                    offset,
                                                    ordering,
                                                    parent,
                                                    readDepth,
                                                    search,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    pathPk: string,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    objectId?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<PaginatedCommentReadList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{path_pk}/comments/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                            'path_pk': pathPk,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'limit': limit,
                                                            'object_id': objectId,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CommentWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsCommentsCreate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    pathPk,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    pathPk: string,
                                                    requestBody: CommentWriteSerializerWithRepr,
                                                }): CancelablePromise<CommentWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{path_pk}/comments/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                            'path_pk': pathPk,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCommentWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static commentBulkUpdate3({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    pathPk,
                                                    requestBody,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    limit,
                                                    objectId,
                                                    offset,
                                                    ordering,
                                                    parent,
                                                    readDepth,
                                                    search,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    pathPk: string,
                                                    requestBody: Array<CommentWriteSerializerWithRepr>,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    objectId?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<PaginatedCommentWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{path_pk}/comments/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                            'path_pk': pathPk,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'limit': limit,
                                                            'object_id': objectId,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedCommentWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static commentBulkPartialUpdate3({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    pathPk,
                                                    requestBody,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    limit,
                                                    objectId,
                                                    offset,
                                                    ordering,
                                                    parent,
                                                    readDepth,
                                                    search,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    pathPk: string,
                                                    requestBody: Array<CommentWriteSerializerWithRepr>,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    objectId?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<PaginatedCommentWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{path_pk}/comments/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                            'path_pk': pathPk,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'limit': limit,
                                                            'object_id': objectId,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static commentBulkDestroy3({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    pathPk,
                                                    id,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    pathPk: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{path_pk}/comments/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                            'path_pk': pathPk,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CommentRead
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsCommentsRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    pathPk,
                                                    contentType,
                                                    createdAt,
                                                    createdBy,
                                                    excludeFields,
                                                    fields,
                                                    isResolved,
                                                    objectId,
                                                    parent,
                                                    readDepth,
                                                    text,
                                                    updatedAt,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    pathPk: string,
                                                    contentType?: Array<string>,
                                                    createdAt?: Array<string>,
                                                    createdBy?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    isResolved?: Array<string>,
                                                    objectId?: Array<string>,
                                                    parent?: Array<string>,
                                                    readDepth?: number,
                                                    text?: Array<string>,
                                                    updatedAt?: Array<string>,
                                                }): CancelablePromise<CommentRead> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{path_pk}/comments/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                            'path_pk': pathPk,
                                                        },
                                                        query: {
                                                            'content_type': contentType,
                                                            'created_at': createdAt,
                                                            'created_by': createdBy,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'is_resolved': isResolved,
                                                            'object_id': objectId,
                                                            'parent': parent,
                                                            'read_depth': readDepth,
                                                            'text': text,
                                                            'updated_at': updatedAt,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns CommentWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsCommentsUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    pathPk,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    pathPk: string,
                                                    requestBody: CommentWriteSerializerWithRepr,
                                                }): CancelablePromise<CommentWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{path_pk}/comments/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                            'path_pk': pathPk,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns CommentWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsCommentsPartialUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    pathPk,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    pathPk: string,
                                                    requestBody?: PatchedCommentWriteSerializerWithRepr,
                                                }): CancelablePromise<CommentWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{path_pk}/comments/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                            'path_pk': pathPk,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsCommentsDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    pathPk,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    id: string,
                                                    organisationUuid: string,
                                                    pathPk: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{path_pk}/comments/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                            'path_pk': pathPk,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PathView
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    additionalPrompts,
                                                    botResponseType,
                                                    breachFallbackBlock,
                                                    completelyFill,
                                                    conditionalPrompts,
                                                    conditionalSetIntent,
                                                    defaultPath,
                                                    destinationBlock,
                                                    displayInGlobalList,
                                                    excludeFields,
                                                    fields,
                                                    fillEntity,
                                                    fillFromMetadata,
                                                    flowConfig,
                                                    hide,
                                                    ignoreAsCurrentIntent,
                                                    intent,
                                                    mimicIntent,
                                                    mimicTrigger,
                                                    name,
                                                    order,
                                                    override,
                                                    partiallyFilled,
                                                    readDepth,
                                                    renderInfo,
                                                    retries,
                                                    setIntent,
                                                    setLanguage,
                                                    setMetadata,
                                                    setMetadataJson,
                                                    sourceBlock,
                                                    transitionType,
                                                    trigger,
                                                    ttsStorageType,
                                                    userInputExample,
                                                    validate,
                                                    visitLimit,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this path.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    additionalPrompts?: Array<string>,
                                                    botResponseType?: Array<string>,
                                                    breachFallbackBlock?: Array<string>,
                                                    completelyFill?: Array<string>,
                                                    conditionalPrompts?: Array<string>,
                                                    conditionalSetIntent?: Array<string>,
                                                    defaultPath?: Array<string>,
                                                    destinationBlock?: Array<string>,
                                                    displayInGlobalList?: Array<string>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    fillEntity?: Array<string>,
                                                    fillFromMetadata?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    hide?: Array<string>,
                                                    ignoreAsCurrentIntent?: Array<string>,
                                                    intent?: Array<string>,
                                                    mimicIntent?: Array<string>,
                                                    mimicTrigger?: Array<string>,
                                                    name?: Array<string>,
                                                    order?: Array<string>,
                                                    override?: Array<string>,
                                                    partiallyFilled?: Array<string>,
                                                    readDepth?: number,
                                                    renderInfo?: Array<string>,
                                                    retries?: Array<string>,
                                                    setIntent?: Array<string>,
                                                    setLanguage?: Array<string>,
                                                    setMetadata?: Array<string>,
                                                    setMetadataJson?: Array<string>,
                                                    sourceBlock?: Array<string>,
                                                    transitionType?: Array<string>,
                                                    trigger?: Array<string>,
                                                    ttsStorageType?: Array<string>,
                                                    userInputExample?: Array<string>,
                                                    validate?: Array<string>,
                                                    visitLimit?: Array<string>,
                                                }): CancelablePromise<PathView> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'additional_prompts': additionalPrompts,
                                                            'bot_response_type': botResponseType,
                                                            'tts_storage_type': ttsStorageType,
                                                            'breach_fallback_block': breachFallbackBlock,
                                                            'completely_fill': completelyFill,
                                                            'conditional_prompts': conditionalPrompts,
                                                            'conditional_set_intent': conditionalSetIntent,
                                                            'default_path': defaultPath,
                                                            'destination_block': destinationBlock,
                                                            'display_in_global_list': displayInGlobalList,
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'fill_entity': fillEntity,
                                                            'fill_from_metadata': fillFromMetadata,
                                                            'flow_config': flowConfig,
                                                            'hide': hide,
                                                            'ignore_as_current_intent': ignoreAsCurrentIntent,
                                                            'intent': intent,
                                                            'mimic_intent': mimicIntent,
                                                            'mimic_trigger': mimicTrigger,
                                                            'name': name,
                                                            'order': order,
                                                            'override': override,
                                                            'partially_filled': partiallyFilled,
                                                            'read_depth': readDepth,
                                                            'render_info': renderInfo,
                                                            'retries': retries,
                                                            'set_intent': setIntent,
                                                            'set_language': setLanguage,
                                                            'set_metadata': setMetadata,
                                                            'set_metadata_json': setMetadataJson,
                                                            'source_block': sourceBlock,
                                                            'transition_type': transitionType,
                                                            'trigger': trigger,
                                                            'user_input_example': userInputExample,
                                                            'validate': validate,
                                                            'visit_limit': visitLimit,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PathSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this path.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody: PathSerializerWithRepr,
                                                }): CancelablePromise<PathSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PathSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsPartialUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this path.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedPathSerializerWithRepr,
                                                }): CancelablePromise<PathSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this path.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PathView
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsUndeleteRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this path.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<PathView> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/{id}/undelete/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PathView
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPathsBulkUndeleteRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<PathView> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/paths/bulk_undelete/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedPromptPhrasesListList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPromptPhrasesList({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    language,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    phrases,
                                                    readDepth,
                                                    search,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    language?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    phrases?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                }): CancelablePromise<PaginatedPromptPhrasesListList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompt-phrases/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'language': language,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'phrases': phrases,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PromptPhrasesWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPromptPhrasesCreate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: PromptPhrasesWriteSerializerWithRepr,
                                                }): CancelablePromise<PromptPhrasesWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompt-phrases/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedPromptPhrasesWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static promptPhrasesBulkUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    language,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    phrases,
                                                    readDepth,
                                                    search,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<PromptPhrasesWriteSerializerWithRepr>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    language?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    phrases?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                }): CancelablePromise<PaginatedPromptPhrasesWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompt-phrases/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'language': language,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'phrases': phrases,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedPromptPhrasesWriteSerializerWithReprList
                                                 * @throws ApiError
                                                 */
                                                public static promptPhrasesBulkPartialUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    language,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    phrases,
                                                    readDepth,
                                                    search,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: Array<PromptPhrasesWriteSerializerWithRepr>,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    language?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    phrases?: Array<string>,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                }): CancelablePromise<PaginatedPromptPhrasesWriteSerializerWithReprList> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompt-phrases/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'language': language,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'phrases': phrases,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static promptPhrasesBulkDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    id,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    id?: Array<number>,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompt-phrases/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'id': id,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PromptPhrasesRead
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPromptPhrasesRetrieve({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    language,
                                                    name,
                                                    phrases,
                                                    readDepth,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this prompt phrases.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    language?: Array<string>,
                                                    name?: Array<string>,
                                                    phrases?: Array<string>,
                                                    readDepth?: number,
                                                }): CancelablePromise<PromptPhrasesRead> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompt-phrases/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'language': language,
                                                            'name': name,
                                                            'phrases': phrases,
                                                            'read_depth': readDepth,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PromptPhrasesWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPromptPhrasesUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this prompt phrases.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody: PromptPhrasesWriteSerializerWithRepr,
                                                }): CancelablePromise<PromptPhrasesWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PUT',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompt-phrases/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns PromptPhrasesWriteSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPromptPhrasesPartialUpdate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this prompt phrases.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                    requestBody?: PatchedPromptPhrasesWriteSerializerWithRepr,
                                                }): CancelablePromise<PromptPhrasesWriteSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'PATCH',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompt-phrases/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * @returns void
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPromptPhrasesDestroy({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    id,
                                                    organisationUuid,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    /**
                                                     * A unique integer value identifying this prompt phrases.
                                                     */
                                                    id: number,
                                                    organisationUuid: string,
                                                }): CancelablePromise<void> {
                                                    return __request(OpenAPI, {
                                                        method: 'DELETE',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompt-phrases/{id}/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'id': id,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PaginatedPromptViewList
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPromptsList({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    excludeFields,
                                                    fields,
                                                    flowConfig,
                                                    limit,
                                                    name,
                                                    offset,
                                                    ordering,
                                                    readDepth,
                                                    search,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    excludeFields?: Array<string>,
                                                    fields?: Array<string>,
                                                    flowConfig?: Array<string>,
                                                    /**
                                                     * Number of results to return per page.
                                                     */
                                                    limit?: number,
                                                    name?: Array<string>,
                                                    /**
                                                     * The initial index from which to return the results.
                                                     */
                                                    offset?: number,
                                                    /**
                                                     * Which field to use when ordering the results.
                                                     */
                                                    ordering?: string,
                                                    readDepth?: number,
                                                    /**
                                                     * A search term.
                                                     */
                                                    search?: string,
                                                }): CancelablePromise<PaginatedPromptViewList> {
                                                    return __request(OpenAPI, {
                                                        method: 'GET',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        query: {
                                                            'exclude-fields': excludeFields,
                                                            'fields': fields,
                                                            'flow_config': flowConfig,
                                                            'limit': limit,
                                                            'name': name,
                                                            'offset': offset,
                                                            'ordering': ordering,
                                                            'read_depth': readDepth,
                                                            'search': search,
                                                        },
                                                    });
                                                }
                                                /**
                                                 * @returns PromptSerializerWithRepr
                                                 * @throws ApiError
                                                 */
                                                public static organisationsFlowsVersionsPromptsCreate({
                                                    flowConfigVersion,
                                                    flowUuid,
                                                    organisationUuid,
                                                    requestBody,
                                                }: {
                                                    flowConfigVersion: string,
                                                    flowUuid: string,
                                                    organisationUuid: string,
                                                    requestBody: PromptSerializerWithRepr,
                                                }): CancelablePromise<PromptSerializerWithRepr> {
                                                    return __request(OpenAPI, {
                                                        method: 'POST',
                                                        url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/',
                                                        path: {
                                                            'flow_config_version': flowConfigVersion,
                                                            'flow_uuid': flowUuid,
                                                            'organisation_uuid': organisationUuid,
                                                        },
                                                        body: requestBody,
                                                        mediaType: 'application/json',
                                                    });
                                                }
                                                /**
                                                 * Format:
                                                 * [{
                                                     * "id": 1 | null,
                                                     * "name": "SOME_NLS_KEY",
                                                     * "prompts": [{
                                                         * "language": 1,
                                                         * "content": "Some content",
                                                         * "type": "TTS"
                                                         * }]
                                                         * }]
                                                         * @returns PromptSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<PromptBulkUpdate>,
                                                        }): CancelablePromise<PromptSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedPromptSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static promptBulkPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<PromptSerializerWithRepr>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                        }): CancelablePromise<PaginatedPromptSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static promptBulkDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            id,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            id?: Array<number>,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'id': id,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PromptView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            name,
                                                            readDepth,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            name?: Array<string>,
                                                            readDepth?: number,
                                                        }): CancelablePromise<PromptView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'name': name,
                                                                    'read_depth': readDepth,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PromptSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsUpdate2({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody: PromptSerializerWithRepr,
                                                        }): CancelablePromise<PromptSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PromptSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody?: PatchedPromptSerializerWithRepr,
                                                        }): CancelablePromise<PromptSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedPromptContentViewList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsPromptContentsList({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            promptPk,
                                                            content,
                                                            createdAt,
                                                            excludeFields,
                                                            fields,
                                                            language,
                                                            lastModifiedAt,
                                                            limit,
                                                            offset,
                                                            ordering,
                                                            path,
                                                            prompt,
                                                            readDepth,
                                                            search,
                                                            ssmlTags,
                                                            type,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                            content?: Array<string>,
                                                            createdAt?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            language?: Array<string>,
                                                            lastModifiedAt?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            path?: Array<string>,
                                                            prompt?: Array<string>,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            ssmlTags?: Array<string>,
                                                            type?: Array<string>,
                                                        }): CancelablePromise<PaginatedPromptContentViewList> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                                query: {
                                                                    'content': content,
                                                                    'created_at': createdAt,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'language': language,
                                                                    'last_modified_at': lastModifiedAt,
                                                                    'limit': limit,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'path': path,
                                                                    'prompt': prompt,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'ssml_tags': ssmlTags,
                                                                    'type': type,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PromptContentSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsPromptContentsCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            promptPk,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                            requestBody: PromptContentSerializerWithRepr,
                                                        }): CancelablePromise<PromptContentSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedPromptContentSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static promptContentBulkUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            promptPk,
                                                            requestBody,
                                                            content,
                                                            createdAt,
                                                            excludeFields,
                                                            fields,
                                                            language,
                                                            lastModifiedAt,
                                                            limit,
                                                            offset,
                                                            ordering,
                                                            path,
                                                            prompt,
                                                            readDepth,
                                                            search,
                                                            ssmlTags,
                                                            type,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                            requestBody: Array<PromptContentSerializerWithRepr>,
                                                            content?: Array<string>,
                                                            createdAt?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            language?: Array<string>,
                                                            lastModifiedAt?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            path?: Array<string>,
                                                            prompt?: Array<string>,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            ssmlTags?: Array<string>,
                                                            type?: Array<string>,
                                                        }): CancelablePromise<PaginatedPromptContentSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                                query: {
                                                                    'content': content,
                                                                    'created_at': createdAt,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'language': language,
                                                                    'last_modified_at': lastModifiedAt,
                                                                    'limit': limit,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'path': path,
                                                                    'prompt': prompt,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'ssml_tags': ssmlTags,
                                                                    'type': type,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedPromptContentSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static promptContentBulkPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            promptPk,
                                                            requestBody,
                                                            content,
                                                            createdAt,
                                                            excludeFields,
                                                            fields,
                                                            language,
                                                            lastModifiedAt,
                                                            limit,
                                                            offset,
                                                            ordering,
                                                            path,
                                                            prompt,
                                                            readDepth,
                                                            search,
                                                            ssmlTags,
                                                            type,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                            requestBody: Array<PromptContentSerializerWithRepr>,
                                                            content?: Array<string>,
                                                            createdAt?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            language?: Array<string>,
                                                            lastModifiedAt?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            path?: Array<string>,
                                                            prompt?: Array<string>,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            ssmlTags?: Array<string>,
                                                            type?: Array<string>,
                                                        }): CancelablePromise<PaginatedPromptContentSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                                query: {
                                                                    'content': content,
                                                                    'created_at': createdAt,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'language': language,
                                                                    'last_modified_at': lastModifiedAt,
                                                                    'limit': limit,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'path': path,
                                                                    'prompt': prompt,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'ssml_tags': ssmlTags,
                                                                    'type': type,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static promptContentBulkDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            promptPk,
                                                            id,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                            id?: Array<number>,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                                query: {
                                                                    'id': id,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PromptContentView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsPromptContentsRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            promptPk,
                                                            content,
                                                            createdAt,
                                                            excludeFields,
                                                            fields,
                                                            language,
                                                            lastModifiedAt,
                                                            path,
                                                            prompt,
                                                            readDepth,
                                                            ssmlTags,
                                                            type,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                            content?: Array<string>,
                                                            createdAt?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            language?: Array<string>,
                                                            lastModifiedAt?: Array<string>,
                                                            path?: Array<string>,
                                                            prompt?: Array<string>,
                                                            readDepth?: number,
                                                            ssmlTags?: Array<string>,
                                                            type?: Array<string>,
                                                        }): CancelablePromise<PromptContentView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                                query: {
                                                                    'content': content,
                                                                    'created_at': createdAt,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'language': language,
                                                                    'last_modified_at': lastModifiedAt,
                                                                    'path': path,
                                                                    'prompt': prompt,
                                                                    'read_depth': readDepth,
                                                                    'ssml_tags': ssmlTags,
                                                                    'type': type,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PromptContentSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsPromptContentsUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            promptPk,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                            requestBody: PromptContentSerializerWithRepr,
                                                        }): CancelablePromise<PromptContentSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PromptContentSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsPromptContentsPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            promptPk,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                            requestBody?: PatchedPromptContentSerializerWithRepr,
                                                        }): CancelablePromise<PromptContentSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsPromptContentsDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            promptPk,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsPromptContentsDeleteAudioDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            promptPk,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/{id}/delete_audio/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PromptContentView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsPromptContentsUploadAudioCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            promptPk,
                                                            formData,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this prompt content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            promptPk: number,
                                                            formData?: {
                                                                file?: Blob;
                                                            },
                                                        }): CancelablePromise<PromptContentView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/{prompt_pk}/prompt-contents/{id}/upload_audio/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'prompt_pk': promptPk,
                                                                },
                                                                formData: formData,
                                                                mediaType: 'multipart/form-data',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PromptView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsAutoRenameCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<PromptView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/auto_rename/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * Remove all prompts that are not used in any block or path in a flow_config.
                                                         * @returns PromptView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsRemoveUnusedPromptsCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<PromptView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/remove_unused_prompts/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SearchPromptResponse
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPromptsSearchRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            column,
                                                            exactMatch,
                                                            matchCase,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            column?: string,
                                                            exactMatch?: boolean,
                                                            matchCase?: boolean,
                                                            search?: string,
                                                        }): CancelablePromise<SearchPromptResponse> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/prompts/search/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'column': column,
                                                                    'exact_match': exactMatch,
                                                                    'match_case': matchCase,
                                                                    'search': search,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedSmallTalkListList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSmallTalksList({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            destinationBlock,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            prompt,
                                                            readDepth,
                                                            retries,
                                                            search,
                                                            status,
                                                            triggerOrIntent,
                                                            type,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            destinationBlock?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            prompt?: Array<string>,
                                                            readDepth?: number,
                                                            retries?: Array<string>,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            status?: Array<string>,
                                                            triggerOrIntent?: Array<string>,
                                                            type?: Array<string>,
                                                        }): CancelablePromise<PaginatedSmallTalkListList> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'destination_block': destinationBlock,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'prompt': prompt,
                                                                    'read_depth': readDepth,
                                                                    'retries': retries,
                                                                    'search': search,
                                                                    'status': status,
                                                                    'trigger_or_intent': triggerOrIntent,
                                                                    'type': type,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SmallTalkWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSmallTalksCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: SmallTalkWriteSerializerWithRepr,
                                                        }): CancelablePromise<SmallTalkWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedSmallTalkWriteSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static smallTalkBulkUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            destinationBlock,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            prompt,
                                                            readDepth,
                                                            retries,
                                                            search,
                                                            status,
                                                            triggerOrIntent,
                                                            type,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<SmallTalkWriteSerializerWithRepr>,
                                                            destinationBlock?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            prompt?: Array<string>,
                                                            readDepth?: number,
                                                            retries?: Array<string>,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            status?: Array<string>,
                                                            triggerOrIntent?: Array<string>,
                                                            type?: Array<string>,
                                                        }): CancelablePromise<PaginatedSmallTalkWriteSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'destination_block': destinationBlock,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'prompt': prompt,
                                                                    'read_depth': readDepth,
                                                                    'retries': retries,
                                                                    'search': search,
                                                                    'status': status,
                                                                    'trigger_or_intent': triggerOrIntent,
                                                                    'type': type,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedSmallTalkWriteSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static smallTalkBulkPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            destinationBlock,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            prompt,
                                                            readDepth,
                                                            retries,
                                                            search,
                                                            status,
                                                            triggerOrIntent,
                                                            type,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<SmallTalkWriteSerializerWithRepr>,
                                                            destinationBlock?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            prompt?: Array<string>,
                                                            readDepth?: number,
                                                            retries?: Array<string>,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            status?: Array<string>,
                                                            triggerOrIntent?: Array<string>,
                                                            type?: Array<string>,
                                                        }): CancelablePromise<PaginatedSmallTalkWriteSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'destination_block': destinationBlock,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'prompt': prompt,
                                                                    'read_depth': readDepth,
                                                                    'retries': retries,
                                                                    'search': search,
                                                                    'status': status,
                                                                    'trigger_or_intent': triggerOrIntent,
                                                                    'type': type,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static smallTalkBulkDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            id,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            id?: Array<number>,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'id': id,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SmallTalkRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSmallTalksRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            destinationBlock,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            name,
                                                            prompt,
                                                            readDepth,
                                                            retries,
                                                            status,
                                                            triggerOrIntent,
                                                            type,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this small talk.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            destinationBlock?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            name?: Array<string>,
                                                            prompt?: Array<string>,
                                                            readDepth?: number,
                                                            retries?: Array<string>,
                                                            status?: Array<string>,
                                                            triggerOrIntent?: Array<string>,
                                                            type?: Array<string>,
                                                        }): CancelablePromise<SmallTalkRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'destination_block': destinationBlock,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'name': name,
                                                                    'prompt': prompt,
                                                                    'read_depth': readDepth,
                                                                    'retries': retries,
                                                                    'status': status,
                                                                    'trigger_or_intent': triggerOrIntent,
                                                                    'type': type,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SmallTalkWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSmallTalksUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this small talk.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody: SmallTalkWriteSerializerWithRepr,
                                                        }): CancelablePromise<SmallTalkWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns SmallTalkWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSmallTalksPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this small talk.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody?: PatchedSmallTalkWriteSerializerWithRepr,
                                                        }): CancelablePromise<SmallTalkWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSmallTalksDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this small talk.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SmallTalkRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSmallTalksApplySmallTalksToBlocksRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<SmallTalkRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/apply_small_talks_to_blocks/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SmallTalkRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSmallTalksGetPredefinedPromptsRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<SmallTalkRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/small-talks/get_predefined_prompts/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedSubFlowViewList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsList({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            id,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            id?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                        }): CancelablePromise<PaginatedSubFlowViewList> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'id': id,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SubFlowSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: SubFlowSerializerWithRepr,
                                                        }): CancelablePromise<SubFlowSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedSubFlowSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static subFlowBulkUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            id,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<SubFlowSerializerWithRepr>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            id?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                        }): CancelablePromise<PaginatedSubFlowSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'id': id,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedSubFlowSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static subFlowBulkPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            id,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<SubFlowSerializerWithRepr>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            id?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                        }): CancelablePromise<PaginatedSubFlowSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'id': id,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static subFlowBulkDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            id,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            id?: Array<number>,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'id': id,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SubFlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            slug,
                                                            excludeFields,
                                                            fields,
                                                            name,
                                                            readDepth,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            slug: string,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            name?: Array<string>,
                                                            readDepth?: number,
                                                        }): CancelablePromise<SubFlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/{slug}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'slug': slug,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'name': name,
                                                                    'read_depth': readDepth,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SubFlowSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            slug,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            slug: string,
                                                            requestBody: SubFlowSerializerWithRepr,
                                                        }): CancelablePromise<SubFlowSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/{slug}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'slug': slug,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns SubFlowSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            slug,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            slug: string,
                                                            requestBody?: PatchedSubFlowSerializerWithRepr,
                                                        }): CancelablePromise<SubFlowSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/{slug}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'slug': slug,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            slug,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            slug: string,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/{slug}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'slug': slug,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * # Selected Blocks & Paths:
                                                         * # - Add entropy to block and prompts names
                                                         * # - Duplicate selected blocks, selected visible outbound paths, hidden paths for the selected blocks
                                                         * # - Prompts for blocks and paths to be duplicated
                                                         * # 1. Same flow config
                                                         * # - Entrypoint blocks must be duplicated as is
                                                         * # - Paths pointing to blocks outside of the subflow must be duplicated
                                                         * # 2. Different flow config
                                                         * # - Entrypoint blocks must be duplicated without the entrypoint_subflow field. However, the entrypoint_block field must be ignored if the block does not exist in the subflow.
                                                         * # - Paths pointing to blocks outside of the subflow must be duplicated without the destination_block field
                                                         * @returns PaginatedDuplicateResponseList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsDuplicateBlocksPathsCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            slug,
                                                            requestBody,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            id,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            slug: string,
                                                            requestBody: DuplicateBlockPath,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            id?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                        }): CancelablePromise<PaginatedDuplicateResponseList> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/{slug}/duplicate_blocks_paths/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'slug': slug,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'id': id,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns SubFlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsUndeleteRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            slug,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            id: number,
                                                            organisationUuid: string,
                                                            slug: string,
                                                        }): CancelablePromise<SubFlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/{slug}/undelete/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'slug': slug,
                                                                },
                                                                query: {
                                                                    'id': id,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SubFlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsConvertToSubflowCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: SubFlowView,
                                                        }): CancelablePromise<SubFlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/convert_to_subflow/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * # Subflow level:
                                                         * # - Duplicate all blocks & all outbound paths for these blocks (hidden and visible)
                                                         * # - Prompts for blocks and paths to be duplicated
                                                         * # 1. Same flow config
                                                         * # - Add entropy to block and prompts names
                                                         * # - Entrypoint blocks must be duplicated as is
                                                         * # - Paths pointing to blocks outside of the subflow must be duplicated
                                                         * # 2. Different flow config
                                                         * # - Entrypoint blocks must be duplicated without the entrypoint_subflow field. However, the entrypoint_block field must be ignored if the block does not exist in the subflow.
                                                         * # - Paths pointing to blocks outside of the subflow must be duplicated without the destination_block field
                                                         * @returns PaginatedDuplicateResponseList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsDuplicateCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            id,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: DuplicateSubFlow,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            id?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                        }): CancelablePromise<PaginatedDuplicateResponseList> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/duplicate/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'id': id,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns SubFlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSubFlowsReverseConvertToSubflowCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: SubFlowView,
                                                        }): CancelablePromise<SubFlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/sub-flows/reverse_convert_to_subflow/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * TTS Persona Related APIs
                                                         * @returns PaginatedTTSPersonaReadList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsTtsPersonaList({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            description,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            forDemo,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            primary,
                                                            readDepth,
                                                            search,
                                                            ssmlTags,
                                                            thumbnail,
                                                            ttsAgent,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            description?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            forDemo?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            primary?: Array<string>,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            ssmlTags?: Array<string>,
                                                            thumbnail?: Array<string>,
                                                            ttsAgent?: Array<string>,
                                                        }): CancelablePromise<PaginatedTTSPersonaReadList> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'description': description,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'for_demo': forDemo,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'primary': primary,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'ssml_tags': ssmlTags,
                                                                    'thumbnail': thumbnail,
                                                                    'tts_agent': ttsAgent,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * TTS Persona Related APIs
                                                         * @returns TTSPersonaWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsTtsPersonaCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody?: TTSPersonaWriteSerializerWithRepr,
                                                        }): CancelablePromise<TTSPersonaWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * TTS Persona Related APIs
                                                         * @returns PaginatedTTSPersonaWriteSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static ttsPersonaBulkUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            description,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            forDemo,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            primary,
                                                            readDepth,
                                                            search,
                                                            ssmlTags,
                                                            thumbnail,
                                                            ttsAgent,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<TTSPersonaWriteSerializerWithRepr>,
                                                            description?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            forDemo?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            primary?: Array<string>,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            ssmlTags?: Array<string>,
                                                            thumbnail?: Array<string>,
                                                            ttsAgent?: Array<string>,
                                                        }): CancelablePromise<PaginatedTTSPersonaWriteSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'description': description,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'for_demo': forDemo,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'primary': primary,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'ssml_tags': ssmlTags,
                                                                    'thumbnail': thumbnail,
                                                                    'tts_agent': ttsAgent,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * TTS Persona Related APIs
                                                         * @returns PaginatedTTSPersonaWriteSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static ttsPersonaBulkPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            description,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            forDemo,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            primary,
                                                            readDepth,
                                                            search,
                                                            ssmlTags,
                                                            thumbnail,
                                                            ttsAgent,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<TTSPersonaWriteSerializerWithRepr>,
                                                            description?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            forDemo?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            primary?: Array<string>,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            ssmlTags?: Array<string>,
                                                            thumbnail?: Array<string>,
                                                            ttsAgent?: Array<string>,
                                                        }): CancelablePromise<PaginatedTTSPersonaWriteSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'description': description,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'for_demo': forDemo,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'primary': primary,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'ssml_tags': ssmlTags,
                                                                    'thumbnail': thumbnail,
                                                                    'tts_agent': ttsAgent,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * TTS Persona Related APIs
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static ttsPersonaBulkDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            id,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            id?: Array<number>,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'id': id,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * TTS Persona Related APIs
                                                         * @returns TTSPersonaRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsTtsPersonaRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            description,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            forDemo,
                                                            name,
                                                            primary,
                                                            readDepth,
                                                            ssmlTags,
                                                            thumbnail,
                                                            ttsAgent,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this tts persona.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            description?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            forDemo?: Array<string>,
                                                            name?: Array<string>,
                                                            primary?: Array<string>,
                                                            readDepth?: number,
                                                            ssmlTags?: Array<string>,
                                                            thumbnail?: Array<string>,
                                                            ttsAgent?: Array<string>,
                                                        }): CancelablePromise<TTSPersonaRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'description': description,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'for_demo': forDemo,
                                                                    'name': name,
                                                                    'primary': primary,
                                                                    'read_depth': readDepth,
                                                                    'ssml_tags': ssmlTags,
                                                                    'thumbnail': thumbnail,
                                                                    'tts_agent': ttsAgent,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * TTS Persona Related APIs
                                                         * @returns TTSPersonaWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsTtsPersonaUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this tts persona.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody?: TTSPersonaWriteSerializerWithRepr,
                                                        }): CancelablePromise<TTSPersonaWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * TTS Persona Related APIs
                                                         * @returns TTSPersonaWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsTtsPersonaPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this tts persona.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody?: PatchedTTSPersonaWriteSerializerWithRepr,
                                                        }): CancelablePromise<TTSPersonaWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * TTS Persona Related APIs
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsTtsPersonaDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this tts persona.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * Updates the given TTS Persona as primary
                                                         * - Update Primary TTS
                                                         * - If template_type=Application
                                                         * Update Prompts
                                                         * @returns TTSPersonaRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsTtsPersonaMarkAsPrimaryCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this tts persona.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody?: TTSPersonaWrite,
                                                        }): CancelablePromise<TTSPersonaRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/tts_persona/{id}/mark_as_primary/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedUtteranceListList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesList({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                        }): CancelablePromise<PaginatedUtteranceListList> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns UtteranceWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: UtteranceWriteSerializerWithRepr,
                                                        }): CancelablePromise<UtteranceWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedUtteranceWriteSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static utteranceBulkUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<UtteranceWriteSerializerWithRepr>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                        }): CancelablePromise<PaginatedUtteranceWriteSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedUtteranceWriteSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static utteranceBulkPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            limit,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: Array<UtteranceWriteSerializerWithRepr>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                        }): CancelablePromise<PaginatedUtteranceWriteSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'limit': limit,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static utteranceBulkDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            id,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            id?: Array<number>,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'id': id,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns UtteranceRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            excludeFields,
                                                            fields,
                                                            flowConfig,
                                                            name,
                                                            readDepth,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this utterance.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            flowConfig?: Array<string>,
                                                            name?: Array<string>,
                                                            readDepth?: number,
                                                        }): CancelablePromise<UtteranceRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'flow_config': flowConfig,
                                                                    'name': name,
                                                                    'read_depth': readDepth,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns UtteranceWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this utterance.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody: UtteranceWriteSerializerWithRepr,
                                                        }): CancelablePromise<UtteranceWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns UtteranceWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this utterance.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody?: PatchedUtteranceWriteSerializerWithRepr,
                                                        }): CancelablePromise<UtteranceWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this utterance.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedUtterancesContentListList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesContentsList({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            utterancePk,
                                                            excludeFields,
                                                            fields,
                                                            language,
                                                            limit,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                            utterance,
                                                            utterances,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            utterancePk: number,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            language?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            utterance?: Array<string>,
                                                            utterances?: Array<string>,
                                                        }): CancelablePromise<PaginatedUtterancesContentListList> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{utterance_pk}/contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'utterance_pk': utterancePk,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'language': language,
                                                                    'limit': limit,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'utterance': utterance,
                                                                    'utterances': utterances,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns UtterancesContentWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesContentsCreate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            utterancePk,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            utterancePk: number,
                                                            requestBody: UtterancesContentWriteSerializerWithRepr,
                                                        }): CancelablePromise<UtterancesContentWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{utterance_pk}/contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'utterance_pk': utterancePk,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedUtterancesContentWriteSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static utterancesContentBulkUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            utterancePk,
                                                            requestBody,
                                                            excludeFields,
                                                            fields,
                                                            language,
                                                            limit,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                            utterance,
                                                            utterances,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            utterancePk: number,
                                                            requestBody: Array<UtterancesContentWriteSerializerWithRepr>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            language?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            utterance?: Array<string>,
                                                            utterances?: Array<string>,
                                                        }): CancelablePromise<PaginatedUtterancesContentWriteSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{utterance_pk}/contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'utterance_pk': utterancePk,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'language': language,
                                                                    'limit': limit,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'utterance': utterance,
                                                                    'utterances': utterances,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedUtterancesContentWriteSerializerWithReprList
                                                         * @throws ApiError
                                                         */
                                                        public static utterancesContentBulkPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            utterancePk,
                                                            requestBody,
                                                            excludeFields,
                                                            fields,
                                                            language,
                                                            limit,
                                                            offset,
                                                            ordering,
                                                            readDepth,
                                                            search,
                                                            utterance,
                                                            utterances,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            utterancePk: number,
                                                            requestBody: Array<UtterancesContentWriteSerializerWithRepr>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            language?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            utterance?: Array<string>,
                                                            utterances?: Array<string>,
                                                        }): CancelablePromise<PaginatedUtterancesContentWriteSerializerWithReprList> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{utterance_pk}/contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'utterance_pk': utterancePk,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'language': language,
                                                                    'limit': limit,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'utterance': utterance,
                                                                    'utterances': utterances,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static utterancesContentBulkDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            organisationUuid,
                                                            utterancePk,
                                                            id,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            utterancePk: number,
                                                            id?: Array<number>,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{utterance_pk}/contents/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'utterance_pk': utterancePk,
                                                                },
                                                                query: {
                                                                    'id': id,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns UtterancesContentRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesContentsRetrieve({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            utterancePk,
                                                            excludeFields,
                                                            fields,
                                                            language,
                                                            readDepth,
                                                            utterance,
                                                            utterances,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this utterances content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            utterancePk: number,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            language?: Array<string>,
                                                            readDepth?: number,
                                                            utterance?: Array<string>,
                                                            utterances?: Array<string>,
                                                        }): CancelablePromise<UtterancesContentRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{utterance_pk}/contents/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'utterance_pk': utterancePk,
                                                                },
                                                                query: {
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'language': language,
                                                                    'read_depth': readDepth,
                                                                    'utterance': utterance,
                                                                    'utterances': utterances,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns UtterancesContentWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesContentsUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            utterancePk,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this utterances content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            utterancePk: number,
                                                            requestBody: UtterancesContentWriteSerializerWithRepr,
                                                        }): CancelablePromise<UtterancesContentWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{utterance_pk}/contents/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'utterance_pk': utterancePk,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns UtterancesContentWriteSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesContentsPartialUpdate({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            utterancePk,
                                                            requestBody,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this utterances content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            utterancePk: number,
                                                            requestBody?: PatchedUtterancesContentWriteSerializerWithRepr,
                                                        }): CancelablePromise<UtterancesContentWriteSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{utterance_pk}/contents/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'utterance_pk': utterancePk,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUserUtterancesContentsDestroy({
                                                            flowConfigVersion,
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                            utterancePk,
                                                        }: {
                                                            flowConfigVersion: string,
                                                            flowUuid: string,
                                                            /**
                                                             * A unique integer value identifying this utterances content.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            utterancePk: number,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{flow_config_version}/user-utterances/{utterance_pk}/contents/{id}/',
                                                                path: {
                                                                    'flow_config_version': flowConfigVersion,
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'utterance_pk': utterancePk,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigUpdate
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUpdate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                            requestBody?: FlowConfigUpdate,
                                                        }): CancelablePromise<FlowConfigUpdate> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigUpdate
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsPartialUpdate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                            requestBody?: PatchedFlowConfigUpdate,
                                                        }): CancelablePromise<FlowConfigUpdate> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsDestroy({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsCommentsRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/comments/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns DeployResponseSerialzier
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsDeployCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                            requestBody: DeployRequest,
                                                        }): CancelablePromise<DeployResponseSerialzier> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/deploy/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsEvaluateImportedYamlRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                            importedClientUuid,
                                                            importedFlowUuid,
                                                            importedFlowVersion,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                            importedClientUuid?: string,
                                                            importedFlowUuid?: string,
                                                            importedFlowVersion?: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/evaluate_imported_yaml/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                                query: {
                                                                    'imported_client_uuid': importedClientUuid,
                                                                    'imported_flow_uuid': importedFlowUuid,
                                                                    'imported_flow_version': importedFlowVersion,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsFetchApplicationParametersRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                            namespace,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                            namespace?: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/fetch_application_parameters/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                                query: {
                                                                    'namespace': namespace,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsGenerateUseCasesCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                            requestBody: GenerateUseCase,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/generate_use_cases/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsGenerateYamlRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/generate_yaml/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns AsyncTaskResponse
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsGenerateYamlAsyncRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<AsyncTaskResponse> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/generate_yaml_async/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsGetIntentsTriggersRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/get_intents_triggers/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsImportFlowFromFsmCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                            requestBody: ImportFlow,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/import_flow_from_fsm/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsMigrateToTtsPersonaCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/migrate_to_tts_persona/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * Refreshes account attributes for a given Flow Config
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsRefreshAccountAttributesRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/refresh_account_attributes/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsRefreshBusinessAttributesRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/refresh_business_attributes/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsRefreshTemplateParametersRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/refresh_template_parameters/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsSaveYamlUpdate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                            requestBody: FlowYaml,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/save_yaml/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsUpdateTemplateParameterValuesUpdate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                            requestBody: FlowConfigView,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/update_template_parameter_values/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsValidateRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/validate/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns AsyncTaskResponse
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsValidateAsyncRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                            version,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            version: string,
                                                        }): CancelablePromise<AsyncTaskResponse> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/{version}/validate_async/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                    'version': version,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * # - Duplicate a flow_config
                                                         * Target flow in the same org:
                                                         * 1. Create the flow config using the version type provided in the target flow (Don't duplicate reverse relations for flow configs) (1 main db query + m2m queries)
                                                         * 2. Duplicate all prompts for the flow config and create an old/new map (2 db queries)
                                                         * 3. Duplicate all subflows and create an old/new map (1 db query)
                                                         * 4. Duplicate all blocks (without entrypoint_subflow field) and use the prompts & subflows maps. Update the duplicated blocks' entrypoint_subflow field.
                                                         * 5. Duplicate entities
                                                         * 6. Duplicate all paths and use the prompts & subflows maps
                                                         * @returns FlowConfigView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsDuplicateCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: DuplicateFlowConfig,
                                                        }): CancelablePromise<FlowConfigView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/duplicate/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * # - Duplicate a flow_config async
                                                         * Target flow in the same org:
                                                         * 1. Create the flow config using the version type provided in the target flow (Don't duplicate reverse relations for flow configs) (1 main db query + m2m queries)
                                                         * 2. Duplicate all prompts for the flow config and create an old/new map (2 db queries)
                                                         * 3. Duplicate all subflows and create an old/new map (1 db query)
                                                         * 4. Duplicate all blocks (without entrypoint_subflow field) and use the prompts & subflows maps. Update the duplicated blocks' entrypoint_subflow field.
                                                         * 5. Duplicate entities
                                                         * 6. Duplicate all paths and use the prompts & subflows maps
                                                         * @returns AsyncTaskResponse
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVersionsDuplicateAsyncCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: DuplicateFlowConfig,
                                                        }): CancelablePromise<AsyncTaskResponse> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/versions/duplicate_async/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersRetrieve2({
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            flowUuid: string,
                                                            id: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/{id}/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersUpdate({
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            flowUuid: string,
                                                            id: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/{id}/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersPartialUpdate({
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            flowUuid: string,
                                                            id: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/{id}/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersDestroy({
                                                            flowUuid,
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            flowUuid: string,
                                                            id: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/{id}/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersAssignCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: VirtualNumberRequest,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/assign/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns VirtualNumberListResponse
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersAssignedList({
                                                            flowUuid,
                                                            organisationUuid,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<Array<VirtualNumberListResponse>> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/assigned/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersAvailableVirtualNumbersRetrieve({
                                                            flowUuid,
                                                            organisationUuid,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/available_virtual_numbers/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersBulkAssignCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody?: BulkAssignVirtualNumberRequest,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/bulk_assign/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * Change the virtual number associated with a flow.
                                                         *
                                                         * Args:
                                                         * request (Request): The HTTP request object containing the data for changing the virtual number.
                                                         * *args: Additional arguments passed to the method.
                                                         * **kwargs: Additional keyword arguments passed to the method.
                                                         *
                                                         * Returns:
                                                         * Response: A response with a success message if the virtual number change is successful.
                                                         *
                                                         * Raises:
                                                         * APIException: If the flow object is not found.
                                                         * # APIException: If the campaign linked to the flow is live.
                                                         * APIException: If an exception occurs during the number change in the FSM.
                                                         * APIException: If an exception occurs during the update of the virtual number in the OCM campaign.
                                                         * APIException: If an exception occurs during the revert of the number change in the FSM.
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersChangeNumberUpdate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: ChangeNumberRequest,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/change_number/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersPartialUpdateNumberPartialUpdate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody?: PatchedPartialUpdateNumberRequest,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/partial_update_number/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * Endpoint to un assign a virtual number with flow_uuid in FSM
                                                         *
                                                         * :request: VirtualNumberRequest
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsVirtualNumbersUnassignCreate({
                                                            flowUuid,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            flowUuid: string,
                                                            organisationUuid: string,
                                                            requestBody: VirtualNumberRequest,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{flow_uuid}/virtual-numbers/unassign/',
                                                                path: {
                                                                    'flow_uuid': flowUuid,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsRetrieve({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsUpdate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: FlowSerializerWithRepr,
                                                        }): CancelablePromise<FlowSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowSerializerWithRepr
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsPartialUpdate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody?: PatchedFlowSerializerWithRepr,
                                                        }): CancelablePromise<FlowSerializerWithRepr> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsDestroy({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsArchiveUpdate({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/archive/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsCallWithParametersCreate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: CallWithParametersRequest,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/call_with_parameters/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsDocumentationRetrieve({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/documentation/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsFetchCallCreate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                            ssmlRedact,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: FetchCallRequest,
                                                            ssmlRedact?: boolean,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/fetch_call/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                query: {
                                                                    'ssml_redact': ssmlRedact,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns ApplicationFlowCount
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsGetApplicationsFlowsCountRetrieve({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<ApplicationFlowCount> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/get_applications_flows_count/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigApiSpecs
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsGetFlowApiSpecsRetrieve({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<FlowConfigApiSpecs> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/get_flow_api_specs/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsMarkFlowAsBetaUpdate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: MarkFlowAsBeta,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/mark_flow_as_beta/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsTriggerCallCreate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: TriggerCallRequest,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/trigger_call/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsUnarchiveUpdate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: UnarchiveFlowRequest,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/unarchive/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowConfigApiSpecs
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsUpdateFlowApiSpecsUpdate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: FlowConfigApiSpecs,
                                                        }): CancelablePromise<FlowConfigApiSpecs> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/flows/{uuid}/update_flow_api_specs/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsCreateGlobalTemplateCreate({
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            requestBody: FlowView,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/flows/create_global_template/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns FlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsFlowsGlobalTemplatesRetrieve({
                                                            organisationUuid,
                                                        }: {
                                                            organisationUuid: string,
                                                        }): CancelablePromise<FlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/flows/global_templates/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns GetAssosiatedFlowCountResponse
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsGetAssosiatedFlowsCountRetrieve({
                                                            organisationUuid,
                                                        }: {
                                                            organisationUuid: string,
                                                        }): CancelablePromise<GetAssosiatedFlowCountResponse> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/get_assosiated_flows_count/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns FolderFileMap
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsGetCampaignFilesRetrieve({
                                                            organisationUuid,
                                                        }: {
                                                            organisationUuid: string,
                                                        }): CancelablePromise<FolderFileMap> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/get_campaign_files/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedPaymentConnectorsSerializersList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsGetClientPaymentConnectorsList({
                                                            organisationUuid,
                                                            agencyDetail,
                                                            campaignUuid,
                                                            clientBillingId,
                                                            createdBy,
                                                            dashboards,
                                                            dataKey,
                                                            demoConfig,
                                                            description,
                                                            displayName,
                                                            enableIpWhitelisting,
                                                            excludeFields,
                                                            fields,
                                                            ftpBucket,
                                                            industrySegmentType,
                                                            limit,
                                                            metadata,
                                                            name,
                                                            offset,
                                                            ordering,
                                                            paymentPortalDetail,
                                                            readDepth,
                                                            search,
                                                            status,
                                                            uuid,
                                                            whitelistedIpAddress,
                                                        }: {
                                                            organisationUuid: string,
                                                            agencyDetail?: Array<string>,
                                                            campaignUuid?: Array<string>,
                                                            clientBillingId?: Array<string>,
                                                            createdBy?: Array<string>,
                                                            dashboards?: Array<string>,
                                                            dataKey?: Array<string>,
                                                            demoConfig?: Array<string>,
                                                            description?: Array<string>,
                                                            displayName?: Array<string>,
                                                            enableIpWhitelisting?: Array<string>,
                                                            excludeFields?: Array<string>,
                                                            fields?: Array<string>,
                                                            ftpBucket?: Array<string>,
                                                            industrySegmentType?: Array<string>,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            metadata?: Array<string>,
                                                            name?: Array<string>,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            offset?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            paymentPortalDetail?: Array<string>,
                                                            readDepth?: number,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            status?: Array<string>,
                                                            uuid?: Array<string>,
                                                            whitelistedIpAddress?: Array<string>,
                                                        }): CancelablePromise<PaginatedPaymentConnectorsSerializersList> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/get_client_payment_connectors/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'agency_detail': agencyDetail,
                                                                    'campaign_uuid': campaignUuid,
                                                                    'client_billing_id': clientBillingId,
                                                                    'created_by': createdBy,
                                                                    'dashboards': dashboards,
                                                                    'data_key': dataKey,
                                                                    'demo_config': demoConfig,
                                                                    'description': description,
                                                                    'display_name': displayName,
                                                                    'enable_ip_whitelisting': enableIpWhitelisting,
                                                                    'exclude-fields': excludeFields,
                                                                    'fields': fields,
                                                                    'ftp_bucket': ftpBucket,
                                                                    'industry_segment_type': industrySegmentType,
                                                                    'limit': limit,
                                                                    'metadata': metadata,
                                                                    'name': name,
                                                                    'offset': offset,
                                                                    'ordering': ordering,
                                                                    'payment_portal_detail': paymentPortalDetail,
                                                                    'read_depth': readDepth,
                                                                    'search': search,
                                                                    'status': status,
                                                                    'uuid': uuid,
                                                                    'whitelisted_ip_address': whitelistedIpAddress,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns PaginatedRolesList
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsRolesList({
                                                            organisationUuid,
                                                            limit,
                                                            ordering,
                                                            search,
                                                            start,
                                                        }: {
                                                            organisationUuid: string,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            limit?: number,
                                                            /**
                                                             * Which field to use when ordering the results.
                                                             */
                                                            ordering?: string,
                                                            /**
                                                             * A search term.
                                                             */
                                                            search?: string,
                                                            /**
                                                             * The initial index from which to return the results.
                                                             */
                                                            start?: number,
                                                        }): CancelablePromise<PaginatedRolesList> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/roles/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'limit': limit,
                                                                    'ordering': ordering,
                                                                    'search': search,
                                                                    'start': start,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns Roles
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsRolesCreate({
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            requestBody: Roles,
                                                        }): CancelablePromise<Roles> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/roles/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns Roles
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsRolesRetrieve({
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            /**
                                                             * A unique integer value identifying this role.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<Roles> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/roles/{id}/',
                                                                path: {
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns Roles
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsRolesUpdate({
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            /**
                                                             * A unique integer value identifying this role.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody: Roles,
                                                        }): CancelablePromise<Roles> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/roles/{id}/',
                                                                path: {
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns Roles
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsRolesPartialUpdate({
                                                            id,
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            /**
                                                             * A unique integer value identifying this role.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                            requestBody?: PatchedRoles,
                                                        }): CancelablePromise<Roles> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/roles/{id}/',
                                                                path: {
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns void
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsRolesDestroy({
                                                            id,
                                                            organisationUuid,
                                                        }: {
                                                            /**
                                                             * A unique integer value identifying this role.
                                                             */
                                                            id: number,
                                                            organisationUuid: string,
                                                        }): CancelablePromise<void> {
                                                            return __request(OpenAPI, {
                                                                method: 'DELETE',
                                                                url: '/api/organisations/{organisation_uuid}/roles/{id}/',
                                                                path: {
                                                                    'id': id,
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SmsFlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsList({
                                                            organisationUuid,
                                                            templateType,
                                                            status,
                                                        }: {
                                                            organisationUuid: string,
                                                            templateType: any,
                                                            status?: string,
                                                        }): CancelablePromise<Array<SmsFlowView>> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'status': status,
                                                                    'template_type': templateType,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns SmsFlowView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsCreate({
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            requestBody: SmsFlowCreateRequest,
                                                        }): CancelablePromise<SmsFlowView> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns SmsRetrieve
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsRetrieve({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<SmsRetrieve> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsAssignVirtualNumbersCreate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: AssignVirtualNumbers,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/assign_virtual_numbers/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsCreateOrUpdatePromptCreate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: PromptCreateOrUpdate,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/create_or_update_prompt/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns GetAttributesResponse
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsGetAttributesListRetrieve({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<GetAttributesResponse> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/get_attributes_list/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsGetScriptPromptsRetrieve({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<Record<string, any>> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/get_script_prompts/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns InteractionWithMessages
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsInteractionMessagesRetrieve({
                                                            organisationUuid,
                                                            uuid,
                                                            interactionUuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            /**
                                                             * Interaction uuid
                                                             */
                                                            interactionUuid?: string,
                                                        }): CancelablePromise<InteractionWithMessages> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/interaction_messages/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                query: {
                                                                    'interaction_uuid': interactionUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * List all interactions for a specific UUID with optional search and filters
                                                         * @returns InteractionPaginated
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsInteractionsRetrieve({
                                                            organisationUuid,
                                                            uuid,
                                                            endDate,
                                                            page,
                                                            pageSize,
                                                            responseStatus,
                                                            search,
                                                            startDate,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            /**
                                                             * Filter by end date (ISO 8601 format)
                                                             */
                                                            endDate?: string,
                                                            /**
                                                             * A page number within the paginated result set.
                                                             */
                                                            page?: number,
                                                            /**
                                                             * Number of results to return per page.
                                                             */
                                                            pageSize?: number,
                                                            /**
                                                             * Filter by response status
                                                             */
                                                            responseStatus?: 'all' | 'with_response' | 'without_response',
                                                            /**
                                                             * Contact number for search
                                                             */
                                                            search?: string,
                                                            /**
                                                             * Filter by start date (ISO 8601 format)
                                                             */
                                                            startDate?: string,
                                                        }): CancelablePromise<InteractionPaginated> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/interactions/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                query: {
                                                                    'end_date': endDate,
                                                                    'page': page,
                                                                    'page_size': pageSize,
                                                                    'response_status': responseStatus,
                                                                    'search': search,
                                                                    'start_date': startDate,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsSaveSmsAgentPartialUpdate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody?: PatchedSaveSmsAgentRequest,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'PATCH',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/save_sms_agent/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsSendEmailMessageCreate({
                                                            organisationUuid,
                                                            uuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                            requestBody: QueueEmailMessage,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/send_email_message/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsUnassignAllVirtualNumbersCreate({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/unassign_all_virtual_numbers/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns VirtualNumbersView
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsVirtualNumbersList({
                                                            organisationUuid,
                                                            uuid,
                                                        }: {
                                                            organisationUuid: string,
                                                            uuid: string,
                                                        }): CancelablePromise<Array<VirtualNumbersView>> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/{uuid}/virtual_numbers/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                    'uuid': uuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsEndChatCreate({
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            requestBody: EndChatRequest,
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/end_chat/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns ChatResponse
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsInitiateChatCreate({
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            requestBody: InitialiseChatRequest,
                                                        }): CancelablePromise<ChatResponse> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/initiate_chat/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns ChatResponse
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsSmsFlowsRespondToChatCreate({
                                                            organisationUuid,
                                                            requestBody,
                                                        }: {
                                                            organisationUuid: string,
                                                            requestBody: RespondToChatRequest,
                                                        }): CancelablePromise<ChatResponse> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/sms-flows/respond_to_chat/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                body: requestBody,
                                                                mediaType: 'application/json',
                                                            });
                                                        }
                                                        /**
                                                         * @returns OrganisationRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsUnarchiveUpdate({
                                                            organisationUuid,
                                                        }: {
                                                            organisationUuid: string,
                                                        }): CancelablePromise<OrganisationRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'PUT',
                                                                url: '/api/organisations/{organisation_uuid}/unarchive/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                            });
                                                        }
                                                        /**
                                                         * @returns any No response body
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsUploadMediaCreate({
                                                            organisationUuid,
                                                            type = 'logo',
                                                            formData,
                                                        }: {
                                                            organisationUuid: string,
                                                            type?: 'logo',
                                                            formData?: {
                                                                /**
                                                                 * Media file for organisation. can be logo, report etc.
                                                                 */
                                                                file?: Blob;
                                                            },
                                                        }): CancelablePromise<any> {
                                                            return __request(OpenAPI, {
                                                                method: 'POST',
                                                                url: '/api/organisations/{organisation_uuid}/upload_media/',
                                                                path: {
                                                                    'organisation_uuid': organisationUuid,
                                                                },
                                                                query: {
                                                                    'type': type,
                                                                },
                                                                formData: formData,
                                                                mediaType: 'multipart/form-data',
                                                            });
                                                        }
                                                        /**
                                                         * Return Demo Client UUID for experience center
                                                         * @returns OrganisationRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsDemoClientUuidRetrieve(): CancelablePromise<OrganisationRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/demo_client_uuid/',
                                                            });
                                                        }
                                                        /**
                                                         * Return Demo Flow UUID for experience center
                                                         * @returns OrganisationRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsDemoFlowUuidRetrieve(): CancelablePromise<OrganisationRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/demo_flow_uuid/',
                                                            });
                                                        }
                                                        /**
                                                         * Fetches a list of organisations or flows,
                                                         * by passing a query string
                                                         * @returns OrganisationRead
                                                         * @throws ApiError
                                                         */
                                                        public static organisationsGetOrganisationsAndFlowsRetrieve({
                                                            search,
                                                        }: {
                                                            search?: string,
                                                        }): CancelablePromise<OrganisationRead> {
                                                            return __request(OpenAPI, {
                                                                method: 'GET',
                                                                url: '/api/organisations/get_organisations_and_flows/',
                                                                query: {
                                                                    'search': search,
                                                                },
                                                            });
                                                        }
                                                    }
